{
  "copy": {
    "viewport.web.auto.random": "Tüm kartlar",
    "viewport.web.auto.favorites": "Favorilerim",
    "viewport.web.auto.unplayed": "Almadıklarım",
    "viewport.web.auto.mode": "Kartları nereden seçelim?",
    "viewport.web.auto.help": "Kart grubunu & adetlerini seç ve satın alma adımına geç!",
    "viewport.web.auto.liveHelp": "Kart grubunu & adetlerini seç ve satın alma adımına geç!",
    "viewport.web.auto.available": "Adedi seç veya yaz. En fazla {max} kart seçebilirsin.",
    "viewport.web.room.goNext": "Sıradaki Çekilişe Geç",
    "viewport.web.desktop.noWinResult": "Bu çekilişte ikramiye kazanamadın. Kartlarının son durumunu aşağıda görebilirsin.",
    "design.cta.enabled": "Vurguyu etkinleştir",
    "design.cta.notifications": "Bilgi, Başarı, Uyarı ve Hata → Bildirim Yönetimi",
    "design.cta.where.sales": "Satış ekranının CTA zemini. Sonraki çekilişin kataloğunda geri dönüş düğmesi açılışta iki kez vurgulanır. Hızlı seçim ve satın alma düğmeleri parlamaz.",
    "design.cta.where.preparing": "Satış kapandıktan sonra ilk top beklenirken CTA zemini. Oyuncudan eylem beklenmediği için düğme vurgusu çalışmaz.",
    "design.cta.where.one-line": "1. Çinko sırasında sonraki çekilişe geçiş veya seçime devam düğmesi kullanılabiliyorsa iki kez vurgulanır. Sonraki toplarda tekrarlanmaz.",
    "design.cta.where.two-lines": "2. Çinko sırasında kullanılabilir geçiş düğmesi iki kez vurgulanır; sayaç güncellemelerinde tekrarlanmaz.",
    "design.cta.where.full-house": "Tombala sırasında kullanılabilir geçiş düğmesi iki kez vurgulanır; sayaç güncellemelerinde tekrarlanmaz.",
    "design.cta.where.award": "Sunucunun ödül arası boyunca CTA zemini. Kutlamaya rakip bir düğme parlaması gösterilmez; ara süresi değişmez.",
    "design.cta.where.completed": "Oyuncu son kartlarını incelerken sonraki veya canlı çekilişe geçiş düğmesi aralıklı vurgulanır. Oyuncuyu otomatik taşımaz; etkileşimde durur.",
    "design.cta.where.cancelled": "İptal edilen çekiliş ekranda tutulurken kullanılabilir sonraki çekiliş düğmesi aralıklı vurgulanır. İptal ve iade bilgisini değiştirmez.",
    "design.cta.title": "CTA ve geçişler",
    "design.cta.help": "Aşama rengini ve geçiş düğmesinin vurgusunu ayrı ayarlayabilirsin. Düğme iki kez yumuşakça parlar. Sonuçta sonraki çekilişe geçiş bekleniyorsa altı parlama süresi dinlenip tekrarlar; düğmeye dokununca veya odaklanınca durur. Sayaç ve top güncellemeleri vurguyu yeniden başlatmaz. Ödeme, sunucuyu bekleme ve ödül arasında parlama yoktur. Hareketi azalt tercihi dikkate alınır.",
    "design.cta.next": "Sonraki çekiliş düğmesi",
    "design.cta.secondary": "İkincil düğme zemini",
    "design.cta.background": "Panel zemini",
    "design.cta.blink": "Blink açık",
    "design.cta.duration": "Bir parlama süresi (ms)",
    "design.cta.phase.sales": "Kart seçimi / satış açık",
    "design.cta.phase.preparing": "Satış kapandı / çekiliş hazırlanıyor",
    "design.cta.phase.one-line": "1. Çinko çekiliyor",
    "design.cta.phase.two-lines": "2. Çinko çekiliyor",
    "design.cta.phase.full-house": "Tombala çekiliyor",
    "design.cta.phase.award": "İkramiye açıklandı / kısa ara",
    "design.cta.phase.completed": "Oyun bitti / sonraki çekiliş",
    "design.cta.phase.cancelled": "Çekiliş iptal edildi",
    "desktop.fullscreen": "Tam ekran",
    "desktop.exitFullscreen": "Tam ekrandan çık",
    "desktop.fullscreenUnavailable": "Bu pencerede tam ekran açılamıyor",
    "desktop.stages": "Çekilişin aşamaları",
    "desktop.stage.done": "Tamamlandı",
    "desktop.stage.active": "Çekiliyor",
    "desktop.stage.waiting": "Sırada",
    "desktop.stage.closed": "Kapandı",
    "desktop.stageDrawing": "{stage} çekiliyor",
    "desktop.stageFinished": "{stage} tamamlandı",
    "desktop.paused": "Çekiliş duraklatıldı",
    "desktop.prizeMultiple": "KATI",
    "desktop.numberLast": "Son çekilen top: {number}",
    "desktop.numberCalled": "{number} çekildi",
    "desktop.numberWaiting": "{number} henüz çekilmedi",
    "desktop.called": "Çekilen",
    "desktop.nextSelection": "Sonraki çekiliş için kart seçimi",
    "desktop.liveDraw": "Canlı çekiliş",
    "desktop.selection": "Kartlarını seç, oyuna katıl",
    "desktop.purchaseContext": "Seçtiğin kartlar sonraki çekiliş içindir. Satın almadan önce tutarı ve toplamı kontrol et.",
    "desktop.observerResult": "Bu çekilişi izleyici olarak takip ettin.",
    "desktop.wonResult": "Bu çekilişte kazandın. Kazancını ve kartlarının son durumunu aşağıda görebilirsin.",
    "desktop.noWinResult": "Bu çekilişte ikramiye kazanamadın. Kartlarının son durumu aşağıda.",
    "desktop.liveHelp": "Kartların çıkan toplarla otomatik işaretlenir. Sonraki çekilişe alım alttaki alandan yapılır.",
    "desktop.preparingHelp": "Kart alımı kapandı. Çekilişin başlaması bekleniyor.",
    "desktop.nextHelp": "Bu çekiliş satışa açık. Satış bitiş sayacı mevcut çekiliş tamamlandığında başlayacak.",
    "desktop.selectionHelp": "Kartlarını tek tek veya Hızlı Kart Seç ile belirle; satın almadan önce tutarını kontrol et.",
    "desktop.followCurrent": "Güncel oyuna geç",
    "desktop.manualSelection": "Kartları Seç",
    "desktop.nextOwned": "Sonraki çekilişte {count} kartın var",
    "desktop.nextEmpty": "Henüz kart almadın",
    "desktop.cardOrder": "Kart sırası",
    "desktop.orderNumber": "Kart numarası · sabit",
    "desktop.orderNearest": "Kazanmaya en yakın",
    "desktop.nearestCards": "En İyi Kartlar",
    "card.add": "Tutar ekle",
    "card.win": "✦ Güzel haber! Kartın kazandı.",
    "room.all": "Tümü",
    "x.jpBase": "JP başlangıç tutarı",
    "auto.help": "Kart grubunu & adetlerini seç ve satın alma adımına geç!",
    "auto.mode": "Kartları nereden seçelim?",
    "auto.unit": "Adet",
    "cards.all": "Tüm kartlar",
    "nav.games": "Oyunlar",
    "play.next": "Sıradaki ödül",
    "room.help": "Nasıl oynanır?",
    "room.live": "Canlı çekiliş",
    "room.menu": "Oyun menüsü",
    "room.signOut": "Çıkış yap",
    "room.pool": "Toplam havuz",
    "admin.edit": "Ayarları düzenle",
    "admin.time": "Kayıt zamanı",
    "auto.apply": "Kartları seç",
    "auto.count": "Kart Adedi Seçimi",
    "auto.empty": "Bu koşullarda seçilebilecek kart yok.",
    "auto.least": "Az seçilen kartlar",
    "auto.range": "En az 1, en fazla {max} kart seçebilirsin.",
    "auto.title": "Hızlı Kart Seç",
    "award.draw": "Çekiliş #{draw}",
    "brand.full": "90 STUDIO",
    "brand.home": "90 Studio ana sayfa",
    "brand.word": "studio",
    "card.added": "Kartına {amount} eklendi.",
    "card.label": "KART",
    "card.owned": "SENİN KARTIN",
    "card.total": "Karttaki toplam",
    "cards.auto": "Otomatik seç",
    "cards.help": "Kartlarını seç, tutarını belirle ve kontrol ederek onayla.",
    "cards.mine": "Kartlarım",
    "cards.next": "Sonraki kartlar",
    "cards.sort": "Kart sırası",
    "cta.expand": "Alt paneli aç",
    "design.ink": "Ana metin",
    "play.cards": "Kart seç",
    "play.title": "Kartlarını seç. Anı yakala.",
    "prize.done": "Sonuçlandı",
    "prize.pool": "Ödül havuzu",
    "room.cards": "Tüm Kartlar",
    "room.draws": "Çekilişler",
    "room.myWin": "Kazandığım",
    "room.quick": "Hızlı Seç",
    "room.title": "Canlı Tombala",
    "room.watch": "Çekilişi izle",
    "round.done": "Bu turun sonuçları hazır",
    "round.live": "Gözler stüdyoda",
    "round.open": "Kartlarını seç, yerini al",
    "stage.done": "ÇEKİLİŞ TAMAMLANDI",
    "stage.live": "SANAL STÜDYO",
    "stage.mute": "Sunucu sesini kapat",
    "stage.open": "Seçimler açık",
    "stage.pool": "TOPLAM HAVUZ",
    "studio.new": "Yeni prova aç",
    "x.winLabel": "misli kazan",
    "admin.actor": "İşlemi yapan",
    "admin.after": "Taslak değer",
    "admin.balls": "İşlenmiş toplar",
    "admin.bound": "Satışa açılmış çekilişler",
    "admin.brand": "GameAdmin",
    "admin.cards": "Farklı aktif kart",
    "admin.draft": "Kaydedilmiş taslak",
    "admin.saved": "Taslak kaydedildi. Oyun ayarları henüz değişmedi.",
    "admin.stage": "Aşama",
    "admin.title": "Oyun yönetimi",
    "auto.random": "Tüm kartlar",
    "auto.unsold": "Hiç tutar eklenmemiş kartlar",
    "card.marked": "Çekildi",
    "card.select": "SATIN AL",
    "cards.empty": "Henüz bir kart seçmedin. Tüm kartlardan kendine bir yer aç.",
    "cards.title": "Şansına yer aç.",
    "design.copy": "Ekran metinleri",
    "design.gold": "Vurgu rengi",
    "design.room": "Tombala oyun odası",
    "design.save": "Tasarımı uygula",
    "market.help": "Her seçimin ayrı hesaplanır. Çarpanlar bu prova profiline aittir.",
    "nav.tombala": "Tombala",
    "play.follow": "Çekilişi izle",
    "play.refund": "İade edilen",
    "results.won": "Tebrikler! Ödülün bakiyene işlendi.",
    "room.closed": "Seçimler kapandı",
    "room.dateTo": "Bitiş tarihi",
    "room.follow": "Çekiliş Kartlarım",
    "room.goNext": "Sıradaki Çekilişe Geç",
    "room.noBall": "Top bekleniyor",
    "room.search": "Kart no",
    "round.cards": "{count} kart",
    "stage.label": "Sanal yayın stüdyosu",
    "stage.ready": "Hazır",
    "studio.done": "Tur tamamlandı",
    "studio.flow": "YAYIN AKIŞI",
    "studio.last": "Son top",
    "studio.live": "Çekiliş sürüyor",
    "studio.open": "Seçimler açık",
    "studio.send": "Okuyucu sonucu gönder",
    "admin.amount": "Toplam ikramiye",
    "admin.awards": "Kesinleşmiş ikramiyeler",
    "admin.before": "Etkin değer",
    "admin.drawId": "Çekiliş",
    "admin.failed": "Yönetim servisine ulaşılamadı.",
    "admin.number": "Sayı",
    "admin.reason": "Değişiklik gerekçesi",
    "admin.saving": "Kaydediliyor…",
    "admin.source": "Kaynak",
    "auto.maximum": "Maks. {max}",
    "balls.recent": "SON TOPLAR",
    "brand.number": "90",
    "card.details": "Kart ayrıntıları",
    "card.matched": "Eşleşen sayılar",
    "cards.colors": "Kart renkleri",
    "cards.loaded": "{shown} / {count} kart",
    "cards.search": "Kart No",
    "common.close": "Kapat",
    "cta.collapse": "Alt paneli küçült",
    "design.brand": "Marka paleti",
    "design.count": "Parçacık sayısı",
    "design.reset": "Kaydedilmiş tasarıma dön",
    "design.saved": "Kaydedildi. Açık ekranlar birkaç saniyede güncellenecek.",
    "design.title": "Tasarım ve ekran metinleri",
    "designer.row": "Satır {row}",
    "favorite.add": "Kart {card} favorilere ekle",
    "flow.wonHelp": "Bu çekilişteki toplam ikramiye payın.",
    "flow.yourWin": "Kazandığın",
    "market.added": "Seçimine {amount} eklendi.",
    "market.first": "İLK TOP",
    "play.eyebrow": "OYUNUN MERKEZİ",
    "play.noOwned": "Bu çekilişte henüz bir kartın yok.",
    "play.results": "Sonuçlar",
    "receipt.unit": "kart",
    "results.back": "Sonuç listesine dön",
    "results.more": "Daha eski çekilişleri göster",
    "results.view": "Detay",
    "room.current": "Bu çekiliş",
    "room.details": "Kart detayı",
    "room.filters": "Filtrele",
    "room.jpLimit": "En geç {count}. top",
    "room.nextBuy": "Kart al",
    "room.preview": "Olası tombala payın",
    "room.results": "Sonuçlar",
    "room.soundOn": "Ses açık",
    "room.success": "Tutarın seçtiğin çekilişteki kartlarına eklendi.",
    "stage.unmute": "Sunucu sesini aç",
    "studio.count": "Top sayısı",
    "studio.input": "Okunan top",
    "studio.saved": "İşlem kaydedildi.",
    "studio.start": "Seçimleri kapat ve başlat",
    "studio.title": "Stüdyo senin kontrolünde.",
    "wallet.label": "Prova bakiyen",
    "x.prizeTerms": "Çarpanlar ve jackpot",
    "admin.current": "Mevcut çekiliş",
    "admin.loading": "Yönetim verileri yükleniyor…",
    "admin.noBalls": "Henüz top çekilmedi.",
    "admin.noDraft": "Bekleyen taslak yok",
    "admin.players": "Oyuncu",
    "admin.product": "Tombala platformu",
    "admin.profile": "Kural sürümü",
    "admin.refresh": "Yenile",
    "admin.setting": "Ayar",
    "admin.sources": "Referans dosyaları",
    "admin.unsaved": "Kaydedilmemiş değişiklikler var.",
    "auto.liveHelp": "Kart grubunu & adetlerini seç ve satın alma adımına geç!",
    "auto.unplayed": "Almadıklarım",
    "award.dismiss": "Bildirimi kapat",
    "balls.waiting": "İlk top için geri sayım başladı.",
    "brand.tagline": "THE NUMBERS COME ALIVE",
    "card.addLabel": "Kart {card} için {amount} TL ekle",
    "card.prizeWon": "KAZANDIN",
    "cards.eyebrow": "SENİN KARTIN, SENİN HEYECANIN",
    "cards.sortLow": "Az seçilenler",
    "common.amount": "Tutar",
    "design.failed": "Tasarım profili kaydedilemedi.",
    "design.motion": "Kazanma animasyonu",
    "designer.cell": "Satır {row}, sütun {column}",
    "designer.help": "Kendi 90 top kartını oluştur. Kaydetmek para harcamaz; oynamak için kartı seçip tutarını ayrıca onaylarsın.",
    "designer.name": "Kartının adı",
    "designer.save": "Kartımı kaydet",
    "flow.lostHelp": "Bu çekilişte ikramiye kazanmadın.",
    "flow.nextSold": "{count} kart satıldı",
    "flow.quickBuy": "Hızlı Satın Al",
    "flow.wonTitle": "İkramiye kazandın",
    "footer.studio": "Stüdyo kontrolü ↗",
    "loading.title": "Stüdyoya bağlanıyoruz",
    "market.choose": "Seç +",
    "market.closed": "İlk top geldi. Bir sonraki çekilişte yeniden buluşalım.",
    "market.result": "Sonuç ✓",
    "markets.title": "İhtimalini seç.",
    "play.allBalls": "Çekilen tüm sayılar",
    "play.liveHelp": "Kartların otomatik işaretlenir. Sıradaki ödüle en yakın kartlarını öne alabilirsin.",
    "play.ownTotal": "Kartlarındaki toplam",
    "play.winnings": "Kazandığın",
    "prize.current": "Şu an oynanan ikramiye",
    "prize.jackpot": "Jackpot",
    "prize.waiting": "Kart eşiği bekleniyor",
    "results.added": "Kartlara eklenen",
    "results.apply": "Tarihleri uygula",
    "results.balls": "{count} top çekildi",
    "results.cards": "Kartlar",
    "results.empty": "Tamamlanan ilk çekiliş burada görünecek.",
    "results.error": "Sonuçlar şu anda yüklenemedi.",
    "results.noWin": "Bu çekilişte kartlarına ödül çıkmadı.",
    "results.title": "Sonuçların burada.",
    "room.cardView": "Kart görünümü",
    "room.dateFrom": "Başlangıç tarihi",
    "room.lastBall": "Son top",
    "room.myAmount": "Kartlarıma eklediğim",
    "room.nextOpen": "Bu kartlar sıradaki çekiliş için. Mevcut çekiliş bitince otomatik başlayacak.",
    "room.onlyMine": "Katıldığım çekilişler",
    "room.personal": "Özel",
    "room.pickNext": "Sıradaki Çekilişe Kart Al",
    "room.selected": "{count} kart seçtin",
    "room.soundOff": "Ses kapalı",
    "room.starting": "Çekiliş başlıyor",
    "room.upcoming": "Sıradaki çekiliş",
    "round.players": "{count} oyuncu",
    "selection.buy": "Satın al",
    "stage.closing": "SEÇİMLER KAPANIYOR",
    "stage.drawing": "TOPLAR SIRAYLA GELİYOR",
    "stage.soundOn": "Ses açık",
    "stage.waiting": "İlk top bekleniyor",
    "studio.reader": "Okuyucu entegrasyonu provası",
    "tombala.title": "Her sayı yeni bir ihtimal.",
    "wallet.avatar": "S",
    "x.cardReturns": "Kazanırsan alacağın brüt ödeme",
    "x.jackpotHelp": "Gösterilen Jackpot, sabit başlangıç tutarı ile birikimin dağıtıma açılan yüzdesidir. Kalan birikim havuzda kalır. Satılmamış kazanan kartların birikim payı da devreder; taban tekrar havuza eklenmez. Kazananların kişisel payı yatırdıkları tutara göre hesaplanır.",
    "x.jackpotPool": "Jackpot havuzu",
    "x.resultTerms": "Bu çekilişin ikramiye koşulları",
    "admin.activate": "Yeni oluşturulacak çekilişler için etkinleştir",
    "admin.analysis": "JP sıklığını incele",
    "admin.drawHelp": "Mevcut ve sıradaki çekilişler gösterilir. Geçmiş raporları ve gerekçeli iptal/iade işlemleri sonraki işlerdir.",
    "admin.noAwards": "Henüz ikramiye kesinleşmedi.",
    "admin.openDraw": "Detayı göster",
    "admin.retained": "JP birikiminde tutulacak pay: %{percent}",
    "admin.revision": "Yönetim kayıt sürümü",
    "admin.sequence": "Sıra",
    "admin.subtitle": "Kuralları, çekilişleri ve matematik analizini tek yerden takip et.",
    "admin.upcoming": "Satışa açık sıradaki çekiliş",
    "auto.available": "Adedi seç veya yaz. En fazla {max} kart seçebilirsin.",
    "auto.favorites": "Favorilerim",
    "broadcast.stop": "Durdur",
    "card.potential": "Tek kazanan olursa tombala payın",
    "card.remaining": "{count} sayı kaldı",
    "cards.previous": "Önceki kartlar",
    "cards.sortHigh": "Çok seçilenler",
    "cards.sortName": "Ad A–Z",
    "common.waiting": "Bekleniyor",
    "design.eyebrow": "CANLI TOMBALA X",
    "design.marking": "Ortak sayı işareti",
    "design.palette": "Top renkleri",
    "design.preview": "Örnek etkileşim",
    "design.primary": "Ana yeşil",
    "design.room.bg": "Oda zemini",
    "design.surface": "Sayfa zemini",
    "designer.color": "Kart rengi",
    "designer.ready": "Kartın geçerli. Yalnız senin kart kütüphanene kaydedilecek.",
    "designer.rules": "Her satırda 5 sayı olmalı. 15 farklı sayı kullan ve sütun aralıklarına uy. Aynı sütundaki sayıları istediğin satıra yerleştirebilirsin.",
    "designer.title": "Kart tasarla",
    "favorite.error": "Favoriler yüklenemedi. Yeniden deneyebilirsin.",
    "favorite.retry": "Favorileri yenile",
    "flow.lostTitle": "Çekiliş tamamlandı",
    "flow.nextOwned": "Sıradaki kartlarım",
    "flow.salesOpen": "Satış açık",
    "flow.voidPrize": "Bu çekiliş iptal edildiği için ikramiye payı geçerli değil.",
    "flow.watchLive": "Canlı Çekilişe Geç",
    "flow.yourStake": "Yatırdığın",
    "play.liveTitle": "Şimdi gözler sayılarda.",
    "prize.one-line": "1. Çinko",
    "purchase.retry": "İşlemi tekrar kontrol et",
    "receipt.closed": "Bu çekilişin satış süresi doldu.",
    "receipt.review": "İşlemin kesin sonucu kontrol ediliyor; aynı seçim için yeni ödeme başlatma.",
    "results.atBall": "{count}. topta tamamlandı",
    "results.jpPool": "Çekilişin Jackpot havuzu",
    "results.period": "Sonuç tarihi",
    "results.return": "Güncel oyuna dön",
    "results.status": "Sonuç",
    "room.available": "Hemen Kartlarını Seç, Oyuna Katıl!",
    "room.ballCount": "{count}. top",
    "room.broadcast": "Yayın",
    "room.cancelled": "Çekiliş iptal edildi",
    "room.closeMenu": "Menüyü kapat",
    "room.completed": "Çekiliş tamamlandı",
    "room.drawCards": "{count} aktif kart",
    "room.favorites": "Favori Kartlarım",
    "room.fullBoard": "Tüm toplar",
    "room.helpLocal": "Oyun koşulları satış açılmadan belirlenir ve el boyunca değişmez.",
    "room.helpPrize": "Normal aşamalarda bahis × çarpan ödenir; beraberlikte bölünmez. Aşamalar toplanır ve ana para çarpana dahildir. Jackpot ayrı paylaşılır.",
    "room.helpTrack": "İlk tamamlayan kartlar aşamayı sonuçlandırır. Satılmamış kart da kazanabilir; o kart için ödeme yapılmaz.",
    "room.jpCarried": "Devreden havuz",
    "room.jpExpired": "Jackpot şansı sona erdi",
    "room.liveShort": "Canlı",
    "room.muteSound": "Sesi kapat",
    "room.nearCards": "Kazanmaya yakın kartlar",
    "room.noneOwned": "Bu çekilişte kartın yok.",
    "room.preparing": "Çekiliş hazırlanıyor",
    "room.yourCards": "{count} kartın var",
    "settings.title": "Oyun ayarları",
    "stage.imageAlt": "Top makinesi bulunan modern bir stüdyoda sanal sunucu",
    "stage.lastBall": "SON ÇEKİLEN TOP",
    "stage.sequence": "{count}. top",
    "stage.soundOff": "Sesi aç",
    "stage.starting": "BİRLİKTE BAŞLIYORUZ",
    "studio.eyebrow": "YAYIN MASASI / YEREL PROVA",
    "x.carryPending": "Önceki çekilişin jackpot devri bekleniyor.",
    "x.jackpotShare": "Havuzdan pay",
    "admin.activated": "Yeni çekiliş şablonu etkinleştirildi. Satışa açılmış çekilişlerin kuralları korundu.",
    "admin.auditHelp": "Her kayıt zaman, sürüm, gerekçe ve önceki/yeni değerleri içerir. Yerel dosya kaydı bağımsız zaman damgası veya üretim denetim sistemi değildir.",
    "admin.ballCount": "Çekilen top",
    "admin.localHelp": "Yerel oyun verisine bağlıdır. Üretim kullanıcı/rol ve bayi servisleri henüz bağlı değil.",
    "admin.nav.audit": "Değişiklik kayıtları",
    "admin.nav.draws": "Çekilişler",
    "admin.nav.scope": "Referans kapsamı",
    "admin.noChanges": "Henüz kayıt yok.",
    "admin.poolTotal": "Havuzlara ayrılan toplam: %{percent}",
    "admin.saveDraft": "Taslağı doğrula ve kaydet",
    "award.yourShare": "Senin payın",
    "broadcast.retry": "Yeniden dene",
    "broadcast.start": "Oynat",
    "broadcast.video": "Canlı yayın oynatıcısı",
    "card.exactValue": "Tam tutar",
    "card.marker.ink": "Kalem",
    "card.yourAmount": "Kartındaki tutar",
    "cards.backToTop": "En üste dön",
    "cards.favorites": "Favorilerim",
    "cards.noMatches": "Bu filtreye uygun kart bulunamadı.",
    "cards.sortLabel": "Sırala",
    "design.advanced": "Tüm tasarım profili · JSON",
    "designer.delete": "Sil",
    "designer.failed": "Kart kaydedilemedi. Yeniden deneyebilirsin.",
    "experience.save": "Kaydet ve uygula",
    "favorite.remove": "Kart {card} favorilerden çıkar",
    "flow.chooseCard": "Kartını Seç",
    "flow.totalPrize": "Toplam ikramiye {amount}",
    "jackpot.caption": "Biriken ödül havuzu",
    "jackpot.eyebrow": "BÜYÜK HEYECAN",
    "market.selected": "seçildi",
    "markets.eyebrow": "BİR SAYIDAN DAHA FAZLASI",
    "play.lastResult": "Son sonuçları gör",
    "prize.cancelled": "İptal edildi",
    "prize.completed": "Tamamlandı",
    "prize.two-lines": "2. Çinko",
    "receipt.balance": "Bakiye kalan seçimler için yeterli değil.",
    "receipt.debited": "Ödeme onaylandı; kart kabulünün kesin sonucu doğrulanıyor.",
    "receipt.pending": "{count} kartın satın alma işlemi sürüyor…",
    "receipt.session": "Bayi oturumun sona erdi. Oyunu bayi sayfasından yeniden açabilirsin.",
    "receipt.waiting": "İşlem onayı bekleniyor.",
    "results.eyebrow": "HER ÇEKİLİŞİN BİR HİKÂYESİ VAR",
    "results.jpCarry": "Sonraki çekilişe devreden",
    "results.jpLimit": "Jackpot top sınırı",
    "results.loading": "Sonuçlar yükleniyor…",
    "results.noCards": "Bu çekilişte oynadığın Tombala kartı yok.",
    "room.allNumbers": "Çekilen toplar",
    "room.gameSounds": "Oyun sesleri",
    "room.helpAmount": "Kartlarını ve bu elin izin verdiği tutarı seç. Satın almadan önce, bir kartın hangi aşamayı kazanırsa ne kadar ödeme alacağını satın alma alanında görürsün.",
    "room.helpChoose": "{count} sabit kartın tamamı her çekilişte yarışır. İstediğin kartları seç; aynı kartı başka oyuncular da oynayabilir.",
    "room.helpRefund": "Çekiliş iptal edilirse kabul edilmiş bahislerin iadesi işleme alınır. İade ve ikramiye durumlarını Sonuçlar bölümünden takip edebilirsin.",
    "room.nextMoving": "Sonraki oynanmış kartlar",
    "room.resultsFor": "Çekiliş #{draw}",
    "room.salesClose": "Kalan Süre:",
    "room.selectDraw": "Çekilişi seç",
    "selection.clear": "Seçimi Sil",
    "selection.draft": "Henüz tutar eklenmedi",
    "selection.final": "Onaylanan tutar geri alınamaz. Sistem çekilişi iptal ederse iade edilir.",
    "selection.limit": "Bir işlemde en fazla {count} kart seçebilirsin.",
    "selection.title": "Seçtiğin kartlar",
    "selection.total": "Toplam Tutar",
    "stage.presenter": "SANAL SUNUCUNUZ",
    "stage.rehearsal": "RNG PROVASI",
    "tombala.eyebrow": "BİR TOP. BİNLERCE HEYECAN.",
    "x.guideStageWin": "KATINI KAZAN",
    "x.multiplierWin": "{multiplier} misli kazan",
    "x.purchaseCount": "{count} kart satıldı",
    "x.purchaseGuide": "Nasıl kazanırsın?",
    "x.unfundedAward": "Kazanan Kartlar",
    "admin.nav.design": "Görünüm kataloğu",
    "admin.nav.studio": "Stüdyo",
    "admin.scopeIntro": "Referans GameAdmin / BackOffice özelliklerinin yeni sürümdeki karşılıkları. Tamamlanmamış modüller burada açıkça izlenir.",
    "admin.status.new": "Yeni · yerelde çalışıyor",
    "admin.unit.count": "adet",
    "auto.unavailable": "Bağlantı ve satış durumu uygun olduğunda seçim yapabilirsin.",
    "award.totalPrize": "Toplam ikramiye",
    "broadcast.hlsUrl": "HLS yayın adresi",
    "card.amountLabel": "Karta eklenecek tutar",
    "card.conditional": "Bu kart aşamayı kazanırsa, kabul edilmiş toplam tutarın sabit çarpanla hesaplanan brüt ödemesidir. Diğer kazananlar bu tutarı azaltmaz. Aşama ödemeleri birbirine eklenir.",
    "card.marker.chip": "Pul",
    "card.numberLabel": "No. {number}",
    "card.prizeNotWon": "Bu ikramiye tamamlandı. Bu karttan kazanç elde etmedin.",
    "cards.sortIdHelp": "Numaraya göre sırala",
    "common.rehearsal": "PROVA",
    "design.copyValue": "Metin değeri",
    "design.jsonLabel": "UI tasarım profili",
    "design.numberInk": "Kart sayıları",
    "design.room.text": "Oda metni",
    "designer.deleted": "Özel kart kütüphanenden silindi.",
    "designer.library": "Özel kartlarım",
    "experience.intro": "Bu ayarlar kaydedilince uygulanır. Çekilişin top aralığını, satış kapanış saatini veya ikramiye kurallarını değiştirmez.",
    "experience.sales": "Simülasyon satış güncelleme aralığı",
    "experience.saved": "Görünüm ve simülasyon ayarları kaydedildi.",
    "flow.browseCards": "Kartları Gör",
    "flow.myCardCount": "{count} kartım",
    "flow.myNextCards": "{count} kartın var",
    "flow.quickClosed": "#{draw} çekilişinin satış süresi dolduğu için hızlı seçim kapandı. Yeni seçim için sonraki çekilişe geçebilirsin.",
    "flow.resultTitle": "Çekiliş sonucum",
    "flow.waitingNext": "Çekiliş tamamlandı. Sıradaki çekiliş hazırlanıyor.",
    "footer.rehearsal": "RNG provası · Test bakiyesi · Gerçek para kullanılmaz",
    "play.chooseCards": "Tüm Kartları Listele",
    "prize.full-house": "Tombala",
    "purchase.partial": "Kartlarının bir kısmı alındı. İşlem ayrıntılarını kontrol et.",
    "purchase.pending": "İşlemin sonucu kontrol ediliyor",
    "receipt.accepted": "{count} {unit} satın alındı",
    "receipt.refunded": "Alınamayan seçimler için tahsil edilen tutar iade edildi.",
    "receipt.rejected": "{count} {unit} alınamadı",
    "results.dateHelp": "Tamamlanma tarihine göre listelenir.",
    "results.jp.Empty": "Jackpot koşulu sağlandı; dağıtılabilir tutar oluşmadı.",
    "results.refunded": "İade",
    "results.sequence": "Çekilme sırasına göre toplar",
    "room.amountRange": "Kart başına {min} – {max}",
    "room.backToCards": "Kartlara dön",
    "room.confirmDraw": "Çekiliş",
    "room.drawChanged": "Çekiliş değişti; onaylanmamış seçimin temizlendi.",
    "room.enableSound": "Sesi aç",
    "room.filterTitle": "Kartları filtrele ve sırala",
    "room.jpRemaining": "{count} top kaldı",
    "room.playedCount": "Çekiliş Kartlarım ({count})",
    "selection.remove": "İPTAL ET",
    "selection.review": "Kontrol et",
    "studio.confirmed": "Doğrulanmış top akışı",
    "studio.connected": "Bağlı",
    "studio.preparing": "Çekiliş hazırlanıyor",
    "x.cardReturnsFor": "{amount} üzerinden kazanırsan alacağın brüt ödeme",
    "x.guideStageLead": "Yatırdığın tutarın",
    "x.jackpotCarried": "Sonraki çekilişe devretti",
    "x.jackpotSettled": "Paylaşım tamamlandı",
    "x.jpDistribution": "Birikimden dağıtılacak pay",
    "x.paymentPending": "Kazancının {amount} tutarı için bayi ödeme teyidi bekleniyor.",
    "admin.environment": "Yerel test",
    "admin.group.pools": "Havuz dağılımı",
    "admin.nav.jackpot": "JP hesaplayıcı",
    "admin.status.Live": "Çekiliş sürüyor",
    "award.winnerTitle": "Tebrikler, kazandın!",
    "broadcast.connect": "Bağlan",
    "card.detailsLabel": "Kart {card} ayrıntıları",
    "card.investedHelp": "Bu çekilişte bu karta eklediğin toplam tutar.",
    "card.markerEffect": "İşaretleme efekti",
    "cards.noFavorites": "Sevdiğin kartları yıldızla kaydet; sonraki çekilişte kolayca bul.",
    "cards.shuffleHelp": "Kartları karıştır",
    "connection.online": "Stüdyo bağlı",
    "design.components": "Bileşen önizlemesi",
    "design.copySearch": "Metin ara",
    "design.copySelect": "Düzenlenecek metin",
    "design.markingInk": "Çekilen sayı yazısı",
    "design.room.panel": "Paneller",
    "designer.fillRows": "Her satıra 5 sayı seç. Kalan kutular boş kalır.",
    "flow.refundAmount": "İade edilen",
    "flow.returnToDraw": "Çekilişe Dön",
    "flow.startingHelp": "Bu çekilişe kart alımı kapandı. İlk top birazdan çekilecek.",
    "flow.watchCurrent": "Çekilişi izle",
    "flow.watchingHelp": "Bu çekilişe kart almadın. Sonraki çekiliş için kart seçebilirsin.",
    "footer.experience": "/ Sanal stüdyo deneyimi",
    "prize.exactAmount": "Güncel tutar",
    "purchase.accepted": "İşlem onaylandı. Tutarlar seçtiğin kartlara eklendi.",
    "purchase.checking": "Kontrol ediliyor…",
    "results.cancelled": "TOMBALA OYUNU İPTAL EDİLDİ",
    "results.cards.all": "Tüm oyun kartları",
    "results.completed": "TOMBALA SONUCUN",
    "results.grossHelp": "Gösterilen ikramiyelere yatırdığın tutar dahildir.",
    "results.noMatches": "Bu filtrelere uygun çekiliş bulunamadı.",
    "results.notJoined": "Bu çekilişe katılmadın",
    "results.offeredAt": "Satışa açılış",
    "results.prizeHelp": "Çinko ve Tombala kazançları kişisel bahsin × çarpan ile hesaplanır; diğer oyuncularla bölüşülmez. Kartlara dokunarak ayrıntılarını görebilirsin.",
    "results.yourShare": "Senin kazancın",
    "room.balanceLabel": "Bakiye",
    "room.finishedDraw": "Biten çekiliş · #{draw}",
    "room.personalCard": "Özel kartın",
    "room.purchaseBack": "Geri dön",
    "room.selectedDraw": "Oynadığın çekiliş",
    "room.walkingCards": "Kafadakiler",
    "selection.confirm": "Onayla ve ekle",
    "selection.expired": "Yeni çekiliş açıldı. Önceki turdaki onaylanmamış seçimin temizlendi.",
    "selection.maximum": "Max",
    "selection.minimum": "Min",
    "selection.perCard": "Her karta",
    "settings.subtitle": "Satış, çekiliş, ikramiye ve kart kuralları.",
    "stage.activeCards": "{count} aktif kart",
    "studio.automation": "Bağımsız RNG ve otomatik prova oyuncuları açık. Toplar kayıtlı diziden sırayla gelir.",
    "studio.connection": "Bağlantı",
    "studio.readerHelp": "RNG otomasyonu kapalıyken kullanılır. Fiziksel yayında reader ve arıza durumundaki yetkili giriş aynı sözleşmeyi kullanır.",
    "x.fixedMultiplier": "Sabit çarpan",
    "x.grossPayoutHelp": "Çarpan, yatırılan tutar dahil toplam ödemedir. Kazanılan aşamaların ödemeleri birbirine eklenir.",
    "x.guideJackpotWin": "KAZAN",
    "x.guideStageTitle": "{stage} yap",
    "x.jackpotOwnShare": "JP payın",
    "x.purchaseReturns": "Bu alımın kart başına brüt ödemesi",
    "admin.confirmLeave": "Kaydedilmemiş değişiklikleri bırakmak istiyor musun?",
    "admin.group.limits": "Tutar ve kart sınırları",
    "admin.group.timing": "Süreler",
    "admin.nav.overview": "Genel bakış",
    "admin.nav.settings": "Oyun ayarları",
    "admin.status.local": "Yerelde çalışıyor",
    "admin.tombalaTotal": "Tombala toplamı",
    "admin.unit.percent": "%",
    "admin.unit.seconds": "saniye",
    "award.winningCards": "{count} kazanan kart",
    "broadcast.labTitle": "90° Yayın provası",
    "broadcast.nextHelp": "Ant Media’nın kendi oynatıcısı → oyun olaylarıyla zaman eşleştirme → doğal Türkçe ses → konuşan AI sunucu ve gerçekçi stüdyo.",
    "broadcast.protocol": "Oynatma yöntemi",
    "broadcast.streamId": "Stream ID",
    "broadcast.syncHelp": "Bu prova video oynatmayı doğrular. Kartlar, sayı anonsları ve ikramiye bildirimleriyle senkron henüz bağlanmadı.",
    "card.investedShort": "YATIRDIN",
    "desktop.boardTitle": "TABELA",
    "card.prizeCurrency": "İkramiye payların · {currency}",
    "card.shareCurrency": "Olası payların · {currency}",
    "card.unfundedShare": "Bu karta oynamadınız.",
    "cards.resetFilters": "Filtreleri sıfırla",
    "connection.pending": "Bağlantı bekleniyor",
    "connection.waiting": "Bağlantı kuruluyor. İşlem yapmak için bağlantının dönmesini bekle.",
    "design.cardPalette": "Kart renkleri · 6 grup",
    "design.description": "Oyun renklerini, kart ve top görünümünü, işaretleme biçimini ve ekran metinlerini düzenle. Kaydedilen tasarım mobil ve web ekranlarında ortak kullanılır.",
    "design.room.accent": "Vurgu ve kazanç",
    "design.room.action": "İşlem düğmeleri",
    "designer.clearCell": "Sayıyı sil",
    "designer.deleteYes": "Kartı sil",
    "designer.nameLimit": "{count}/{max} karakter",
    "experience.counter": "İkramiye sayacı animasyon süresi",
    "flow.nextCatalogue": "Sonraki Çekilişin Kartları",
    "flow.nextPreparing": "Sıradaki çekiliş hazırlanıyor",
    "flow.preparingHelp": "Satış kapandı. Çekiliş birazdan başlayacak.",
    "flow.refundPending": "İade durumun güncelleniyor.",
    "flow.watchingTitle": "Çekilişi izliyorsun",
    "market.amountLabel": "Seçim tutarı",
    "play.cancelledHelp": "Tombala bu tur başlamadı. Kart tutarları iade edildi; ortak yayın diğer oyun için sürebilir.",
    "purchase.uncertain": "İşlemin yanıtı alınamadı. Aynı işlemi kontrol et; yeniden tutar eklemiyoruz.",
    "receipt.amountStep": "Tutar, izin verilen alım adımına uygun değil.",
    "receipt.notDebited": "Bayi tahsilatın gerçekleşmediğini doğruladı.",
    "results.cards.mine": "Kartlarım",
    "results.cardsCount": "{count} kartla katıldın",
    "results.drawResult": "Çekiliş sonucu",
    "results.filter.all": "Tüm sonuçlar",
    "results.filter.won": "Kazandıklarım",
    "results.notAwarded": "Bu ikramiye oluşmadı.",
    "results.period.all": "Tümü",
    "results.selectDraw": "Ayrıntılarını görmek için bir çekiliş seç.",
    "results.totalPrize": "Oyuncuların toplam kazancı",
    "room.broadcastOpen": "Açık",
    "room.gameSoundHelp": "Numara ve ikramiye seslerini açıp kapatır.",
    "room.hideBroadcast": "Yayını küçült",
    "room.inactivePrize": "Şart bekleniyor",
    "room.ownedUpcoming": "Sıradaki çekilişte {count} kartın hazır.",
    "room.personalCards": "Özel Kartlarım",
    "room.previousBalls": "Önceki üç top",
    "room.requiredCards": "{count} farklı kartta açılır",
    "room.resultPending": "Çekilişin kesin sonucu yükleniyor…",
    "room.selectionDraw": "Çekiliş #{draw}",
    "room.selectionStep": "Kart seç → Tutarını yaz → Onayla",
    "room.showBroadcast": "Yayını aç",
    "selection.selected": "SEÇİLDİ",
    "studio.openOverlay": "Yayın görünümünü aç ↗",
    "x.fixedMultipliers": "Sabit ödeme çarpanları",
    "x.guideJackpotLead": "İlk {count} topta",
    "x.guideJackpotMark": "JACKPOT",
    "x.jackpotQuoteHelp": "Bu kart tek başına Jackpot yaparsa, bu karttaki yatırımların oranına göre alabileceğin tutardır. Havuz ve yatırımlar değiştikçe güncellenir. Aynı anda başka kartlar kazanırsa kesin pay yeniden hesaplanır; satılmamış kazanan kartların payı devreder.",
    "x.paymentConfirmed": "Kazancın için bayi ödeme teyidi alındı.",
    "admin.activeVersion": "Yeni çekiliş şablonu",
    "admin.group.display": "Gösterim ayarları",
    "admin.group.jackpot": "Jackpot",
    "admin.settingsIntro": "Değişiklikleri önce taslak kaydet. Etkinleştirme bundan sonra oluşturulacak çekilişleri etkiler; mevcut ve önceden satışa açılmış sıradaki çekiliş korunur.",
    "admin.source.Reader": "Okuyucu",
    "award.observerTitle": "Kazanan Kartlar",
    "broadcast.nextTitle": "Sıradaki bağlantı",
    "broadcast.playToken": "Oynatma tokenı (isteğe bağlı)",
    "broadcast.playerUrl": "Ant Media player adresi",
    "broadcast.tokenHelp": "Yalnız kısa süreli test oynatma tokenını kullan. Token Ant Media player adresine eklenir; tarayıcı depolamasına kaydedilmez. Yönetici parolası, lisans veya yayın anahtarı girilmez.",
    "broadcast.websocket": "Ant Media WebSocket adresi",
    "card.catalogVersion": "Kart sürümü",
    "card.confirmedShare": "Bu karttan kazandığın kesin tutar.",
    "card.remainingShort": "{count} kaldı",
    "flow.cancelledTitle": "Çekiliş iptal edildi",
    "flow.enterCatalogue": "Giriş",
    "flow.nextOwnedCount": "Sonraki çekilişte {count} kartın var.",
    "flow.ownWinningCard": "Kart {number} · Senin kazanan kartın",
    "flow.preparingTitle": "Çekilişe hazırlanıyoruz",
    "flow.prizeBreakdown": "İkramiye dökümü",
    "flow.purchasedCards": "{count} kart alındı",
    "flow.salesRemaining": "Satış bitimine",
    "jackpot.description": "Her çekilişte yeni bir ihtimal. Topları takip et, anı yakala.",
    "loading.description": "Kartlar ve yayın hazırlanıyor.",
    "loading.failed": "Oyun bilgisi alınamadı. Lütfen yeniden deneyin.",
    "purchase.card_limit": "Bu çekilişte izin verilen kart sayısına ulaştın.",
    "purchase.notStarted": "İşlem bu tarayıcıda başlatılamadı. Sayfayı yenileyip tekrar dene; tutar düşülmedi.",
    "purchase.processing": "Satın alınıyor...",
    "purchase.wrong_draw": "Çekiliş değişti. Güncel turu kontrol et.",
    "receipt.amountLimit": "Seçim tutarı izin verilen sınırı aşıyor.",
    "receipt.notApproved": "Alınamayan seçimler için ödeme onaylanmadı.",
    "receipt.notIncluded": "Onayı alınamayan seçimler oyuna dahil edilmedi. Ödeme durumu kontrol ediliyor; kesinti varsa iade edilecek.",
    "results.filter.lost": "Kazanç oluşmayanlar",
    "room.catalogHeading": "{label} * {count} adet",
    "room.confirmCurrent": "Mevcut çekiliş · #{draw}",
    "room.nextOwnedCount": "{count} adet",
    "room.personalMarker": "Ö",
    "room.previousMoving": "Önceki oynanmış kartlar",
    "room.remainingShort": "{count} kaldı",
    "room.selectionTitle": "Lütfen Seçiminizi Yapınız!",
    "settings.breadcrumb": "GAMEADMIN / TOMBALA",
    "settings.navigation": "Tombala yönetim bölümleri",
    "spectator.inspected": "İncelediğin kart",
    "x.cardPurchaseCount": "Bu kart için {count} satın alma",
    "x.carryPendingShort": "Devir bekleniyor",
    "x.purchaseCountHelp": "Bu çekilişte onaylanmış toplam kart alımı. Aynı karta yapılan ayrı alımlar da sayılır.",
    "admin.nav.experience": "Görünüm ve simülasyon",
    "admin.status.partial": "Kısmen hazır",
    "admin.status.pending": "Bekliyor",
    "broadcast.backToGame": "Oyuna dön",
    "broadcast.nativeHelp": "Ses, tam ekran, kalite ve bağlantı davranışı Ant Media oynatıcısında kalır. Adresteki oynatma seçenekleri korunur; üzerine ikinci bir kontrol paneli eklenmez.",
    "broadcast.noFallback": "WebRTC bağlanamazsa HLS’ye otomatik geçilmez. Gecikmesi farklı olan HLS ayrı seçilip ölçülür.",
    "broadcast.source.hls": "HLS",
    "card.playFooterLabel": "Kartının ikramiye payları ve yatırdığın tutar",
    "design.copyNoResults": "Eşleşen metin bulunamadı.",
    "designer.choiceRules": "Sütun aralığındaki sayıları istediğin satıra yerleştir. Aynı sayı kartta bir kez kullanılabilir.",
    "designer.columnRange": "{column}. sütun · {min}–{max}",
    "designer.previewName": "Kartının adı",
    "experience.salesHelp": "Otomatik prova alımlarının işlenme aralığı. Gerçek oyuncunun satın alma yanıtını bekletmez. Son satış grubunun kapanış öncesinde tamamlanması sağlanır.",
    "flow.nextDrawHeading": "Sonraki Çekiliş",
    "flow.nextOwnedAction": "Sıradaki Kartlarım · {count}",
    "flow.purchaseDrawWon": "#{draw} çekilişinde {amount} kazandın.",
    "flow.refundConfirmed": "İade tutarı bakiyene yansıtıldı.",
    "flow.selectionClosed": "#{draw} çekilişine kart alımı kapandı. {count} kartlık seçimin korunuyor. Sıradaki çekilişte devam edebilirsin.",
    "flow.transactionDraw": "Çekiliş No: #{draw}",
    "purchase.amount_step": "Tutar, tanımlı kart alım adımına uygun değil.",
    "purchase.notAccepted": "Bu işlem kabul edilmedi; tutar düşülmedi.",
    "results.jp.Allocated": "Jackpot dağıtımı tamamlandı.",
    "results.observerHelp": "Çekilişin sonuçlarını ve kartlarını aşağıdan inceleyebilirsin.",
    "results.period.today": "Bugün",
    "results.prizeResults": "İkramiye sonuçları",
    "results.refreshError": "Güncel ödeme durumu alınamadı. Son doğrulanan sonuç gösteriliyor.",
    "results.winningCards": "Kazanan kartlar",
    "results.yourWinnings": "Toplam kazancın",
    "room.broadcastClosed": "Kapalı",
    "room.confirmUpcoming": "Sıradaki çekiliş · #{draw}",
    "room.gameSoundResume": "Sesi Aç",
    "room.nextSummaryOpen": "Sıradaki çekiliş kart alımını aç",
    "selection.amountStep": "Tutarı {step} adımlarla gir.",
    "selection.countTitle": "{count} adet kart seçtin",
    "selection.removeCard": "Seçimi iptal et",
    "settings.previewHelp": "Mevcut GameAdmin içine alınacak ayar modülünün yerel önizlemesi. Bu ekrandaki kayıtlar yalnız yerel test oyununu etkiler; mevcut GameAdmin servislerine henüz bağlı değildir.",
    "studio.confirmedHelp": "Renkler tüm sayıların sabit gruplarını gösterir. Parlak toplar doğrulanmış sonuçlardır; çekilme sırası yalnızca geldiğinde görünür.",
    "x.guideJackpotAction": "Tombala yap",
    "x.purchaseQuoteTitle": "Kazanırsan, kart başına",
    "broadcast.previewHelp": "Bu hareketli test görüntüsü tarayıcıda üretilip gerçek bir WebRTC gönderici–alıcı bağlantısından geçiyor. Ant Media sunucusuna bağlı değil; AI sunucu ve ses henüz bağlı değil.",
    "broadcast.status.idle": "Durduruldu",
    "card.conditionalShort": "Aşamayı kazanırsan brüt ödemen",
    "card.prizeUnavailable": "Bu ikramiye için artık yarışılmıyor.",
    "designer.deleteCancel": "Vazgeç",
    "designer.deleteFailed": "Kart silinemedi. Tekrar deneyebilirsin.",
    "designer.deleteLocked": "Katıldığı çekiliş bitince silinebilir.",
    "designer.libraryCount": "Kayıtlı özel kart: {count} / {max}",
    "designer.libraryLimit": "En fazla {max} özel kart kaydedebilirsin. Yeni kart için kütüphanenden bir kart silebilirsin.",
    "designer.numberPicker": "Sayı seçimi",
    "flow.otherWinningCard": "Kart {number} · Diğer kazanan kart",
    "flow.returnToLiveDraw": "Canlı Çekilişe Dön",
    "purchase.amount_limit": "Kartlardan biri için tanımlı tutar sınırı aşılıyor.",
    "purchase.receiptCards": "{count} kartlık işlem",
    "purchase.sales_closed": "Bu çekilişin seçim süresi doldu.",
    "purchase.unknown_card": "Kartlardan biri güncel çekilişte bulunamadı.",
    "receipt.refundPending": "Alınamayan seçimlerin iadesi bekleniyor.",
    "results.cards.winning": "Kazanan kartlar",
    "results.noCardsInView": "Bu grupta gösterilecek kart yok.",
    "results.paymentReview": "Bu tutarın {amount} bölümü için ödeme incelemesi sürüyor.",
    "results.section.balls": "Top sırası",
    "results.section.cards": "Kartlar",
    "room.bestCardsHeading": "En iyi {count} kart",
    "room.gameSoundBlocked": "Sesi başlatmak için dokun",
    "room.nextSummaryClose": "Kart alımını kapat",
    "x.purchasePaymentHelp": "İkramiye Kuralları",
    "x.purchaseReturnsHelp": "Bu ek tutarın kart başına brüt ödemesidir. Aşamalar toplanır; başka kazananlar ödemeni azaltmaz.",
    "admin.source.Rehearsal": "RNG provası",
    "admin.status.Cancelled": "İptal edildi",
    "admin.status.Completed": "Tamamlandı",
    "admin.status.Preparing": "Hazırlanıyor",
    "admin.status.SalesOpen": "Satış açık",
    "broadcast.connectTitle": "Test yayınına bağlan",
    "broadcast.externalHelp": "Yalnız oynatma bağlantısı. Bu ekran yayına veri göndermez ve çekiliş durumunu değiştirmez.",
    "broadcast.localPreview": "Yerel provaya dön",
    "broadcast.previewLabel": "YEREL YAYIN PROVASI",
    "broadcast.status.ended": "Yayın sona erdi",
    "broadcast.status.error": "Yayın bağlantısı kurulamadı",
    "card.prizeState.active": "Şu an oynanan ikramiye",
    "designer.deleteConfirm": "“{name}” kütüphaneden silinsin mi?",
    "experience.counterHelp": "Yeni tutara sayarak ulaşma süresi. 0, animasyonu kapatır. Değişmeyen tutar sabit kalır.",
    "experience.movingCards": "Yürüyen kart sayısı",
    "flow.cancelledObserver": "Bu çekiliş iptal edildi. Sıradaki çekiliş bekleniyor.",
    "flow.continueSelection": "Yarım Kalan Seçime Devam Et",
    "flow.noNextCardsPrompt": "Henüz kart almadın",
    "flow.previousCancelled": "Önceki çekiliş #{draw} iptal edildi.",
    "flow.selectionRestored": "{count} kartlık seçimin ve tutarın aktarıldı. Satın alarak bu çekilişe katılabilirsin.",
    "results.cancelledShort": "İptal edildi",
    "results.detailSections": "Çekiliş ayrıntıları",
    "results.jpContribution": "Jackpot katkı oranı",
    "results.refundedAmount": "İade edilen tutar",
    "results.section.prizes": "İkramiyeler",
    "room.nextSelectionDraw": "Sıradaki Çekiliş #{draw}",
    "room.ownedCardsHeading": "Oyun Kartlarım * {count} adet",
    "room.selectCardsPrompt": "Hızlı Kart Seç",
    "selection.balanceAfter": "İşlem sonrası bakiye",
    "selection.confirmTitle": "Seçimini kontrol et.",
    "x.purchasePaymentRules": "Tutarlar bu alım içindir ve yatırdığın parayı içerir. Kart birden fazla aşamayı kazanırsa ödemeler toplanır. Başka kazananlar bu ödemeyi azaltmaz.",
    "admin.action.DraftSaved": "Taslak kaydedildi",
    "admin.group.eligibility": "Oyun ve ikramiye açılma koşulları",
    "admin.unit.milliseconds": "ms",
    "auto.preferencesPending": "Favorilerin henüz yüklenmedi. Bağlantıyı kontrol edip tekrar dene.",
    "broadcast.error.expired": "Oynatma izninin süresi doldu. Yeni bir oturum gerekiyor.",
    "purchase.unknown_market": "Seçenek bu çekilişte bulunamadı.",
    "results.filter.refunded": "İptal / İade",
    "results.jp.NotTriggered": "Jackpot ilk {count} top içinde çıkmadı.",
    "results.unfundedWinners": "Kazanan kartlar satın alınmadığı için ödeme oluşmadı.",
    "room.drawStartingPrompt": "Çekiliş Başlıyor",
    "spectator.backToNearest": "En yakınlara dön",
    "x.purchaseAdditionRules": "Ek alımın, bu karttaki kabul edilmiş önceki tutarına eklenir. Buradaki rakamlar yalnız eklediğin tutarın ödeme karşılığıdır.",
    "broadcast.hlsPlaceholder": "https://sunucu/uygulama/streams/yayin.m3u8",
    "broadcast.officialPlayer": "Ant Media resmi yayın oynatıcısı",
    "broadcast.status.blocked": "Yayını başlatmak için dokun.",
    "broadcast.status.expired": "Oynatma oturumu sona erdi",
    "broadcast.status.playing": "Görüntü oynatılıyor",
    "card.prizeState.upcoming": "Sıradaki ikramiye",
    "design.markingBackground": "Çekilen sayı zemini",
    "designer.interactiveHelp": "Bir kutu seç, ardından kartına eklemek istediğin sayıya bas.",
    "results.period.yesterday": "Dün",
    "room.broadcastOpenAction": "Aç",
    "broadcast.source.antmedia": "Ant Media resmi player",
    "broadcast.status.embedded": "Yayın durumu oynatıcıda",
    "broadcast.status.retrying": "Yeniden bağlanılıyor…",
    "card.prizeState.completed": "Tamamlandı",
    "cards.numberSearchResults": "Kart No: {number}",
    "experience.spectatorCards": "İzleyiciye açık kart sayısı",
    "purchase.request_conflict": "İşlem kaydı seçiminle eşleşmedi. Sonuçlarını kontrol et.",
    "results.refundDescription": "Bu çekiliş için yatırdığın tutarın iadesi tamamlandı.",
    "room.broadcastCloseAction": "Kapat",
    "broadcast.error.connection": "Yayına ulaşılamadı.",
    "broadcast.status.buffering": "Görüntü bekleniyor…",
    "card.purchasePrizeCurrency": "Olası payların · {currency}",
    "experience.movingCardsHelp": "Üstteki kaydırılabilir şeritte gösterilecek en yakın kart sayısı. 1–10.",
    "purchase.invalid_selection": "Seçilen kart listesi uygun değil.",
    "results.jp.CarriedUnfunded": "Jackpot kartları satın alınmadığı için havuz devretti.",
    "x.jackpotPendingAmountHelp": "Bu çekilişin mevcut Jackpot tutarıdır. Önceki çekilişten gelecek devir kesinleştiğinde eklenir.",
    "admin.source.ManualFallback": "Manuel kurtarma",
    "broadcast.error.unsupported": "Bu tarayıcı oynatma yöntemini desteklemiyor.",
    "broadcast.playerPlaceholder": "https://sunucu/uygulama/play.html?id=yayin",
    "broadcast.status.connecting": "Yayına bağlanılıyor…",
    "card.prizeState.unavailable": "Devre dışı",
    "designer.personal_card_busy": "İşlemleri çok hızlı yapıyorsun. Biraz bekleyip tekrar deneyebilirsin.",
    "design.copySearchPlaceholder": "Metin veya anahtar adı…",
    "designer.personal_card_limit": "En fazla {max} özel kart kaydedebilirsin.",
    "flow.selectionCatalogChanged": "Kart serisi yenilendi. Bu çekiliş için kartlarını yeniden seçebilirsin.",
    "flow.selectionPartlyRestored": "Bu çekilişte kullanılabilen {count} kart aktarıldı. Seçimini kontrol edip satın alabilirsin.",
    "selection.confirmDescription": "Aşağıdaki kartların her birine aynı tutar eklenecek.",
    "broadcast.error.authorization": "Bu yayın için geçerli bir oynatma izni gerekiyor.",
    "broadcast.error.invalidSource": "play.html ve id/name içeren Ant Media oynatma adresini kontrol et.",
    "experience.spectatorCardsHelp": "Bu çekilişe kart almayan kişiye açık gösterilecek kart sayısı. 1–10.",
    "purchase.insufficient_balance": "Seçimin için bakiye yeterli değil.",
    "broadcast.source.local-preview": "Yerel WebRTC provası",
    "broadcast.websocketPlaceholder": "wss://sunucu/uygulama/websocket",
    "designer.personal_card_in_play": "Bu kartın katıldığı çekiliş tamamlanmadan kart silinemez.",
    "designer.personal_library_changed": "Kart kütüphanen değişti. Güncel kartlarını kontrol edip tekrar kaydedebilirsin.",
    "purchase.receiptDetailsUnavailable": "İşlemin çekiliş ayrıntıları şu anda okunamıyor. Ödeme durumunu aynı işlem üzerinden kontrol edebilirsin.",
    "admin.action.ActivatedForFutureDraws": "Yeni çekilişler için etkinleştirildi",
    "guide.label": "DEMO Oyun Sunumu",
    "guide.rules": "İade ve oyun koşulları",
    "guide.progress": "{step} / {total}",
    "guide.step": "{step}. adımı göster",
    "guide.previous": "Geri",
    "guide.next": "Devam",
    "guide.finish": "Oyuna dön",
    "guide.hideAgain": "Bir daha gösterme",
    "guide.preferenceError": "Tarayıcı tercihini kaydedemedi. Rehberi kapatıp oyuna devam edebilirsin.",
    "guide.reopen": "Rehberi yeniden aç",
    "guide.preview": "Oyun rehberi · Önizleme",
    "guide.previewHelp": "Kartını seç, satın al, çekilişi izle ve kazancının nasıl hesaplandığını gör.",
    "guide.previewPreference": "Bu önizlemede tercih yalnız ekran açıkken tutulur.",
    "guide.back": "Oyuna dön",
    "guide.loading": "Rehber hazırlanıyor…",
    "guide.error": "Oyun bilgileri alınamadı. Sayfayı yenileyip tekrar deneyebilirsin.",
    "guide.example": "Örnek gösterim",
    "guide.terms": "Tutar ve çarpanlar bu çekilişin koşullarından alınır.",
    "guide.welcome.title": "Canlı Tombala’ya hoş geldin",
    "guide.welcome.body": "Kartını al, çekilişe katıl. Sayılar otomatik işaretlenir; aşamayı ilk tamamlayan kartlar kazanır.",
    "guide.welcome.catalog": "{count} kart · {colors} renk",
    "guide.choose.title": "İlk kartını al",
    "guide.choose.body": "Kartın üzerindeki SATIN AL’a dokun. Ardından tutarını belirleyip satın al.",
    "guide.choose.amount": "Bir kart için örnek tutar",
    "guide.choose.try": "Örnek alımı göster",
    "guide.choose.accepted": "Satın alma tamamlandı",
    "guide.choose.hint": "Başlamak için kartın üzerindeki SATIN AL + düğmesine dokun.",
    "guide.choose.total": "1 kart · {amount}",
    "guide.prizes.title": "Çinko, sonra Tombala!",
    "guide.prizes.body": "Bir sıra 1. Çinko, iki sıra 2. Çinko, tüm sayılar Tombala. Kartın ilgili aşamayı kazanırsa kendi tutarın × çarpan kadar ödeme alırsın.",
    "guide.prizes.note": "Kazandığın aşamalar toplanır. Normal ödül bölünmez; yatırdığın tutar çarpana dahildir.",
    "guide.prizes.payout": "Bu aşamayı kazanırsan",
    "guide.jackpot.title": "Jackpot nasıl kazanılır?",
    "guide.jackpot.body": "İlk {limit} top içinde Tombala kazanan kartlar Jackpot’a da katılır. Jackpot, yukarıdaki çarpanlı kazançlara ek olarak hesaplanır.",
    "guide.jackpot.first": "İlk",
    "guide.jackpot.balls": "top içinde Tombala",
    "guide.jackpot.pool": "Bu çekilişte gösterilen Jackpot",
    "guide.jackpot.note": "Jackpot payın, kazanan kartlara yatırılan tutarlara göre belirlenir.",
    "guide.continue.title": "Oyun kesintisiz devam eder",
    "guide.continue.body": "Canlı çekilişi izlerken alttaki Hızlı Kart Seç ile sonraki çekilişe kart alabilirsin. Hangi çekilişe katıldığını kontrol et; kazançlarını Sonuçlar’dan takip et.",
    "guide.continue.live": "Canlı çekiliş",
    "guide.continue.next": "Sonraki çekiliş",
    "guide.continue.selecting": "Sonraki çekiliş için kart seçimi",
    "guide.continue.return": "Canlı çekilişe dön",
    "guide.continue.note": "Kazanç ve ödeme durumunu Sonuçlar’dan, bu rehberi Nasıl oynanır? menüsünden açabilirsin.",
    "guide.welcome.note": "Birlikte bir kart alıp çekilişi oynayalım.",
    "guide.begin": "Başla",
    "guide.row1": "1 sıra",
    "guide.row2": "2 sıra",
    "guide.row3": "Tüm sayılar",
    "guide.choose.completeBody": "Alım tamamlandı. Kartın üzerindeki tutar, bu karta yatırdığın tutardır.",
    "guide.choose.selected": "Kart seçildi. Alttan tutarını belirle ve SATIN AL’a dokun.",
    "guide.choose.receipt": "1 kart · {amount}",
    "guide.choose.reset": "Yeniden seç",
    "guide.play.open": "Oyna",
    "guide.play.title": "Topları takip et",
    "guide.play.body": "Çıkan sayılar kartında otomatik işaretlenir.",
    "guide.play.ready": "Çekiliş hazır",
    "guide.play.ball": "{count}. top",
    "guide.play.recent": "Önceki toplar",
    "guide.play.start": "Başlat",
    "guide.play.pause": "Duraklat",
    "guide.play.resume": "Devam",
    "guide.play.result": "Sonuç",
    "guide.play.hint": "Kartın hazır. Başlat’a dokun ve çıkan sayıları izle.",
    "guide.play.hit": "Bu sayı kartında var. Senin için işaretlendi.",
    "guide.play.miss": "Bu sayı kartında yok. Sonraki topu bekliyoruz.",
    "guide.play.paused": "Sunum duraklatıldı. Devam’a dokunarak sürdürebilirsin.",
    "guide.play.win1": "Bir sırayı ilk tamamladın: 1. Çinko! Devam ederek ikinci sırayı izle.",
    "guide.play.win2": "İki sırayı ilk tamamladın: 2. Çinko! Şimdi tüm kartı tamamlayalım.",
    "guide.play.win3": "Kartındaki tüm sayılar tamamlandı: Tombala! Sonuçta kazanç hesabını görebilirsin.",
    "guide.result.title": "Tombala! Kazancını gör",
    "guide.result.body": "Bu kartla üç aşamayı da kazandın. Her ödül, satın aldığın tutar ve o aşamanın çarpanıyla hesaplandı.",
    "guide.result.total": "Çarpanlı kazancın",
    "text.App.yukleniyor": "Yükleniyor…",
    "text.App.bildirimler-yukleniyor": "Bildirimler yükleniyor…",
    "text.App.onizleme-yukleniyor": "Önizleme yükleniyor…",
    "text.App.yayin-onizlemesi-yukleniyor": "Yayın önizlemesi yükleniyor…",
    "text.ControlCenter.yonetim-gezinmesi": "Yönetim gezinmesi",
    "text.ControlCenter.yonetim-merkezi": "Yönetim merkezi",
    "text.ControlCenter.tombala-x-test": "Tombala X · Test",
    "text.ControlCenter.oyunu-ac": "Oyunu aç ↗",
    "text.ControlCenter.oyun-yonetimi": "Oyun yönetimi",
    "text.ControlCenter.bayi-islemleri": "Bayi işlemleri",
    "text.ControlCenter.tahsilat-kazanc-iade-ve-mutabakat-bekleyen": "Tahsilat, kazanç, iade ve mutabakat bekleyen işlemler.",
    "text.ControlCenter.test-kullanicilari": "Test kullanıcıları",
    "text.ControlCenter.demo-hesaplari-sifreler-bakiyeler-ve-hesap": "Demo hesapları, şifreler, bakiyeler ve hesap hareketleri.",
    "text.ControlCenter.oyun-ayarlari": "Oyun ayarları",
    "text.ControlCenter.satis-top-cekisi-ikramiye-sureleri-sabit": "Satış, top çekişi, ikramiye süreleri, sabit çarpanlar, limit kademeleri, ayrı jackpot ve sürümlü ayarlar.",
    "text.ControlCenter.cekilis-kontrolu": "Çekiliş kontrolü",
    "text.ControlCenter.canli-durum-gerekceli-duraklatma-ve-top": "Canlı durum, gerekçeli duraklatma ve top çekilmemiş elin iptali.",
    "text.ControlCenter.servis-ayarlari": "Servis ayarları",
    "text.ControlCenter.kuyruk-baglanti-tekrar-ve-oturum-parametreleri": "Kuyruk, bağlantı, tekrar ve oturum parametreleri; sürümlü kayıt ve uygulanma zamanı.",
    "text.ControlCenter.rtp-simulatoru": "RTP simülatörü",
    "text.ControlCenter.hedef-rtp-carpan-onerisi-satis-senaryolari": "Hedef RTP, çarpan önerisi, satış senaryoları, ortak kazananlar ve gerçek JP devir hesabı.",
    "text.ControlCenter.kart-serileri-ve-desenler": "Kart serileri ve desenler",
    "text.ControlCenter.120-kartlik-aday-seriler-alti-renk": "120 kartlık aday seriler, altı renk deseni ve sayı dağılımı incelemesi.",
    "text.ControlCenter.jackpot-hareketleri": "Jackpot hareketleri",
    "text.ControlCenter.baslangic-fonu-satis-katkilari-kazananlara-ayrilan": "Başlangıç fonu, satış katkıları, kazananlara ayrılan tutarlar ve elden ele devir.",
    "text.ControlCenter.gorunum-ve-deneyim": "Görünüm ve deneyim",
    "text.ControlCenter.bildirimler": "Bildirimler",
    "text.ControlCenter.bildirim-metinleri-ortak-temalar-onizleme-ve": "Bildirim metinleri, ortak temalar, önizleme ve bildirim sürümlerine dönüş.",
    "text.ControlCenter.tasarim-ve-ekran-metinleri": "Tasarım ve ekran metinleri",
    "text.ControlCenter.renkler-kart-gorunumu-arayuz-metinleri-ve": "Renkler, kart görünümü, arayüz metinleri ve animasyon seçenekleri.",
    "text.ControlCenter.kart-isaretleme": "Kart işaretleme",
    "text.ControlCenter.pul-kalem-secimi-ve-isaretlenen-sayilarin": "Pul / kalem seçimi ve işaretlenen sayıların görünümü.",
    "text.ControlCenter.gorunum-ayarlari": "Görünüm ayarları",
    "text.ControlCenter.yuruyen-kart-sayisi-izleyici-kartlari-ve": "Yürüyen kart sayısı, izleyici kartları ve görsel sayaç süresi.",
    "text.ControlCenter.ayar-degisiklikleri": "Ayar değişiklikleri",
    "text.ControlCenter.kaydedilen-taslaklar-etkinlestirmeler-ve-degisiklik-gecmisi": "Kaydedilen taslaklar, etkinleştirmeler ve değişiklik geçmişi.",
    "text.ControlCenter.onizlemeler": "Önizlemeler",
    "text.ControlCenter.ikramiye-animasyonlari": "İkramiye animasyonları",
    "text.ControlCenter.1-cinko-2-cinko-tombala-ve": "1. Çinko, 2. Çinko, Tombala ve Jackpot; kazanan / izleyici görünümü ve ses.",
    "text.ControlCenter.ikramiye-sesleri": "İkramiye sesleri",
    "text.ControlCenter.efekt-ve-anonsun-birlikte-veya-sirayla": "Efekt ve anonsun birlikte veya sırayla çaldığı ses örneklerini karşılaştır.",
    "text.ControlCenter.yayin-onizlemesi": "Yayın önizlemesi",
    "text.ControlCenter.yerel-yayin-gorunumu-ve-ant-media": "Yerel yayın görünümü ve Ant Media oynatıcı bağlantı denemesi.",
    "text.ControlCenter.temiz-yayin-katmani": "Temiz yayın katmanı",
    "text.ControlCenter.cekilisin-yayin-uzerine-yerlestirilecek-gorunumu": "Çekilişin yayın üzerine yerleştirilecek görünümü.",
    "text.ControlCenter.oyunun-ayarlari-cekilis-kontrolleri-ve-tum": "Oyunun ayarları, çekiliş kontrolleri ve tüm önizlemeler tek yerde.",
    "text.ControlCenter.yeni-sekmede-acilir": "Yeni sekmede açılır",
    "text.AwardPreview.onizleme-icin-oyun-veya-yonetim-oturumu": "Önizleme için oyun veya yönetim oturumu gerekli.",
    "text.AwardPreview.ikramiye-onizlemesi": "İkramiye önizlemesi",
    "text.AwardPreview.geri-don": "Geri dön",
    "text.AwardPreview.gercek-oyun-bileseni-ve-bu-elin": "Gerçek oyun bileşeni ve bu elin sunum süreleri kullanılır. Önizleme para veya çekiliş işlemi yapmaz.",
    "text.AwardPreview.sonuc-gorunumu": "Sonuç görünümü",
    "text.AwardPreview.kazanan": "Kazanan",
    "text.AwardPreview.izleyici": "İzleyici",
    "text.AwardPreview.satilmamis-kazanan": "Satılmamış kazanan",
    "text.AwardPreview.kazanan-kart-sayisi": "Kazanan kart sayısı ",
    "text.AwardPreview.sn-bekleme": " sn bekleme · ",
    "text.AwardPreview.sn-gosterim": " sn gösterim · ",
    "text.AwardPreview.sn-devam-beklemesi-profil": " sn devam beklemesi. Profil: ",
    "text.AwardPreview.ses-mikslerini-karsilastir": "Ses mikslerini karşılaştır",
    "text.UxPreview.canli-tombala-x-ux-taslagi": "CANLI TOMBALA X · UX TASLAĞI",
    "text.UxPreview.oyuncu-ve-yonetim-akisi": "Oyuncu ve yönetim akışı",
    "text.UxPreview.gercek-bilesenlerle-yerel-onizleme-ornek-veriler": "Gerçek bileşenlerle yerel önizleme. Örnek veriler kullanılır; alım, ödeme, sunucu ayarı veya çekiliş işlemi yapılmaz.",
    "text.UxPreview.onizleme-alani": "Önizleme alanı",
    "text.UxPreview.oyuncu-ekranlari": "Oyuncu ekranları",
    "text.UxPreview.yonetim-ekranlari": "Yönetim ekranları",
    "text.UxPreview.oyuncu-senaryosu": "Oyuncu senaryosu",
    "text.UxPreview.ekran-genisligi": "Ekran genişliği",
    "text.UxPreview.mobil-yerlesim": "Mobil yerleşim",
    "text.UxPreview.web-yerlesimi": "Web yerleşimi",
    "text.UxPreview.kurallar-ve-limitler-ekraninda-taslak-kaydetme": "Kurallar ve limitler ekranında taslak kaydetme ve etkinleştirme adımları sayfa belleğinde denenebilir. Diğer başlıklar, birlikte inceleyeceğimiz ekran ve işlem akışı taslaklarıdır.",
    "text.UxPreview.ekran-adresi": "Ekran adresi: ",
    "text.UxPreview.bu-bolum-henuz-gorsel-islevsel-kabulu": " · Bu bölüm henüz görsel/işlevsel kabulü tamamlanmış ekran değildir.",
    "text.UxPreview.bu-onizlemede-senaryolar-ustteki-secim-alanindan": "Bu önizlemede senaryolar üstteki seçim alanından açılır. Gerçek oyunda bu menü kartlara, sonuçlara ve kurallara ulaşır.",
    "text.UxPreview.kart-secimi": "Kart seçimi",
    "text.UxPreview.cekilis-sonuclandi": "Çekiliş sonuçlandı",
    "text.UxPreview.satis-kapandi": "Satış kapandı",
    "text.UxPreview.canli-cekilis": "Canlı çekiliş",
    "text.UxPreview.normal-odemeler-baska-kazananlarla-bolunmez-ayni": "Normal ödemeler başka kazananlarla bölünmez. Aynı kart birden fazla aşamayı kazanırsa ödemeler toplanır.",
    "text.UxPreview.hizli-sec": "Hızlı seç",
    "text.UxPreview.splash-ve-sesi-dene": "Splash ve sesi dene",
    "text.UxPreview.sn-once": " sn önce · ",
    "text.UxPreview.sn-gosterim": " sn gösterim · ",
    "text.UxPreview.sn-sonra": " sn sonra",
    "text.UxPreview.ornek-kismi-alim-ilk-kart-kabul": "Örnek kısmi alım: ilk kart kabul edildi. İkinci kartta bakiye yetersiz; bu kart için yeni bahis oluşmadı.",
    "text.UxPreview.sonraki-cekilisin-numarasi-limitleri-ve-carpanlari": "Sonraki çekilişin numarası, limitleri ve çarpanları gösterilir. Seçim yeni el için ancak tekrar SATIN AL denildiğinde gönderilir.",
    "text.UxPreview.sonraki-elin-kosullarini-gor": "Sonraki elin koşullarını gör",
    "text.UxPreview.bu-cekiliste-satis-kapandi-gonderilmemis-secimin": "Bu çekilişte satış kapandı. Gönderilmemiş seçimin korunuyor.",
    "text.UxPreview.tombala-satilmamis-kartta-sonuclandi-jp-kosulu": "Tombala satılmamış kartta sonuçlandı. JP koşulu da oluştuğu için bu örnekte JP havuzunun tamamı devrediyor.",
    "text.UxPreview.ayni-islem-kimligi-sorgulanir-yeni-tahsilat": "Aynı işlem kimliği sorgulanır. Yeni tahsilat veya yeni satın alma başlatılmaz.",
    "text.UxPreview.onizleme-alimi-gercek-tahsilat-yapilmadi-kabul": "Önizleme alımı: gerçek tahsilat yapılmadı. Kabul, kısmi alım ve belirsiz yanıt görünümlerini üstteki senaryolardan inceleyebilirsin.",
    "text.UxPreview.akis-aciklamasi": "Akış açıklaması",
    "text.Accounting.sirada": "Sırada",
    "text.Accounting.tahsilat-gonderildi": "Tahsilat gönderildi",
    "text.Accounting.tahsilat-sorgulaniyor": "Tahsilat sorgulanıyor",
    "text.Accounting.kart-kabulu-bekleniyor": "Kart kabulü bekleniyor",
    "text.Accounting.kart-kabul-edildi": "Kart kabul edildi",
    "text.Accounting.alinamadi": "Alınamadı",
    "text.Accounting.iade-bekliyor": "İade bekliyor",
    "text.Accounting.iade-edildi": "İade edildi",
    "text.Accounting.mutabakat-gerekli": "Mutabakat gerekli",
    "text.Accounting.kart-alimi": "Kart alımı",
    "text.Accounting.kazanc-sonuc": "Kazanç / sonuç",
    "text.Accounting.iade": "İade",
    "text.Accounting.satis-bildirimi": "Satış bildirimi",
    "text.Accounting.kayip-bildirimi": "Kayıp bildirimi",
    "text.Accounting.islem-listesi-alinamadi-yeniden-deneyebilirsin": "İşlem listesi alınamadı. Yeniden deneyebilirsin.",
    "text.Accounting.bitis-tarihi-baslangic-tarihinden-once-olamaz": "Bitiş tarihi başlangıç tarihinden önce olamaz.",
    "text.Accounting.islem-tekrar-siraya-alinamadi": "İşlem tekrar sıraya alınamadı.",
    "text.Accounting.islem-ayni-kimlikle-yeniden-kontrol-icin": "İşlem aynı kimlikle yeniden kontrol için sıraya alındı.",
    "text.Accounting.yonetim-merkezi": "Yönetim merkezi",
    "text.Accounting.bayi-islemleri": "Bayi işlemleri",
    "text.Accounting.tahsilat-kazanc-ve-iadeleri-takip-et": "Tahsilat, kazanç ve iadeleri takip et; işlem detaylarına ulaş.",
    "text.Accounting.yenile": "Yenile",
    "text.Accounting.son-guncelleme": "Son güncelleme ",
    "text.Accounting.islemler-yukleniyor": "İşlemler yükleniyor",
    "text.Accounting.islem-filtreleri": "İşlem filtreleri",
    "text.Accounting.islem-ara": "İşlem ara",
    "text.Accounting.oyuncu-bilet-cekilis-veya-islem-no": "Oyuncu, bilet, çekiliş veya işlem no",
    "text.Accounting.bayi": "Bayi",
    "text.Accounting.tum-bayiler": "Tüm bayiler",
    "text.Accounting.islem-turu": "İşlem türü",
    "text.Accounting.tum-islemler": "Tüm işlemler",
    "text.Accounting.durum": "Durum",
    "text.Accounting.tum-durumlar": "Tüm durumlar",
    "text.Accounting.bekleyen-islemler": "Bekleyen işlemler",
    "text.Accounting.baslangic-tarihi": "Başlangıç tarihi",
    "text.Accounting.bitis-tarihi": "Bitiş tarihi",
    "text.Accounting.tarih-filtresi-islemin-olusturulma-zamanini-kullanir": "Tarih filtresi işlemin oluşturulma zamanını kullanır.",
    "text.Accounting.temizle": "Temizle",
    "text.Accounting.filtrele": "Filtrele",
    "text.Accounting.bayi-islem-listesi": "Bayi işlem listesi",
    "text.Accounting.arama-sonuclari": "Arama sonuçları",
    "text.Accounting.bekleyen": "Bekleyen: ",
    "text.Accounting.mutabakat-gerekli-2": "Mutabakat gerekli: ",
    "text.Accounting.sayfada": "Sayfada",
    "text.Accounting.sayfadaki-islem-sayisi": "Sayfadaki işlem sayısı",
    "text.Accounting.islemler-yukleniyor-2": "İşlemler yükleniyor…",
    "text.Accounting.aramana-uygun-islem-bulunamadi": "Aramana uygun işlem bulunamadı.",
    "text.Accounting.henuz-bayi-islemi-yok": "Henüz bayi işlemi yok.",
    "text.Accounting.filtreleri-degistirerek-yeniden-arayabilirsin": "Filtreleri değiştirerek yeniden arayabilirsin.",
    "text.Accounting.yeni-tahsilat-kazanc-ve-iadeler-burada": "Yeni tahsilat, kazanç ve iadeler burada listelenecek.",
    "text.Accounting.filtreleri-temizle": "Filtreleri temizle",
    "text.Accounting.en-yeni-islem-once-detay-dugmesi": "En yeni işlem önce; detay düğmesi tüm kimlikleri açar.",
    "text.Accounting.tarih-bilet": "Tarih / bilet",
    "text.Accounting.oyuncu-bayi": "Oyuncu / bayi",
    "text.Accounting.islem": "İşlem",
    "text.Accounting.detay": "Detay",
    "text.Accounting.bilet": "Bilet ",
    "text.Accounting.bayi-2": "Bayi ",
    "text.Accounting.sonuc": "Sonuç",
    "text.Accounting.detayini-kapat": "detayını kapat",
    "text.Accounting.detayini-ac": "detayını aç",
    "text.Accounting.islem-detayi": "İşlem detayı",
    "text.Accounting.son-kontrol": "Son kontrol: ",
    "text.Accounting.tekrar": " tekrar",
    "text.Accounting.para-hareketi-henuz-kesinlesmedi": "Para hareketi henüz kesinleşmedi. ",
    "text.Accounting.son-kayit": "Son kayıt",
    "text.Accounting.asamasindan-ayni-islem-kimligiyle-kontrol-edilir": " aşamasından aynı işlem kimliğiyle kontrol edilir.",
    "text.Accounting.oyuncu-kimligi": "Oyuncu kimliği",
    "text.Accounting.bayi-uye-no": "Bayi üye no",
    "text.Accounting.cekilis-kart": "Çekiliş / kart",
    "text.Accounting.gonderilen-islem-no": "Gönderilen işlem no",
    "text.Accounting.bayi-tahsilat-no": "Bayi tahsilat no",
    "text.Accounting.bayi-odeme-iade-no": "Bayi ödeme / iade no",
    "text.Accounting.sonuc-kodu": "Sonuç kodu",
    "text.Accounting.siraya-aliniyor": "Sıraya alınıyor…",
    "text.Accounting.ayni-islemle-yeniden-kontrol-et": "Aynı işlemle yeniden kontrol et",
    "text.Accounting.islem-2": " işlem",
    "text.Accounting.yukleniyor": " · Yükleniyor…",
    "text.Accounting.islem-sayfalari": "İşlem sayfaları",
    "text.Accounting.onceki-sayfa": "Önceki sayfa",
    "text.Accounting.sonraki-sayfa": "Sonraki sayfa",
    "text.ExperienceSettings.ms": "ms",
    "text.ExperienceSettings.yonetim-listesi-baslangic-adedi": "Yönetim listesi başlangıç adedi",
    "text.ExperienceSettings.kayit": "kayıt",
    "text.ExperienceSettings.jackpot-hareketleri-listesi-acildiginda-kullanilir": "Jackpot hareketleri listesi açıldığında kullanılır.",
    "text.ExperienceSettings.bekleyen-odeme-durumunu-yenileme": "Bekleyen ödeme durumunu yenileme",
    "text.ExperienceSettings.sonuc-ekrani-acikken-teyit-bekleyen-kazanc": "Sonuç ekranı açıkken teyit bekleyen kazanç ve iadeler için.",
    "text.NotificationSettings.guncel-bildirim-ayarlari-yuklendi": "Güncel bildirim ayarları yüklendi.",
    "text.NotificationSettings.bildirimler-surum": "Bildirimler sürüm ",
    "text.NotificationSettings.olarak-kaydedildi": " olarak kaydedildi.",
    "text.NotificationSettings.bildirimler": "Bildirimler",
    "text.NotificationSettings.oyun-ici-mesajlari-duzenleyin-dort-ortak": "Oyun içi mesajları düzenleyin, dört ortak temayı önizleyin ve bildirim ayarlarını önceki bir sürüme döndürün.",
    "text.NotificationSettings.mesajlarin-ne-zaman-cikacagi-ve-islem": "Mesajların ne zaman çıkacağı ve işlem sonuçları oyun akışından gelir. İkonlar bilgi, başarı, uyarı ve hata türüne bağlıdır.",
    "text.NotificationSettings.bildirimler-yuklenemedi": "Bildirimler yüklenemedi.",
    "text.NotificationSettings.bildirimler-yukleniyor": "Bildirimler yükleniyor…",
    "text.NotificationSettings.yeniden-dene": "Yeniden dene",
    "text.NotificationSettings.surum": "Sürüm ",
    "text.NotificationSettings.metin": " metin",
    "text.NotificationSettings.guncel-ayarlari-yukle": "Güncel ayarları yükle",
    "text.NotificationSettings.kaydedilmemis-degisiklikler": "Kaydedilmemiş değişiklikler",
    "text.NotificationSettings.degisiklikleri-geri-al": "Değişiklikleri geri al",
    "text.NotificationSettings.bildirim-metinleri": "Bildirim metinleri",
    "text.NotificationSettings.bildirim-ara": "Bildirim ara",
    "text.NotificationSettings.metin-ekran-veya-bildirim-adi": "Metin, ekran veya bildirim adı",
    "text.NotificationSettings.kullanim-alani": "Kullanım alanı",
    "text.NotificationSettings.tumu": "Tümü",
    "text.NotificationSettings.bildirim-listesi": "Bildirim listesi",
    "text.NotificationSettings.aramana-uygun-bildirim-yok": "Aramana uygun bildirim yok.",
    "text.NotificationSettings.bildirim-metni": "Bildirim metni",
    "text.NotificationSettings.sistemden-gelen-alanlar": "Sistemden gelen alanlar: ",
    "text.NotificationSettings.bu-alanlari-metinde-koruyun": ". Bu alanları metinde koruyun.",
    "text.NotificationSettings.bu-metin-degisken-kullanmaz": "Bu metin değişken kullanmaz.",
    "text.NotificationSettings.gosterim-ayarlari": "Gösterim ayarları",
    "text.NotificationSettings.gosterim-bicimi": "Gösterim biçimi",
    "text.NotificationSettings.ekranin-standart-duzeni": "Ekranın standart düzeni",
    "text.NotificationSettings.kompakt-bildirim": "Kompakt bildirim",
    "text.NotificationSettings.genis-bildirim": "Geniş bildirim",
    "text.NotificationSettings.kapatma-dugmesi-goster": " Kapatma düğmesi göster",
    "text.NotificationSettings.yardimci-bildirimi-goster": " Yardımcı bildirimi göster",
    "text.NotificationSettings.bu-bildirim-islem-veya-ekran-durumunu": "Bu bildirim işlem veya ekran durumunu açıklar; tamamen devre dışı bırakılamaz.",
    "text.NotificationSettings.bildirim-yukarida-belirtilen-kullanim-alaninda-gosterilir": " Bildirim yukarıda belirtilen kullanım alanında gösterilir.",
    "text.NotificationSettings.bu-metin-bir-islem-bildirimini-tamamlar": "Bu metin bir işlem bildirimini tamamlar. Ayrı konumu veya kapanma süresi yoktur; ilgili işlemin bildirimiyle birlikte gösterilir.",
    "text.NotificationSettings.onizleme-duzeni": "Önizleme düzeni",
    "text.NotificationSettings.satir-ici-pencere": "Satır içi / pencere",
    "text.NotificationSettings.gecis-ekrani": "Geçiş ekranı",
    "text.NotificationSettings.onizlemeyi-yeniden-goster": "Önizlemeyi yeniden göster",
    "text.NotificationSettings.bu-yardimci-bildirim-kapali": "Bu yardımcı bildirim kapalı.",
    "text.NotificationSettings.secilen-eski-surumun-onizlemesi": "Seçilen eski sürümün önizlemesi.",
    "text.NotificationSettings.kaydetmeden-onceki-gorunum": "Kaydetmeden önceki görünüm.",
    "text.NotificationSettings.sayi-cekilis-ve-tutar-alanlari-burada": " Sayı, çekiliş ve tutar alanları burada örnek değerlerdir.",
    "text.NotificationSettings.ortak-bildirim-temalari": "Ortak bildirim temaları",
    "text.NotificationSettings.her-turun-zemini-yazisi-ve-ikonu": "Her türün zemini, yazısı ve ikonu bütün oyun ekranlarında aynı temayı kullanır.",
    "text.NotificationSettings.yazi": "Yazı",
    "text.NotificationSettings.ikon": "İkon",
    "text.NotificationSettings.yazi-2": "yazı",
    "text.NotificationSettings.degisiklik-gerekcesi": "Değişiklik gerekçesi",
    "text.NotificationSettings.bu-degisikligi-neden-yapiyorsunuz": "Bu değişikliği neden yapıyorsunuz?",
    "text.NotificationSettings.metindeki-degiskenleri-kontrol-edin": " metindeki değişkenleri kontrol edin: ",
    "text.NotificationSettings.bildirimleri-kaydet": "Bildirimleri kaydet",
    "text.NotificationSettings.bildirim-surum-gecmisi": "Bildirim sürüm geçmişi",
    "text.NotificationSettings.onceki-bir-gorunum-surumunun-yalniz-bildirim": "Önceki bir görünüm sürümünün yalnız bildirim alanları geri alınır. Kartlar, yayın ve oyun ayarları korunur. Eski sürümde bulunmayan alanlar güncel kalır.",
    "text.NotificationSettings.onceki-surumler": "Önceki sürümler",
    "text.NotificationSettings.metin-2": " metin, ",
    "text.NotificationSettings.tema-alani": " tema alanı, ",
    "text.NotificationSettings.gosterim-ayari-degisecek": " gösterim ayarı değişecek",
    "text.NotificationSettings.basari-mesaji-suresi-de-degisecek": "; başarı mesajı süresi de değişecek",
    "text.NotificationSettings.ustte-secili-mesajin-eski-gorunumunu-inceleyebilirsiniz": ". Üstte seçili mesajın eski görünümünü inceleyebilirsiniz.",
    "text.NotificationSettings.secilen-bildirim-surumunu-uygula": "Seçilen bildirim sürümünü uygula",
    "text.NotificationSettings.guncel-onizlemeye-don": "Güncel önizlemeye dön",
    "text.XAnalysis.ikramiye-matematigi": "İkramiye matematiği",
    "text.XAnalysis.120-gercek-kart-ortak-top-sirasi": "120 gerçek kart, ortak top sırası. Satılmamış kartlar da yarışır. Beraber kazananlar tam çarpan alır; aynı kartın farklı aşama ödemeleri toplanır.",
    "text.XAnalysis.normal-geri-odeme-kartlarin-kazanma-olasiliklari": "Normal geri ödeme = kartların kazanma olasılıkları × ilgili çarpanlar. Çoklu kazananlar ve aşamalar arasındaki ilişki aynı simülasyonda hesaplanır. Jackpot bu orana dahil değildir. Bu bir tahmindir; üretim çarpanı onayı değildir.",
    "text.XAnalysis.ornek-cekilis-sayisi": "Örnek çekiliş sayısı",
    "text.XAnalysis.analiz-tohumu": "Analiz tohumu",
    "text.XAnalysis.bahis-dagilimi": "Bahis dağılımı",
    "text.XAnalysis.120-kartta-esit-tutar": "120 kartta eşit tutar",
    "text.XAnalysis.etkin-elin-kabul-edilmis-bahisleri": "Etkin elin kabul edilmiş bahisleri",
    "text.XAnalysis.analizi-calistir": "Analizi çalıştır",
    "text.XAnalysis.raporu-indir": "Raporu indir",
    "text.XAnalysis.profil": "Profil: ",
    "text.XAnalysis.cekilis": " çekiliş · ",
    "text.XAnalysis.kabul-edilmis-satis-agirliklari": "Kabul edilmiş satış ağırlıkları",
    "text.XAnalysis.sn": " sn",
    "text.XAnalysis.normal-geri-odeme": "Normal geri ödeme",
    "text.XAnalysis.95-yaklasik-guven-araligi": "%95 yaklaşık güven aralığı: ",
    "text.XAnalysis.jp-kosuluna-erisme": "JP koşuluna erişme",
    "text.XAnalysis.en-gec": "En geç ",
    "text.XAnalysis.top-satin-alinma-sartindan-ve-jp": ". top. Satın alınma şartından ve JP ödeme miktarından bağımsız.",
    "text.XAnalysis.hedef-rtp-icin-carpan-onerisi": "Hedef RTP için çarpan önerisi",
    "text.XAnalysis.normal-hedef": "Normal hedef: %",
    "text.XAnalysis.ayri-jp-katkisi": " · Ayrı JP katkısı: %",
    "text.XAnalysis.oneri-etkin-kurallari-kendiliginden-degistirmez": ". Öneri etkin kuralları kendiliğinden değiştirmez.",
    "text.XAnalysis.asama": "Aşama",
    "text.XAnalysis.onerilen-carpan": "Önerilen çarpan",
    "text.XAnalysis.normal-rtp-katkisi": "Normal RTP katkısı",
    "text.XAnalysis.normal-toplam": "Normal toplam",
    "text.XAnalysis.95-yaklasik-aralik": " · %95 yaklaşık aralık: %",
    "text.XAnalysis.jp-katkisi-dahil-fonlanan-oran": "JP katkısı dahil fonlanan oran: %",
    "text.XAnalysis.devreden-jp-nedeniyle-belirli-donemde-fiilen": ". Devreden JP nedeniyle belirli dönemde fiilen ödenen oran farklı olabilir. Aşama ağırlıkları ve yuvarlama adımı oyun ayarlarından değişir.",
    "text.XAnalysis.taslak-kaydedildi": "Taslak kaydedildi. ",
    "text.XAnalysis.incele-ve-etkinlestir": "İncele ve etkinleştir →",
    "text.XAnalysis.taslaga-aktarma-gerekcesi": "Taslağa aktarma gerekçesi",
    "text.XAnalysis.carpanlari-taslaga-aktar": "Çarpanları taslağa aktar",
    "text.XAnalysis.asamalar-ve-ayni-topta-coklu-kazananlar": "Aşamalar ve aynı topta çoklu kazananlar",
    "text.XAnalysis.carpan": "Çarpan",
    "text.XAnalysis.ort-kazanan-kart": "Ort. kazanan kart",
    "text.XAnalysis.birden-fazla-kazanan": "Birden fazla kazanan",
    "text.XAnalysis.gozlenen-en-cok": "Gözlenen en çok",
    "text.XAnalysis.normal-geri-odemeye-katki": "Normal geri ödemeye katkı",
    "text.XAnalysis.coklu-kazanma-dagilimi": "Çoklu kazanma dağılımı",
    "text.XAnalysis.kazanan-kart-sayisi-cekilis-sayisi": "Kazanan kart sayısı → çekiliş sayısı",
    "text.XAnalysis.kart-basina-olasiliklar-ve-normal-geri": "Kart başına olasılıklar ve normal geri ödeme",
    "text.XAnalysis.her-kartin-orani-o-karta-yatirilan": "Her kartın oranı, o karta yatırılan tutara göredir. Kartların aynı top sırasını paylaşması nedeniyle eşit olasılıklı oldukları varsayılmaz. Aralıklar tek tek %95 tahmin aralıklarıdır; 120 kart için ortak garanti değildir.",
    "text.XAnalysis.kart-ara": "Kart ara",
    "text.XAnalysis.kart": "Kart",
    "text.XAnalysis.islem-yontemi": "İşlem yöntemi: ",
    "text.XAnalysis.katalog": " · Katalog: ",
    "text.XAnalysis.analiz-rng-si-oyun-cekilisini-etkilemez": ". Analiz RNG’si oyun çekilişini etkilemez. Sonuçlar örnekleme belirsizliği içerir; özellikle seyrek olaylarda daha fazla örnek gerekir.",
    "text.XCatalogDesigner.seriler-kaydedildi-incelemek-icin-seriyi-secebilirsin": "Seriler kaydedildi. İncelemek için seriyi seçebilirsin.",
    "text.XCatalogDesigner.uretim-ayarlari-kaydedildi": "Üretim ayarları kaydedildi.",
    "text.XCatalogDesigner.serisi-ve": " serisi ve ",
    "text.XCatalogDesigner.karti-silinsin-mi": " kartı silinsin mi?",
    "text.XCatalogDesigner.kart-serisi-silindi": "Kart serisi silindi.",
    "text.XCatalogDesigner.kart-serileri-ve-desenler": "Kart serileri ve desenler",
    "text.XCatalogDesigner.kart-serilerinin-sayi-dagilimini-incele-ve": "Kart serilerinin sayı dağılımını incele ve RTP simülatöründe karşılaştır. Buradaki seri seçimi etkin oyun kataloğunu değiştirmez.",
    "text.XCatalogDesigner.secili-seriyi-sil": "Seçili seriyi sil",
    "text.XCatalogDesigner.kart-serisi": "Kart serisi",
    "text.XCatalogDesigner.renk-grubu": "Renk grubu",
    "text.XCatalogDesigner.butun-renkler": "Bütün renkler",
    "text.XCatalogDesigner.bu-seriyi-simule-et": "Bu seriyi simüle et →",
    "text.XCatalogDesigner.sayi-dagilimi": "Sayı dağılımı: ",
    "text.XCatalogDesigner.kullanim": " kullanım",
    "text.XCatalogDesigner.hucre-90-sayi-asagidaki-degerler-secili": " hücre / 90 sayı. Aşağıdaki değerler seçili seriden hesaplanır. Bu denge, tek başına kazanma olasılıklarının eşitliğini kanıtlamaz.",
    "text.XCatalogDesigner.sayi": "Sayı",
    "text.XCatalogDesigner.toplam": "Toplam",
    "text.XCatalogDesigner.satir-1-2-3": "Satır 1 / 2 / 3",
    "text.XCatalogDesigner.120-kartlik-aday-seri-uretimi": "120 kartlık aday seri üretimi",
    "text.XCatalogDesigner.uretim-ayarlari": "Üretim ayarları",
    "text.XCatalogDesigner.uretilecek-seri-sayisi": "Üretilecek seri sayısı",
    "text.XCatalogDesigner.uretim-tohumu": "Üretim tohumu",
    "text.XCatalogDesigner.simulasyon-alt-siniri": "Simülasyon alt sınırı",
    "text.XCatalogDesigner.simulasyon-ust-siniri": "Simülasyon üst sınırı",
    "text.XCatalogDesigner.varsayilan-simulasyon-adedi": "Varsayılan simülasyon adedi",
    "text.XCatalogDesigner.karistirma-denemesi": "Karıştırma denemesi",
    "text.XCatalogDesigner.sayi-cifti-dengeleme-denemesi": "Sayı çifti dengeleme denemesi",
    "text.XCatalogDesigner.her-aday-seri-alti-renkte-yirmiser": "Her aday seri altı renkte yirmişer kart içerir. Üretim etkin SYM120 serisini değiştirmez. Aynı ayarlar ve tohum aynı seriyi üretir. Çift dengeleme, sayıların beraber tekrarını azaltır; sonuçlar ölçülmeden bir seriye “eşit olasılıklı” denmez.",
    "text.XCatalogDesigner.desen-adi": " desen adı",
    "text.XCatalogDesigner.her-kartta-rastgele-hucreler": " Her kartta rastgele hücreler",
    "text.XCatalogDesigner.value1-satir-value2-sutun-value3": "{value1}, satır {value2}, sütun {value3}",
    "text.XCatalogDesigner.satir-doluluklari": "Satır dolulukları: ",
    "text.XCatalogDesigner.her-satir-5-olmali": " · Her satır 5 olmalı.",
    "text.XCatalogDesigner.sutunlar-sirasiyla-1-9-10-19": "Sütunlar sırasıyla 1–9, 10–19, 20–29, 30–39, 40–49, 50–59, 60–69, 70–79 ve 80–90 aralıklarını kullanır. Her satırda 5 sayı bulunur. Desenler tercih edilen hücrelerdir; sayı dengesi ve kolon kuralı için yerleşimleri uyarlanır. Dikey sıralama zorunlu değildir.",
    "text.XCatalogDesigner.ayarlari-kaydet-ve": "Ayarları kaydet ve ",
    "text.XCatalogDesigner.seri-uret": " seri üret",
    "text.XCatalogDesigner.yalniz-ayarlari-kaydet": "Yalnız ayarları kaydet",
    "text.XCatalogDesigner.degisiklikleri-geri-al": "Değişiklikleri geri al",
    "text.XDrawControls.islem-kaydedildi": "İşlem kaydedildi.",
    "text.XDrawControls.cekilis-kontrolu": "Çekiliş kontrolü",
    "text.XDrawControls.yukleniyor": "Yükleniyor…",
    "text.XDrawControls.asama-sonuclari": "Aşama sonuçları",
    "text.XDrawControls.henuz-sonuclanan-asama-yok": "Henüz sonuçlanan aşama yok.",
    "text.XDrawControls.asama": "Aşama",
    "text.XDrawControls.kazanan-kartlar": "Kazanan kartlar",
    "text.XDrawControls.satilmis-satilmamis": "Satılmış / satılmamış",
    "text.XDrawControls.90-top": "/90 top · ",
    "text.XDrawControls.bagli": "Bağlı",
    "text.XDrawControls.baglanti-bekleniyor": "Bağlantı bekleniyor",
    "text.XDrawControls.satis-bitisi": "Satış bitişi: ",
    "text.XDrawControls.120-kart-yarisiyor-satilmayan-bir-kart": "120 kart yarışıyor. Satılmayan bir kart da aşamayı sonuçlandırabilir. Satış bitişi el açılırken belirlenir.",
    "text.XDrawControls.islem-gerekcesi": "İşlem gerekçesi",
    "text.XDrawControls.cekilise-devam-et": "Çekilişe devam et",
    "text.XDrawControls.cekilisi-duraklat": "Çekilişi duraklat",
    "text.XDrawControls.top-cekilmemis-eli-iptal-et": "Top çekilmemiş eli iptal et",
    "text.XDrawControls.duraklatma-satis-suresini-uzatmaz-iptal-edilen": "Duraklatma satış süresini uzatmaz. İptal edilen kabul edilmiş bahislerin iadeleri bayi kuyruğundan yürütülür.",
    "text.XDrawControls.yayin-katmanini-ac": "Yayın katmanını aç ↗",
    "text.XJackpotLedger.ilk-birikim-fonu": "İlk birikim fonu",
    "text.XJackpotLedger.isletmeden-karsilanan-taban": "İşletmeden karşılanan taban",
    "text.XJackpotLedger.satis-katkisi": "Satış katkısı",
    "text.XJackpotLedger.iptal-edilen-katki": "İptal edilen katkı",
    "text.XJackpotLedger.kazananlara-ayrilan": "Kazananlara ayrılan",
    "text.XJackpotLedger.onceki-elden-devir": "Önceki elden devir",
    "text.XJackpotLedger.sonraki-ele-devir": "Sonraki ele devir",
    "text.XJackpotLedger.jackpot-hareketleri": "Jackpot hareketleri",
    "text.XJackpotLedger.ilk-birikim-fonu-satis-katkilari-isletmeden": "İlk birikim fonu, satış katkıları, işletmeden karşılanan taban, ayrılan ikramiye ve devir. Kazananlara ayrılan tutarın bayiye teslim durumunu ",
    "text.XJackpotLedger.bayi-islemlerinden": "bayi işlemlerinden",
    "text.XJackpotLedger.izleyebilirsin": " izleyebilirsin.",
    "text.XJackpotLedger.cekilis": "Çekiliş",
    "text.XJackpotLedger.hareket-turu": "Hareket türü",
    "text.XJackpotLedger.tum-hareketler": "Tüm hareketler",
    "text.XJackpotLedger.sayfadaki-kayit-sayisi": "Sayfadaki kayıt sayısı",
    "text.XJackpotLedger.listeyi-yenile": "Listeyi yenile",
    "text.XJackpotLedger.yukleniyor": "Yükleniyor…",
    "text.XJackpotLedger.bu-elin-net-katkisi": "Bu elin net katkısı",
    "text.XJackpotLedger.sonraki-ele-aktarilan": "Sonraki ele aktarılan",
    "text.XJackpotLedger.bu-elde-kalan-fon": "Bu elde kalan fon",
    "text.XJackpotLedger.onceki-cekilisin-devri-henuz-kesinlesmedi-su": "Önceki çekilişin devri henüz kesinleşmedi; şu anda bu elin kaydedilmiş katkıları gösteriliyor.",
    "text.XJackpotLedger.toplamlar-secilen-cekilisin-butun-hareketlerini-kapsar": "Toplamlar seçilen çekilişin bütün hareketlerini kapsar. Profil: ",
    "text.XJackpotLedger.hareket": " hareket",
    "text.XJackpotLedger.zaman": "Zaman",
    "text.XJackpotLedger.tur": "Tür",
    "text.XJackpotLedger.referans": "Referans",
    "text.XJackpotLedger.bu-filtrede-hareket-bulunamadi": "Bu filtrede hareket bulunamadı.",
    "text.XJackpotLedger.hareket-sayfalari": "Hareket sayfaları",
    "text.XJackpotLedger.onceki": "Önceki",
    "text.XJackpotLedger.sonraki": "Sonraki",
    "text.XLaboratoryShared.rtp-simulatoru": "RTP simülatörü",
    "text.XLaboratoryShared.kart-serileri-ve-desenler": "Kart serileri ve desenler",
    "text.XLaboratoryShared.etkin-oyun-ayarlari": "Etkin oyun ayarları",
    "text.XLaboratoryShared.onceki": "← Önceki",
    "text.XLaboratoryShared.kayit": " kayıt",
    "text.XLaboratoryShared.sonraki": "Sonraki →",
    "text.XLaboratoryShared.seriler-hazirlaniyor": "Seriler hazırlanıyor",
    "text.XLaboratoryShared.cekilisler-hesaplaniyor": "Çekilişler hesaplanıyor",
    "text.XProfileReview.kayitli-taslagi-bundan-sonra-satisa-acilacak": " kayıtlı taslağı, bundan sonra satışa açılacak çekilişlerde kullanılacak. Aktif ve ön satışa açılmış çekilişlerin çarpanları, limitleri ve JP koşulları değişmeyecek.",
    "text.XProfileReview.ayar": "Ayar",
    "text.XProfileReview.etkin-deger": "Etkin değer",
    "text.XProfileReview.taslak-deger": "Taslak değer",
    "text.XProfileReview.etkin-profil-ile-islevsel-fark-yok": "Etkin profil ile işlevsel fark yok.",
    "text.XRtpReport.simulasyon-sonuclari": "Simülasyon sonuçları",
    "text.XRtpReport.cekilis-tohum": " çekiliş · Tohum ",
    "text.XRtpReport.sn": " sn. ",
    "text.XRtpReport.satis-kopyasi": "Satış kopyası: ",
    "text.XRtpReport.normal-rtp": "Normal RTP",
    "text.XRtpReport.hedef": "Hedef %",
    "text.XRtpReport.fark": " · fark ",
    "text.XRtpReport.puan": " puan",
    "text.XRtpReport.yaklasik-95-aralik": "Yaklaşık %95 aralık: ",
    "text.XRtpReport.bu-orneklemden-guvenilir-bir-aralik-hesaplanamadi": "Bu örneklemden güvenilir bir aralık hesaplanamadı; daha fazla çekiliş gerekli.",
    "text.XRtpReport.jp-dahil-odenen-rtp": "JP dahil ödenen RTP",
    "text.XRtpReport.normal-odeme-odenen-jp-satis": "(Normal ödeme + ödenen JP) / satış",
    "text.XRtpReport.katki-dahil-fonlanan-oran": "Katkı dahil fonlanan oran",
    "text.XRtpReport.normal-odeme-jp-katkisi-odenen-taban": "(Normal ödeme + JP katkısı + ödenen taban) / satış",
    "text.XRtpReport.toplam-satis": "Toplam satış",
    "text.XRtpReport.el-basina": "El başına ",
    "text.XRtpReport.farkli-satilmis-kart": " farklı satılmış kart · ",
    "text.XRtpReport.bahis": " bahis",
    "text.XRtpReport.120-kart-her-cekiliste-yaristi-normal": "120 kart her çekilişte yarıştı. Normal ödemelerde bütün kazanan bahisler tam çarpan aldı. RTP toplam para üzerinden hesaplandı; ana para ayrıca eklenmedi. Satış senaryosu: ",
    "text.XRtpReport.120-kartta-esit-bahis": "120 kartta eşit bahis",
    "text.XRtpReport.tek-elin-kabul-edilmis-bahisleri-her": "Tek elin kabul edilmiş bahisleri her örnekte tekrarlandı",
    "text.XRtpReport.elle-tanimlanan-dagilim-her-ornekte-tekrarlandi": "Elle tanımlanan dağılım her örnekte tekrarlandı",
    "text.XRtpReport.her-elde-yeni-rastgele-satis": "Her elde yeni rastgele satış",
    "text.XRtpReport.asama-bazinda-kazanimlar-ve-rtp": "Aşama bazında kazanımlar ve RTP",
    "text.XRtpReport.ikramiye": "İkramiye",
    "text.XRtpReport.carpan": "Çarpan",
    "text.XRtpReport.ort-kazanan-kart-el": "Ort. kazanan kart / el",
    "text.XRtpReport.ort-odeme-alan-kart-el": "Ort. ödeme alan kart / el",
    "text.XRtpReport.ort-kazanan-bahis-el": "Ort. kazanan bahis / el",
    "text.XRtpReport.birden-fazla-kart-kazanan-el": "Birden fazla kart kazanan el",
    "text.XRtpReport.toplam-odeme": "Toplam ödeme",
    "text.XRtpReport.rtp-katkisi": "RTP katkısı",
    "text.XRtpReport.toplam": "Toplam ",
    "text.XRtpReport.normal-toplam": "Normal toplam",
    "text.XRtpReport.ortak-kazanimlar-kac-karta-cikti": "Ortak kazanımlar: kaç karta çıktı?",
    "text.XRtpReport.1-2-3-kartin-ayni-asamayi": "1, 2, 3… kartın aynı aşamayı aynı topta kazandığı çekiliş sayıları. “Ödeme alan” sütunu satılmış kartları sayar; sıfır olabilir.",
    "text.XRtpReport.kart-sayisi": "Kart sayısı",
    "text.XRtpReport.kazanan-odeme-alan": "Kazanan / ödeme alan",
    "text.XRtpReport.en-cok-gozlenen": "En çok gözlenen: ",
    "text.XRtpReport.bu-gozlem-teorik-ust-sinir-degildir": ". Bu gözlem teorik üst sınır değildir.",
    "text.XRtpReport.hedef-rtp-icin-carpan-onerisi": "Hedef RTP için çarpan önerisi",
    "text.XRtpReport.normal-hedef": "Normal hedef %",
    "text.XRtpReport.jp-katkisi": " · JP katkısı %",
    "text.XRtpReport.asama-agirliklari": " · aşama ağırlıkları ",
    "text.XRtpReport.carpan-adimi": " · çarpan adımı ",
    "text.XRtpReport.bu-orneklemde": "Bu örneklemde %",
    "text.XRtpReport.rtp": " RTP",
    "text.XRtpReport.bu-orneklemde-onerinin-normal-rtp-si": "Bu örneklemde önerinin normal RTP'si: ",
    "text.XRtpReport.sonraki-bagimsiz-orneklem-farkli-sonuc-verebilir": ". Sonraki bağımsız örneklem farklı sonuç verebilir.",
    "text.XRtpReport.oneriyi-yeni": "Öneriyi yeni ",
    "text.XRtpReport.cekiliste-dogrula": " çekilişte doğrula",
    "text.XRtpReport.oneri-normal-rtp-icindir-jp-taban": "Öneri normal RTP içindir. JP taban ödemeleri normal RTP hedefine dahil değildir; toplam etki raporda ayrıca gösterilir. Doğrulama oyun profilini değiştirmez.",
    "text.XRtpReport.jackpot-devri-ve-odeme": "Jackpot devri ve ödeme",
    "text.XRtpReport.jackpot-ozeti": "Jackpot özeti",
    "text.XRtpReport.baslangic-birikimi": "Başlangıç birikimi",
    "text.XRtpReport.satislardan-katki": "Satışlardan katkı",
    "text.XRtpReport.satisin": "Satışın ",
    "text.XRtpReport.isletmeden-karsilanan-taban": "İşletmeden karşılanan taban",
    "text.XRtpReport.odenen-jp": "Ödenen JP",
    "text.XRtpReport.son-elde-kalan-devir": "Son elde kalan devir",
    "text.XRtpReport.jp-kosulu-olusan-el": "JP koşulu oluşan el",
    "text.XRtpReport.jp-odenen-el": "JP ödenen el",
    "text.XRtpReport.tum-kazananlari-satilmamis-jp-li-el": "Tüm kazananları satılmamış JP'li el",
    "text.XRtpReport.kosul-en-gec": "Koşul: en geç ",
    "text.XRtpReport.top-satilmamis-kazananlarin-esit-kart-payi": ". top. Satılmamış kazananların eşit kart payı devreder; kalan tutar hak sahibi bahislerin tutarına oranla ödenir. Başlangıç birikimi + katkı + ödenen taban = ödeme + kapanış. Sabit taban birikime tekrar eklenmez. Birikimin %",
    "text.XRtpReport.kadari-dagitima-acilir": " kadarı dağıtıma açılır, %",
    "text.XRtpReport.havuzda-kalir-jp-baslangic-tabani": " havuzda kalır. JP başlangıç tabanı ",
    "text.XRtpReport.baslangic-birikimi-ve-isletmenin-karsiladigi-taban": ". Başlangıç birikimi ve işletmenin karşıladığı taban nedeniyle JP dahil RTP satış katkısı oranından yüksek olabilir.",
    "text.XRtpReport.kart-bazinda-kazanimlar-ve-olasiliklar": "Kart bazında kazanımlar ve olasılıklar",
    "text.XRtpReport.kart-numarasi-ara": "Kart numarası ara",
    "text.XRtpReport.renk": "Renk",
    "text.XRtpReport.tumu": "Tümü",
    "text.XRtpReport.siralama": "Sıralama",
    "text.XRtpReport.kart-numarasi": "Kart numarası",
    "text.XRtpReport.kazanimi": " kazanımı",
    "text.XRtpReport.kartin-normal-rtp-si": "Kartın normal RTP'si",
    "text.XRtpReport.olasilik-ve-kart-rtp-si-o": "Olasılık ve kart RTP'si o karta bahis yapılırsa geçerlidir. Satılmamış kartta fiili ödeme sıfırdır. Hücrelerde kazanım adedi, oran ve tek kart için %95 Wilson aralığı gösterilir.",
    "text.XRtpReport.kart": "Kart",
    "text.XRtpReport.renk-gruplarinin-karsilastirmasi": "Renk gruplarının karşılaştırması",
    "text.XRtpReport.grup": "Grup",
    "text.XRtpReport.kart-adedi": "Kart adedi",
    "text.XRtpReport.kart-basina-ort-kazanim": " · kart başına ort. kazanım",
    "text.XRtpReport.cekilis-cekilis-sonuclar-ve-odemeler": "Çekiliş çekiliş sonuçlar ve ödemeler",
    "text.XRtpReport.kazanan-kart": "Kazanan kart",
    "text.XRtpReport.butun-kartlar": "Bütün kartlar",
    "text.XRtpReport.kazandigi-asama": "Kazandığı aşama",
    "text.XRtpReport.herhangi-bir-asama": "Herhangi bir aşama",
    "text.XRtpReport.cekilisler-yukleniyor": "Çekilişler yükleniyor…",
    "text.XRtpReport.el-satis": "El / satış",
    "text.XRtpReport.kart-2": " kart · ",
    "text.XRtpReport.top": ". top · ",
    "text.XRtpReport.kazanan": " kazanan",
    "text.XRtpReport.satilmamis": "Satılmamış",
    "text.XRtpReport.kosul-olustu": "Koşul oluştu",
    "text.XRtpReport.kosul-olusmadi": "Koşul oluşmadı",
    "text.XRtpReport.acilis": "Açılış ",
    "text.XRtpReport.katki": "Katkı ",
    "text.XRtpReport.isletme-tabani": "İşletme tabanı ",
    "text.XRtpReport.devir": "Devir ",
    "text.XRtpReport.dagilim-ve-sapma-raporu": "Dağılım ve sapma raporu",
    "text.XRtpReport.asagidaki-standart-sapma-120-kartin-gozlenen": "Aşağıdaki standart sapma, 120 kartın gözlenen kazanım sayılarının birbirinden ne kadar farklı olduğunu ölçer.",
    "text.XRtpReport.asama": "Aşama",
    "text.XRtpReport.ort-kazanim-kart": "Ort. kazanım / kart",
    "text.XRtpReport.en-az-en-cok": "En az–en çok",
    "text.XRtpReport.standart-sapma": "Standart sapma",
    "text.XRtpReport.degisim-katsayisi": "Değişim katsayısı",
    "text.XRtpReport.ortalamadan-en-buyuk-sapma": "Ortalamadan en büyük sapma",
    "text.XRtpReport.bu-rapor-esit-olasilik-sertifikasi-degildir": "Bu rapor eşit olasılık sertifikası değildir. 10.000 çekilişte kart başına sınırlı sayıda kazanım gözlenir; rastlantısal farklar beklenir. Sayı frekansının dengeli olması da tek başına yarıştaki kazanma şansını eşitlemez. Kart güven aralıkları tek tek hesaplanır; 120 kart için ortak %95 garanti değildir. Serileri birden fazla bağımsız çalışmada karşılaştır.",
    "text.XRtpReport.normal-rtp-guven-araligi-ortak-top": "Normal RTP güven aralığı ortak top sırasını, aşamalar arası ilişkiyi ve değişken satış hacmini içerir. JP'nin devreden havuzu nedeniyle dönemlik toplam RTP için aynı bağımsızlık varsayımıyla güven aralığı verilmez.",
    "text.XRtpReport.katalog": "Katalog ",
    "text.XRtpReport.profil": " · Profil ",
    "text.XRtpReport.sonuclar-gecicidir-bir-sonraki-analiz-veya": ". Sonuçlar geçicidir; bir sonraki analiz veya servis yeniden başlatması önceki detayları kaldırabilir.",
    "text.XRtpSimulator.rtp-simulatoru": "RTP simülatörü",
    "text.XRtpSimulator.kart-serisini-ve-satis-kosullarini-sec": "Kart serisini ve satış koşullarını seç. Çarpanlarla gerçekleşen RTP'yi ölç veya hedef RTP için aday çarpanları hesaplat. Tüm işlemler simülasyondur; oyun kataloğu, bahisleri ve etkin ayarları değişmez.",
    "text.XRtpSimulator.seri-ve-orneklem": "Seri ve örneklem",
    "text.XRtpSimulator.kart-serisi": "Kart serisi",
    "text.XRtpSimulator.cekilis-sayisi": "Çekiliş sayısı",
    "text.XRtpSimulator.tekrar-uretme-tohumu-istege-bagli": "Tekrar üretme tohumu (isteğe bağlı)",
    "text.XRtpSimulator.her-basista-yeni-rastgele-tohum": "Her basışta yeni rastgele tohum",
    "text.XRtpSimulator.bos-birakirsan-her-calisma-bagimsizdir-ayni": "Boş bırakırsan her çalışma bağımsızdır. Aynı tohum ve girdiler sonucu tekrar üretir.",
    "text.XRtpSimulator.rtp-hedefi-ve-normal-ikramiyeler": "RTP hedefi ve normal ikramiyeler",
    "text.XRtpSimulator.hedef-normal-rtp": "Hedef normal RTP (%)",
    "text.XRtpSimulator.onerilen-carpanlarin-adimi": "Önerilen çarpanların adımı",
    "text.XRtpSimulator.bahis-adimiyla-tam-kurus-odeme-olusturmali": "Bahis adımıyla tam kuruş ödeme oluşturmalı.",
    "text.XRtpSimulator.hedef-normal": "Hedef normal %",
    "text.XRtpSimulator.jp-katkisi": " + JP katkısı %",
    "text.XRtpSimulator.toplam-fonlama-hedefi": " = toplam fonlama hedefi ",
    "text.XRtpSimulator.carpani": " çarpanı",
    "text.XRtpSimulator.hedef-agirligi": " hedef ağırlığı",
    "text.XRtpSimulator.normal-rtp-hedefinin": "Normal RTP hedefinin %",
    "text.XRtpSimulator.i-bu-asamaya-ayrilir": "'i bu aşamaya ayrılır.",
    "text.XRtpSimulator.satis-katkisi": "Satış katkısı (%)",
    "text.XRtpSimulator.en-gec-kacinci-topta": "En geç kaçıncı topta?",
    "text.XRtpSimulator.jp-baslangic-tutari-sabit-taban-tl": "JP başlangıç tutarı / sabit taban (TL)",
    "text.XRtpSimulator.isletmenin-karsiladigi-ayri-taban-0-yapilabilir": "İşletmenin karşıladığı ayrı taban; 0 yapılabilir.",
    "text.XRtpSimulator.biriken-havuzdan-dagitilacak-pay": "Biriken havuzdan dağıtılacak pay (%)",
    "text.XRtpSimulator.havuzda-kalacak-pay": "Havuzda kalacak pay: %",
    "text.XRtpSimulator.satilmamis-kazananin-birikim-payi-da-devreder": ". Satılmamış kazananın birikim payı da devreder.",
    "text.XRtpSimulator.simulasyon-baslangicindaki-birikim-tl": "Simülasyon başlangıcındaki birikim (TL)",
    "text.XRtpSimulator.mevcut-birikim-alinir-sabit-taban-bu": "Mevcut birikim alınır; sabit taban bu tutara dahil değildir. Senaryo için değiştirebilirsin.",
    "text.XRtpSimulator.satis-senaryosu": "Satış senaryosu",
    "text.XRtpSimulator.bahis-dagilimi": "Bahis dağılımı",
    "text.XRtpSimulator.kartta-esit-bahis": " kartta eşit bahis",
    "text.XRtpSimulator.kart-bazinda-tutar-ve-oyuncu-sayisi": "Kart bazında tutar ve oyuncu sayısı",
    "text.XRtpSimulator.mevcut-elin-kabul-edilmis-bahisleri": "Mevcut elin kabul edilmiş bahisleri",
    "text.XRtpSimulator.her-elde-rastgele-satis": "Her elde rastgele satış",
    "text.XRtpSimulator.her-kartin-bahis-tutari": "Her kartın bahis tutarı",
    "text.XRtpSimulator.toplu-doldurma-tutari": "Toplu doldurma tutarı",
    "text.XRtpSimulator.tl": " (TL)",
    "text.XRtpSimulator.el-basina-en-az-bahis": "El başına en az bahis",
    "text.XRtpSimulator.el-basina-en-cok-bahis": "El başına en çok bahis",
    "text.XRtpSimulator.en-az-bahis-tutari-tl": "En az bahis tutarı (TL)",
    "text.XRtpSimulator.en-cok-bahis-tutari-tl": "En çok bahis tutarı (TL)",
    "text.XRtpSimulator.bahis-siniri": "Bahis sınırı: ",
    "text.XRtpSimulator.adim": " · adım ",
    "text.XRtpSimulator.her-karta-bir-bagimsiz-oyuncu-ayni": "Her karta bir bağımsız oyuncu aynı tutarı yatırır; dağılım bütün örneklerde aynıdır.",
    "text.XRtpSimulator.baslatma-anindaki-kabul-edilmis-bahisler-kopyalanir": "Başlatma anındaki kabul edilmiş bahisler kopyalanır ve her simülasyon elinde aynı dağılım kullanılır. Bekleyen/başarısız tahsilatlar dahil değildir. Bu bir tarihsel satış tahmini değildir.",
    "text.XRtpSimulator.her-elde-bahis-adedi-verilen-tam": "Her elde bahis adedi verilen tam sayı aralığından, kartlar eşit şansla, tutarlar izinli adımlardan eşit şansla seçilir. Her bahis bağımsız bir test oyuncusudur; aynı karta birden fazla oyuncu gelebilir. Bu dağılım gerçek müşteri davranışına dair bir varsayımdır.",
    "text.XRtpSimulator.hepsine-1-oyuncu-ve-tutari-uygula": "Hepsine 1 oyuncu ve tutarı uygula",
    "text.XRtpSimulator.tum-satislari-sifirla": "Tüm satışları sıfırla",
    "text.XRtpSimulator.sifir-oyuncu-satilmamis-kart-oyuncu-basina": "Sıfır oyuncu = satılmamış kart. Oyuncu başına tutar girilir; oyuncu sayısıyla çarpılır. Aynı karttaki oyuncular tam normal çarpanı alır.",
    "text.XRtpSimulator.kart": "Kart",
    "text.XRtpSimulator.oyuncu-sayisi": "Oyuncu sayısı",
    "text.XRtpSimulator.oyuncu-basina-tl": "Oyuncu başına TL",
    "text.XRtpSimulator.kart-toplami": "Kart toplamı",
    "text.XRtpSimulator.oyuncu-sayisi-2": " oyuncu sayısı",
    "text.XRtpSimulator.bahis-tl": " bahis TL",
    "text.XRtpSimulator.her-elin-toplam-satisi": "Her elin toplam satışı: ",
    "text.XRtpSimulator.cekilisi-simule-et-ve-carpan-oner": " çekilişi simüle et ve çarpan öner",
    "text.XRtpSimulator.seriler-saklanir-calisma-sonuclari-veritabanina-kaydedilmez": "Seriler saklanır; çalışma sonuçları veritabanına kaydedilmez. Aynı anda bir seri üretimi veya detaylı simülasyon çalışabilir.",
    "text.XRtpSimulator.tohumlu-calismanin-onerdigi-carpanlar-yeni-bagimsiz": " tohumlu çalışmanın önerdiği çarpanlar yeni bağımsız çekilişlerle doğrulanıyor. Hedefe tam eşit sonuç beklenmez; güven aralığı ve sapma birlikte değerlendirilir.",
    "text.XRtpSimulator.form-degisti-asagidaki-rapor-onceki-calismanin": "Form değişti. Aşağıdaki rapor önceki çalışmanın kendi ayarlarına aittir; yeniden simüle edene kadar güncellenmez.",
    "text.XServices.servislerin-ayar-yenilemesinde": "Servislerin ayar yenilemesinde",
    "text.XServices.muhasebe-servisi-yeniden-basladiginda": "Muhasebe servisi yeniden başladığında",
    "text.XServices.yeni-istekte": "Yeni istekte",
    "text.XServices.yeni-oturumda": "Yeni oturumda",
    "text.XServices.guncel-servis-ayarlari-yuklendi": "Güncel servis ayarları yüklendi.",
    "text.XServices.servis-ayarlari-surum": "Servis ayarları sürüm ",
    "text.XServices.olarak-kaydedildi": " olarak kaydedildi.",
    "text.XServices.tuketici-sayisinin-uygulanmasi-icin-muhasebe-servisi": " Tüketici sayısının uygulanması için muhasebe servisi yeniden başlatılmalı.",
    "text.XServices.servis-ayarlari": "Servis ayarları",
    "text.XServices.baglanti-sureleri-kuyruk-tuketimi-tekrar-araliklari": "Bağlantı süreleri, kuyruk tüketimi, tekrar aralıkları ve oturum sınırları. Bu ayarlar çekilişin çarpanlarını veya satışa açılmış elin koşullarını değiştirmez.",
    "text.XServices.jp-tutari-ve-satilan-kart-adetleri": "JP tutarı ve satılan kart adetleri ayrı yayın aralıkları kullanır. 3000 ms = 3 saniye, 5000 ms = 5 saniye. Satış adedi ayarı toplamı, alt CTA'yı ve kartların üzerindeki adetleri birlikte yönetir. Satın alma sonucu, kişisel kartlar ve oyun geçişleri bu süreleri beklemez.",
    "text.XServices.kritik-ayar": "Kritik ayar",
    "text.XServices.isaretli-ayarlar-oyun-akisini-tahsilat-iadeyi": " İşaretli ayarlar oyun akışını, tahsilat/iadeyi veya erişimi ciddi etkileyebilir. Değişiklik öncesinde etkisi test edilmeli. Bu işaret bir uyarıdır; alanlar düzenlenebilir.",
    "text.XServices.ayarlar-yuklenemedi": "Ayarlar yüklenemedi.",
    "text.XServices.yukleniyor": "Yükleniyor…",
    "text.XServices.surum": "Sürüm ",
    "text.XServices.son-degisiklik": "Son değişiklik: ",
    "text.XServices.calisma-parametreleri": "Çalışma parametreleri",
    "text.XServices.degisiklik-gerekcesi": "Değişiklik gerekçesi",
    "text.XServices.servis-ayarlarini-kaydet": "Servis ayarlarını kaydet",
    "text.XServices.guncel-ayarlari-yukle": "Güncel ayarları yükle",
    "text.XServices.alanlari-son-kayda-dondur": "Alanları son kayda döndür",
    "text.XServices.kaydedilmemis-degisiklikler": "Kaydedilmemiş değişiklikler",
    "text.XSettings.ayarlar-yuklenemedi": "Ayarlar yüklenemedi",
    "text.XSettings.ayarlar-etkinlestirildi": "Ayarlar etkinleştirildi",
    "text.XSettings.bundan-sonra-satisa-acilacak-cekilislerde-kullanilacak": "Bundan sonra satışa açılacak çekilişlerde kullanılacak. Devam eden ve önceden satışa açılmış çekilişlerde önceki ayarlar geçerli.",
    "text.XSettings.taslak-kaydedildi-henuz-oyunda-etkin-degil": "Taslak kaydedildi — henüz oyunda etkin değil",
    "text.XSettings.degisiklikleri-inceleyip-etkinlestirdiginde-yeni-acilacak-cekilislerde": "Değişiklikleri inceleyip etkinleştirdiğinde yeni açılacak çekilişlerde kullanılacak.",
    "text.XSettings.kayitli-taslak-kaldirildi": "Kayıtlı taslak kaldırıldı",
    "text.XSettings.guncel-ayarlar-yuklendi": "Güncel ayarlar yüklendi",
    "text.XSettings.etkin-ayarlar-degistirilmedi": "Etkin ayarlar değiştirilmedi.",
    "text.XSettings.form-en-son-kayitli-surumu-gosteriyor": "Form en son kayıtlı sürümü gösteriyor.",
    "text.XSettings.islem-tamamlanamadi": "İşlem tamamlanamadı",
    "text.XSettings.canli-tombala-x-ayarlari": "Canlı Tombala X ayarları",
    "text.XSettings.yukleniyor": "Yükleniyor…",
    "text.XSettings.ayar-bolumleri": "Ayar bölümleri",
    "text.XSettings.kurallar-ve-limitler": "Kurallar ve limitler",
    "text.XSettings.gorunum": "Görünüm",
    "text.XSettings.degisiklik-gecmisi": "Değişiklik geçmişi",
    "text.XSettings.ikramiye-matematigi": "İkramiye matematiği",
    "text.XSettings.kaydedilmemis-degisiklikler": "Kaydedilmemiş değişiklikler",
    "text.XSettings.kayitli-taslak-etkinlestirme-bekliyor": "Kayıtlı taslak · Etkinleştirme bekliyor",
    "text.XSettings.etkin-ayarlar": "Etkin ayarlar",
    "text.XSettings.form-kayitli-taslagi-gosteriyor-taslagi-kaydetmek": "Form kayıtlı taslağı gösteriyor. Taslağı kaydetmek tek başına oyundaki ayarları değiştirmez.",
    "text.XSettings.etkin": "Etkin: ",
    "text.XSettings.taslak": " · Taslak: ",
    "text.XSettings.test-profili-carpanlar-uretim-odeme-tablosu": "Test profili · Çarpanlar üretim ödeme tablosu değildir. ",
    "text.XSettings.120-kartin-tamami-yarisir-normal-carpan": "120 kartın tamamı yarışır. Normal çarpan bölünmez; aşama ödemeleri toplanır. Jackpot ayrı havuzdur.",
    "text.XSettings.satisa-acilmis-ellerin-degismez-kosullari": "Satışa açılmış ellerin değişmez koşulları",
    "text.XSettings.cekilis": "Çekiliş",
    "text.XSettings.durum": "Durum",
    "text.XSettings.carpanlar": "Çarpanlar",
    "text.XSettings.kart-tutari": "Kart tutarı",
    "text.XSettings.profil": "Profil",
    "text.XSettings.tl": " TL",
    "text.XSettings.son-100-yonetim-islemi": "Son 100 yönetim işlemi",
    "text.XSettings.zaman": "Zaman",
    "text.XSettings.islem": "İşlem",
    "text.XSettings.yonetici": "Yönetici",
    "text.XSettings.gerekce": "Gerekçe",
    "text.XSettings.surumler": "Sürümler",
    "text.XSettings.carpan-yatirilan-tutar-dahil-brut-odemedir": "Çarpan yatırılan tutar dahil brüt ödemedir. Aynı anda kazanan kart/oyuncu sayısıyla bölünmez. Bahis adımıyla birlikte tam kuruş üretmelidir.",
    "text.XSettings.gosterilen-jp-baslangic-tutari-biriken-havuzun": "Gösterilen JP = başlangıç tutarı + biriken havuzun %",
    "text.XSettings.kadari-havuzda-kalacak-pay": " kadarı. Havuzda kalacak pay: ",
    "text.XSettings.satilmamis-kazanan-kartlarin-dagitilmayan-birikim-payi": ". Satılmamış kazanan kartların dağıtılmayan birikim payı da havuzda kalır. Ödenen taban işletmenin ayrı yükümlülüğüdür.",
    "text.XSettings.degisiklik-gerekcesi": "Değişiklik gerekçesi",
    "text.XSettings.islem-suruyor": "İşlem sürüyor…",
    "text.XSettings.taslagi-kaydet": "Taslağı kaydet",
    "text.XSettings.taslagi-incele-ve-etkinlestir": "Taslağı incele ve etkinleştir",
    "text.XSettings.kayitli-taslagi-kaldir": "Kayıtlı taslağı kaldır",
    "text.XSettings.alanlari-son-kayda-dondur": "Alanları son kayda döndür",
    "text.XSettings.guncel-ayarlari-yukle": "Güncel ayarları yükle",
    "text.XSettings.incele-ve-etkinlestir": "İncele ve etkinleştir",
    "text.XSettings.taslak-kaydedildi": "Taslak kaydedildi",
    "text.XSettings.henuz-oyunda-etkin-degil": "Henüz oyunda etkin değil.",
    "text.XSettings.degisiklikleri-asagidan-kontrol-edip-etkinlestirebilirsin": " Değişiklikleri aşağıdan kontrol edip etkinleştirebilirsin.",
    "text.XSettings.etkinlestirme-gerekcesi": "Etkinleştirme gerekçesi",
    "text.XSettings.etkinlestiriliyor": "Etkinleştiriliyor…",
    "text.XSettings.yeni-cekilisler-icin-etkinlestir": "Yeni çekilişler için etkinleştir",
    "text.XSettings.taslak-olarak-birak": "Taslak olarak bırak",
    "text.MerchantLaunch.oyunu-bayi-sayfasindan-yeniden-acabilirsin": " Oyunu bayi sayfasından yeniden açabilirsin.",
    "text.MerchantLaunch.oturum-dogrulaniyor": "Oturum doğrulanıyor…",
    "text.MerchantLaunch.oyunu-bayi-sayfasindan-acabilirsin": "Oyunu bayi sayfasından açabilirsin.",
    "text.TestAutomation.otomatik-test-oyunculari": "Otomatik test oyuncuları",
    "text.TestAutomation.yalniz-burada-listelenen-ayri-test-hesaplari": "Yalnız burada listelenen ayrı test hesapları otomatik oynar. Alımlar aynı bayi tahsilat ve muhasebe kuyruğundan geçer.",
    "text.TestAutomation.acik": "Açık",
    "text.TestAutomation.kapali": "Kapalı",
    "text.TestAutomation.hesap": " hesap",
    "text.TestAutomation.son-alim": "Son alım: ",
    "text.TestAutomation.durumu-yenile": "Durumu yenile",
    "text.TestAutomation.otomatik-alim-ayarlari": "Otomatik alım ayarları",
    "text.TestSession.test-sunucusuna-ulasilamadi-tekrar-deneyebilirsin": "Test sunucusuna ulaşılamadı. Tekrar deneyebilirsin.",
    "text.TestSession.test-oturumun-sona-erdi-yeniden-giris": "Test oturumun sona erdi. Yeniden giriş yapabilirsin.",
    "text.TestSession.giris-yapilamadi-biraz-bekleyip-tekrar-deneyebilirsin": "Giriş yapılamadı. Biraz bekleyip tekrar deneyebilirsin.",
    "text.TestSession.cikis-yapilamadi-baglantini-kontrol-edip-tekrar": "Çıkış yapılamadı. Bağlantını kontrol edip tekrar deneyebilirsin.",
    "text.TestSession.canli-tombala": "Canlı Tombala",
    "text.TestSession.test-hesabinla-giris-yap": "Test hesabınla giriş yap",
    "text.TestSession.demo-ortami-sana-verilen-test-hesabini": "Demo ortamı · Sana verilen test hesabını kullan.",
    "text.TestSession.kullanici-adi": "Kullanıcı adı",
    "text.TestSession.sifre": "Şifre",
    "text.TestSession.giris-yapiliyor": "Giriş yapılıyor…",
    "text.TestSession.giris-yap": "GİRİŞ YAP",
    "text.TestSession.oturum-kontrol-ediliyor": "Oturum kontrol ediliyor…",
    "text.TestUsers.baslangic-bakiyesi": "Başlangıç bakiyesi",
    "text.TestUsers.demo-bakiye-eklendi": "Demo bakiye eklendi",
    "text.TestUsers.kart-alimi": "Kart alımı",
    "text.TestUsers.kazanc-sonuc": "Kazanç / sonuç",
    "text.TestUsers.iade": "İade",
    "text.TestUsers.test-hesabi-olusturuldu": "Test hesabı oluşturuldu.",
    "text.TestUsers.test-kullanicilari": "Test kullanıcıları",
    "text.TestUsers.hesaplar-ve-bakiyeler-yalnizca-bu-demo": "Hesaplar ve bakiyeler yalnızca bu demo ortamına aittir.",
    "text.TestUsers.liste-guncellendi": "Liste güncellendi.",
    "text.TestUsers.listeyi-yenile": "Listeyi yenile",
    "text.TestUsers.yeni-test-hesabi": "Yeni test hesabı",
    "text.TestUsers.kullanici-adi": "Kullanıcı adı",
    "text.TestUsers.test-bayisi": "Test bayisi",
    "text.TestUsers.bayi": "Bayi ",
    "text.TestUsers.bayi-oyuncu-kimligi": "Bayi oyuncu kimliği",
    "text.TestUsers.bossa-kullanici-adi-kullanilir": "Boşsa kullanıcı adı kullanılır",
    "text.TestUsers.sifre": "Şifre",
    "text.TestUsers.en-az-10-karakter": "En az 10 karakter",
    "text.TestUsers.baslangic-bakiyesi-tl": "Başlangıç bakiyesi (TL)",
    "text.TestUsers.hesap-olustur": "Hesap oluştur",
    "text.TestUsers.hesaplar": "Hesaplar ",
    "text.TestUsers.bayi-2": " · Bayi ",
    "text.TestUsers.hesap-ayrintilari-icin-listeden-bir-kullanici": "Hesap ayrıntıları için listeden bir kullanıcı seçin.",
    "text.TestUsers.oyuncu": " · Oyuncu ",
    "text.TestUsers.tarihinde-olusturuldu": " tarihinde oluşturuldu.",
    "text.TestUsers.hesap-pasiflestirildi-acik-oturumlar-kapatildi": "Hesap pasifleştirildi; açık oturumlar kapatıldı.",
    "text.TestUsers.hesap-aktiflestirildi": "Hesap aktifleştirildi.",
    "text.TestUsers.hesabi-pasiflestir": "Hesabı pasifleştir",
    "text.TestUsers.hesabi-aktiflestir": "Hesabı aktifleştir",
    "text.TestUsers.sifre-degistirildi-acik-oturumlar-kapatildi": "Şifre değiştirildi; açık oturumlar kapatıldı.",
    "text.TestUsers.yeni-sifre": "Yeni şifre",
    "text.TestUsers.sifreyi-degistir": "Şifreyi değiştir",
    "text.TestUsers.demo-bakiyesi-eklendi": "Demo bakiyesi eklendi.",
    "text.TestUsers.eklenecek-demo-bakiyesi-tl": "Eklenecek demo bakiyesi (TL)",
    "text.TestUsers.bakiye-ekle": "Bakiye ekle",
    "text.TestUsers.son-hareketler": "Son hareketler",
    "text.TestUsers.mevcut-siradaki-ve-saklanan-son-cekilisler": "Mevcut, sıradaki ve saklanan son çekilişler.",
    "text.TestUsers.yukleniyor": "Yükleniyor…",
    "text.TestUsers.henuz-hareket-yok": "Henüz hareket yok.",
    "text.TestUsers.cekilis": "Çekiliş #",
    "text.Chrome.cikis": "Çıkış",
    "copy.base": "Varsayılan metin",
    "copy.web": "Web",
    "copy.mobile": "Mobil",
    "copy.inheritHelp": "Web veya Mobil alanını boş bırakırsanız varsayılan metin kullanılır.",
    "copy.effective": "{viewport} ekranında görünecek metin",
    "copy.variables": "Sistem alanlarını koruyun: {variables}",
    "copy.noVariables": "Bu metin değişken kullanmaz.",
    "copy.tooLong": "En fazla {limit} karakter yazabilirsiniz.",
    "copy.variablesInvalid": "Gerekli değişkenleri koruyun: {variables}",
    "copy.previewViewport": "Önizleme cihazı",
    "copy.invalid": "Metin alanlarını kontrol edin.",
    "copy.defaultEmpty": "Varsayılan metin boş olamaz.",
    "page.playerTitle": "Canlı Tombala",
    "page.adminTitle": "Canlı Tombala · Yönetim",
    "schema.settings.rules.multipliers.firstLine.label": "1. Çinko",
    "schema.settings.rules.multipliers.firstLine.help": "",
    "schema.settings.rules.multipliers.firstLine.unit": "×",
    "schema.settings.rules.multipliers.firstLine.group": "Normal ikramiyeler",
    "schema.settings.rules.multipliers.secondLine.label": "2. Çinko",
    "schema.settings.rules.multipliers.secondLine.help": "",
    "schema.settings.rules.multipliers.secondLine.unit": "×",
    "schema.settings.rules.multipliers.secondLine.group": "Normal ikramiyeler",
    "schema.settings.rules.multipliers.fullHouse.label": "Tombala",
    "schema.settings.rules.multipliers.fullHouse.help": "",
    "schema.settings.rules.multipliers.fullHouse.unit": "×",
    "schema.settings.rules.multipliers.fullHouse.group": "Normal ikramiyeler",
    "schema.settings.rules.limits.minimumMinor.label": "En az kart tutarı",
    "schema.settings.rules.limits.minimumMinor.help": "",
    "schema.settings.rules.limits.minimumMinor.unit": "TL",
    "schema.settings.rules.limits.minimumMinor.group": "Bahis limitleri",
    "schema.settings.rules.limits.maximumPerCardMinor.label": "Oyuncunun bir karta yatırabileceği toplam",
    "schema.settings.rules.limits.maximumPerCardMinor.help": "Aynı oyuncunun aynı çekilişte aynı karta yaptığı tüm alımların toplam sınırı.",
    "schema.settings.rules.limits.maximumPerCardMinor.unit": "TL",
    "schema.settings.rules.limits.maximumPerCardMinor.group": "Bahis limitleri",
    "schema.settings.rules.limits.stepMinor.label": "Tutar adımı",
    "schema.settings.rules.limits.stepMinor.help": "",
    "schema.settings.rules.limits.stepMinor.unit": "TL",
    "schema.settings.rules.limits.stepMinor.group": "Bahis limitleri",
    "schema.settings.rules.limits.maximumCardsPerPurchase.label": "Tek işlemde kart sınırı",
    "schema.settings.rules.limits.maximumCardsPerPurchase.help": "",
    "schema.settings.rules.limits.maximumCardsPerPurchase.unit": "",
    "schema.settings.rules.limits.maximumCardsPerPurchase.group": "Bahis limitleri",
    "schema.settings.rules.limits.maximumOwnedCards.label": "Oyuncunun elde kart sınırı",
    "schema.settings.rules.limits.maximumOwnedCards.help": "",
    "schema.settings.rules.limits.maximumOwnedCards.unit": "",
    "schema.settings.rules.limits.maximumOwnedCards.group": "Bahis limitleri",
    "schema.settings.rules.jackpot.contributionPercent.label": "Satış katkısı",
    "schema.settings.rules.jackpot.contributionPercent.help": "",
    "schema.settings.rules.jackpot.contributionPercent.unit": "%",
    "schema.settings.rules.jackpot.contributionPercent.group": "Jackpot",
    "schema.settings.rules.jackpot.baseMinor.label": "JP başlangıç tutarı (sabit taban)",
    "schema.settings.rules.jackpot.baseMinor.help": "Biriken havuzdan ayrı garantili taban. 0 yapılabilir. Her JP sonucunda yalnız hak sahiplerine ödenen kısmı işletme karşılar; satılmamış pay birikime tekrar eklenmez.",
    "schema.settings.rules.jackpot.baseMinor.unit": "TL",
    "schema.settings.rules.jackpot.baseMinor.group": "Jackpot",
    "schema.settings.rules.jackpot.payoutPercent.label": "Biriken havuzdan gösterilecek ve dağıtılacak pay",
    "schema.settings.rules.jackpot.payoutPercent.help": "Yalnız biriken havuza uygulanır; sabit tabana uygulanmaz. Kalan yüzde havuzda devreder. Satılmamış kazanan kartların birikim payı da ayrıca devreder.",
    "schema.settings.rules.jackpot.payoutPercent.unit": "%",
    "schema.settings.rules.jackpot.payoutPercent.group": "Jackpot",
    "schema.settings.rules.jackpot.ballLimit.label": "Son hak kazandıran top",
    "schema.settings.rules.jackpot.ballLimit.help": "",
    "schema.settings.rules.jackpot.ballLimit.unit": "top",
    "schema.settings.rules.jackpot.ballLimit.group": "Jackpot",
    "schema.settings.rules.timings.salesSeconds.label": "Etkin elin satış süresi",
    "schema.settings.rules.timings.salesSeconds.help": "",
    "schema.settings.rules.timings.salesSeconds.unit": "sn",
    "schema.settings.rules.timings.salesSeconds.group": "Zamanlama",
    "schema.settings.rules.timings.preparingSeconds.label": "Çekiliş hazırlığı",
    "schema.settings.rules.timings.preparingSeconds.help": "Satış kapandıktan sonraki geri sayım. Başlangıç anonsu ve sonrasındaki bekleme bu süreye dahil değildir.",
    "schema.settings.rules.timings.preparingSeconds.unit": "sn",
    "schema.settings.rules.timings.preparingSeconds.group": "Zamanlama",
    "schema.settings.rules.timings.openingAnnouncementMilliseconds.label": "Başlangıç anonsu süresi",
    "schema.settings.rules.timings.openingAnnouncementMilliseconds.help": "Geri sayımdan sonra çalan başlangıç efekti ve konuşması için ayrılan süre. Mevcut ses dosyası için 2200 ms. Ses dosyası değişirse süresine uygun güncelleyin.",
    "schema.settings.rules.timings.openingAnnouncementMilliseconds.unit": "ms",
    "schema.settings.rules.timings.openingAnnouncementMilliseconds.group": "Zamanlama",
    "schema.settings.rules.timings.openingPauseMilliseconds.label": "Başlangıç anonsundan sonra bekleme",
    "schema.settings.rules.timings.openingPauseMilliseconds.help": "Anons için ayrılan süre bittikten ilk topa kadar sessiz bekleme. 1000 ms = 1 saniye. Sesi kapalı oyuncularda da aynı sunucu zamanlaması geçerlidir.",
    "schema.settings.rules.timings.openingPauseMilliseconds.unit": "ms",
    "schema.settings.rules.timings.openingPauseMilliseconds.group": "Zamanlama",
    "schema.settings.rules.timings.ballIntervalMilliseconds.label": "Top aralığı",
    "schema.settings.rules.timings.ballIntervalMilliseconds.help": "",
    "schema.settings.rules.timings.ballIntervalMilliseconds.unit": "ms",
    "schema.settings.rules.timings.ballIntervalMilliseconds.group": "Zamanlama",
    "schema.settings.rules.timings.popupDelayMilliseconds.label": "İkramiye öncesi işaretleme",
    "schema.settings.rules.timings.popupDelayMilliseconds.help": "",
    "schema.settings.rules.timings.popupDelayMilliseconds.unit": "ms",
    "schema.settings.rules.timings.popupDelayMilliseconds.group": "Zamanlama",
    "schema.settings.rules.timings.popupDurationMilliseconds.label": "İkramiye sahnesi",
    "schema.settings.rules.timings.popupDurationMilliseconds.help": "",
    "schema.settings.rules.timings.popupDurationMilliseconds.unit": "ms",
    "schema.settings.rules.timings.popupDurationMilliseconds.group": "Zamanlama",
    "schema.settings.rules.timings.continueDelayMilliseconds.label": "Sahneden sonra bekleme",
    "schema.settings.rules.timings.continueDelayMilliseconds.help": "",
    "schema.settings.rules.timings.continueDelayMilliseconds.unit": "ms",
    "schema.settings.rules.timings.continueDelayMilliseconds.group": "Zamanlama",
    "schema.settings.presentation.presenterName.label": "Sunucu adı",
    "schema.settings.presentation.presenterName.help": "",
    "schema.settings.presentation.presenterName.unit": "",
    "schema.settings.presentation.presenterName.group": "Sunum",
    "schema.settings.presentation.visualUrl.label": "Sunucu görseli",
    "schema.settings.presentation.visualUrl.help": "",
    "schema.settings.presentation.visualUrl.unit": "",
    "schema.settings.presentation.visualUrl.group": "Sunum",
    "schema.settings.presentation.presalesEnabled.label": "Canlı çekilişte sonraki el satışı",
    "schema.settings.presentation.presalesEnabled.help": "",
    "schema.settings.presentation.presalesEnabled.unit": "",
    "schema.settings.presentation.presalesEnabled.group": "Sunum",
    "schema.settings.presentation.resultHistoryCount.label": "Gösterilecek geçmiş el",
    "schema.settings.presentation.resultHistoryCount.help": "",
    "schema.settings.presentation.resultHistoryCount.unit": "",
    "schema.settings.presentation.resultHistoryCount.group": "Sunum",
    "schema.settings.simulation.enabled.label": "Test alımlarını aç",
    "schema.settings.simulation.enabled.help": "Yalnız sanal bayi hesapları; gerçek tahsilat kuyruğu kullanılır.",
    "schema.settings.simulation.enabled.unit": "",
    "schema.settings.simulation.enabled.group": "Sanal bayi otomasyonu",
    "schema.settings.simulation.intervalMilliseconds.label": "Alım aralığı",
    "schema.settings.simulation.intervalMilliseconds.help": "",
    "schema.settings.simulation.intervalMilliseconds.unit": "ms",
    "schema.settings.simulation.intervalMilliseconds.group": "Sanal bayi otomasyonu",
    "schema.settings.simulation.cardsPerPurchase.label": "Bir işlemde kart",
    "schema.settings.simulation.cardsPerPurchase.help": "",
    "schema.settings.simulation.cardsPerPurchase.unit": "",
    "schema.settings.simulation.cardsPerPurchase.group": "Sanal bayi otomasyonu",
    "schema.settings.simulation.amountMinor.label": "Kart başına tutar",
    "schema.settings.simulation.amountMinor.help": "",
    "schema.settings.simulation.amountMinor.unit": "kuruş",
    "schema.settings.simulation.amountMinor.group": "Sanal bayi otomasyonu",
    "schema.settings.simulation.maximumPlayers.label": "En çok test oyuncusu",
    "schema.settings.simulation.maximumPlayers.help": "",
    "schema.settings.simulation.maximumPlayers.unit": "",
    "schema.settings.simulation.maximumPlayers.group": "Sanal bayi otomasyonu",
    "schema.settings.simulation.stopBeforeCloseSeconds.label": "Satış kapanışına kala dur",
    "schema.settings.simulation.stopBeforeCloseSeconds.help": "",
    "schema.settings.simulation.stopBeforeCloseSeconds.unit": "sn",
    "schema.settings.simulation.stopBeforeCloseSeconds.group": "Sanal bayi otomasyonu",
    "schema.settings.analysis.minimumTrials.label": "En az örnek",
    "schema.settings.analysis.minimumTrials.help": "",
    "schema.settings.analysis.minimumTrials.unit": "",
    "schema.settings.analysis.minimumTrials.group": "Matematik analizi",
    "schema.settings.analysis.defaultTrials.label": "Varsayılan örnek",
    "schema.settings.analysis.defaultTrials.help": "",
    "schema.settings.analysis.defaultTrials.unit": "",
    "schema.settings.analysis.defaultTrials.group": "Matematik analizi",
    "schema.settings.analysis.maximumTrials.label": "En çok örnek",
    "schema.settings.analysis.maximumTrials.help": "",
    "schema.settings.analysis.maximumTrials.unit": "",
    "schema.settings.analysis.maximumTrials.group": "Matematik analizi",
    "schema.settings.analysis.defaultSeed.label": "Tekrarlanabilir analiz tohumu",
    "schema.settings.analysis.defaultSeed.help": "",
    "schema.settings.analysis.defaultSeed.unit": "",
    "schema.settings.analysis.defaultSeed.group": "Matematik analizi",
    "schema.settings.analysis.targetNormalPercent.label": "Hedef normal RTP",
    "schema.settings.analysis.targetNormalPercent.help": "",
    "schema.settings.analysis.targetNormalPercent.unit": "%",
    "schema.settings.analysis.targetNormalPercent.group": "Matematik analizi",
    "schema.settings.analysis.firstLineWeight.label": "1. Çinko ödeme bütçesi ağırlığı",
    "schema.settings.analysis.firstLineWeight.help": "",
    "schema.settings.analysis.firstLineWeight.unit": "",
    "schema.settings.analysis.firstLineWeight.group": "Matematik analizi",
    "schema.settings.analysis.secondLineWeight.label": "2. Çinko ödeme bütçesi ağırlığı",
    "schema.settings.analysis.secondLineWeight.help": "",
    "schema.settings.analysis.secondLineWeight.unit": "",
    "schema.settings.analysis.secondLineWeight.group": "Matematik analizi",
    "schema.settings.analysis.fullHouseWeight.label": "Tombala ödeme bütçesi ağırlığı",
    "schema.settings.analysis.fullHouseWeight.help": "",
    "schema.settings.analysis.fullHouseWeight.unit": "",
    "schema.settings.analysis.fullHouseWeight.group": "Matematik analizi",
    "schema.settings.analysis.multiplierStep.label": "Önerilen çarpan yuvarlama adımı",
    "schema.settings.analysis.multiplierStep.help": "",
    "schema.settings.analysis.multiplierStep.unit": "",
    "schema.settings.analysis.multiplierStep.group": "Matematik analizi",
    "schema.services.broadcastConcurrency.label": "Paralel yayın gönderimi",
    "schema.services.broadcastConcurrency.help": "Aynı anda yürütülen oyuncuya yayın gönderim işi sayısıdır; oyuna bağlı toplam oyuncu sayısını sınırlamaz. Çok düşük değer yayını geciktirebilir, çok yüksek değer sunucu yükünü artırabilir.",
    "schema.services.broadcastConcurrency.unit": "işlem",
    "schema.services.broadcastQueueCapacity.label": "Bekleyen oyun yayını sınırı",
    "schema.services.broadcastQueueCapacity.help": "Bekleyen oyun durumlarının kuyruk kapasitesidir; oyuncu sayısı değildir. Yetersiz kapasite yeniden eşitlemeyi, yüksek kapasite bellek kullanımını artırabilir.",
    "schema.services.broadcastQueueCapacity.unit": "durum",
    "schema.services.broadcastTimeoutMilliseconds.label": "Yavaş bağlantı yayın zaman aşımı",
    "schema.services.broadcastTimeoutMilliseconds.help": "Çok kısa süre sağlıklı bağlantıların kapanmasına, uzun süre yavaş bağlantıların gönderim işlerini meşgul etmesine yol açabilir.",
    "schema.services.broadcastTimeoutMilliseconds.unit": "ms",
    "schema.services.resultCacheRows.label": "Tamamlanmış çekiliş önbelleği kayıt bütçesi",
    "schema.services.resultCacheRows.help": "Veritabanı kayıtlarını silmez. Düşük değer tekrar okumaları, yüksek değer bellekte tutulan sonuç miktarını artırabilir.",
    "schema.services.resultCacheRows.unit": "kayıt ağırlığı (0: kapalı)",
    "schema.services.jackpotPublishMilliseconds.label": "JP tutarı yayın aralığı",
    "schema.services.jackpotPublishMilliseconds.unit": "ms",
    "schema.services.salesCountPublishMilliseconds.label": "Satılan kart adetleri yayın aralığı (toplam / CTA / kart)",
    "schema.services.salesCountPublishMilliseconds.unit": "ms",
    "schema.services.financialBatchMilliseconds.label": "Muhasebe kayıtlarını tek SQL işleminde birleştirme aralığı",
    "schema.services.financialBatchMilliseconds.help": "Muhasebe kayıtlarının bekleme süresini ve SQL işlem sıklığını etkiler.",
    "schema.services.financialBatchMilliseconds.unit": "ms",
    "schema.services.financialBatchSize.label": "Tek SQL işlemindeki en fazla muhasebe durum kaydı",
    "schema.services.financialBatchSize.help": "Muhasebe işlemlerinin toplu yazım büyüklüğünü ve veritabanı kilit süresini etkiler.",
    "schema.services.financialBatchSize.unit": "kayıt",
    "schema.services.acceptanceBatchMilliseconds.label": "Kart kabullerini tek SQL işleminde birleştirme aralığı",
    "schema.services.acceptanceBatchMilliseconds.help": "Kart kabulünün tamamlanma gecikmesini ve SQL işlem sıklığını etkiler; özellikle satış kapanışında test edilmelidir.",
    "schema.services.acceptanceBatchMilliseconds.unit": "ms",
    "schema.services.acceptanceBatchSize.label": "Tek SQL işlemindeki en fazla kart kabulü",
    "schema.services.acceptanceBatchSize.help": "Kart kabullerinin toplu yazım büyüklüğünü ve veritabanı kilit süresini etkiler.",
    "schema.services.acceptanceBatchSize.unit": "kart",
    "schema.services.purchaseCardConcurrency.label": "Bir alımda paralel kart işleme (bayi sınırını aşmaz)",
    "schema.services.purchaseCardConcurrency.help": "Sepette alınabilecek toplam kart adedi değildir. Aynı alımda birlikte işlenen kartların sayısını ve bayi tahsilat yükünü etkiler.",
    "schema.services.purchaseCardConcurrency.unit": "işlem",
    "schema.services.configurationRefreshMilliseconds.label": "Servislerin ayar yenileme aralığı",
    "schema.services.configurationRefreshMilliseconds.help": "Kaydedilen servis ayarlarının ne kadar sürede yeniden okunacağını belirler.",
    "schema.services.configurationRefreshMilliseconds.unit": "ms",
    "schema.services.clockTickMilliseconds.label": "Çekiliş saatinin en uzun kontrol aralığı",
    "schema.services.clockTickMilliseconds.help": "Yüksek değer satış kapanışı, geri sayım ve top çekme geçişlerini geciktirebilir; çok düşük değer kontrol yükünü artırır.",
    "schema.services.clockTickMilliseconds.unit": "ms",
    "schema.services.rngTimeoutMilliseconds.label": "RNG yanıt süresi sınırı",
    "schema.services.rngTimeoutMilliseconds.help": "Sayı üretme isteğinin bekleme süresidir. Uygun olmayan değer oyun akışını bekletebilir veya zaman aşımına düşürebilir.",
    "schema.services.rngTimeoutMilliseconds.unit": "ms",
    "schema.services.presenterTimeoutMilliseconds.label": "Sunucu sesi yanıt süresi sınırı",
    "schema.services.presenterTimeoutMilliseconds.help": "Anons hizmeti isteğinin zaman aşımını etkiler; ses ve geçiş akışıyla birlikte test edilmelidir.",
    "schema.services.presenterTimeoutMilliseconds.unit": "ms",
    "schema.services.gameApiTimeoutMilliseconds.label": "Muhasebe → oyun yanıt süresi sınırı",
    "schema.services.gameApiTimeoutMilliseconds.help": "Tahsilat sonrası oyun kabulü ve kurtarma isteklerinin bekleme süresini etkiler. Çok kısa süre gereksiz tekrar işlemleri oluşturabilir.",
    "schema.services.gameApiTimeoutMilliseconds.unit": "ms",
    "schema.services.walletRefreshMilliseconds.label": "Bayi bakiyesi yenileme aralığı",
    "schema.services.walletRefreshMilliseconds.help": "Bakiye bilgisinin güncelliğini ve bayiye yapılan sorgu sıklığını etkiler.",
    "schema.services.walletRefreshMilliseconds.unit": "ms",
    "schema.services.workerConcurrency.label": "Satın alma kuyruğu tüketici sayısı",
    "schema.services.workerConcurrency.help": "Satın alma kuyruğunun işleme hızını ve bayiye aynı anda giden tahsilat yükünü etkiler.",
    "schema.services.workerConcurrency.unit": "işçi",
    "schema.services.settlementWorkerConcurrency.label": "Ödeme ve bildirim kuyruğu tüketici sayısı",
    "schema.services.settlementWorkerConcurrency.help": "Ödül ödemeleri ve bayi bildirimlerinin işleme hızını ve bayi yükünü etkiler.",
    "schema.services.settlementWorkerConcurrency.unit": "işçi",
    "schema.services.recoveryWorkerConcurrency.label": "Belirsiz tahsilat sorgusu ve iade tüketici sayısı",
    "schema.services.recoveryWorkerConcurrency.help": "Belirsiz tahsilatların çözülme ve iadelerin tamamlanma hızını etkiler; kesinti senaryolarıyla test edilmelidir.",
    "schema.services.recoveryWorkerConcurrency.unit": "işçi",
    "schema.services.purchasePublishMilliseconds.label": "Satın alma socket yayınlarını birleştirme aralığı",
    "schema.services.purchasePublishMilliseconds.help": "Satın alma güncellemelerinin yayın sıklığı ile ekranda görünme gecikmesini dengeler.",
    "schema.services.purchasePublishMilliseconds.unit": "ms",
    "schema.services.outboxPollMilliseconds.label": "Outbox kontrol aralığı",
    "schema.services.outboxPollMilliseconds.help": "Kalıcı işlerin kuyruğa iletilme gecikmesini etkiler. Yüksek değer tahsilat, ödeme ve bildirimleri bekletebilir.",
    "schema.services.outboxPollMilliseconds.unit": "ms",
    "schema.services.consumerPollMilliseconds.label": "Boş kuyruk bekleme aralığı",
    "schema.services.consumerPollMilliseconds.help": "Boş kuyruktan sonra yeni işe ne kadar sürede bakılacağını belirler; yüksek değer işleme gecikmesi oluşturabilir.",
    "schema.services.consumerPollMilliseconds.unit": "ms",
    "schema.services.importPollMilliseconds.label": "Oyun ödeme kayıtlarını aktarma aralığı",
    "schema.services.importPollMilliseconds.help": "Yeni oyun ödeme kayıtlarının muhasebe akışına alınma gecikmesini etkiler.",
    "schema.services.importPollMilliseconds.unit": "ms",
    "schema.services.reconnectMilliseconds.label": "Servis bağlantı tekrar aralığı",
    "schema.services.reconnectMilliseconds.help": "Kopma sonrası servis bağlantısının toparlanma süresini ve tekrar bağlantı yükünü etkiler.",
    "schema.services.reconnectMilliseconds.unit": "ms",
    "schema.services.retryLimit.label": "Mutabakat incelemesine geçmeden deneme sınırı",
    "schema.services.retryLimit.help": "İşlemin otomatik tekrardan mutabakat incelemesine ne zaman geçeceğini belirler. Düşük değer daha erken manuel inceleme gerektirebilir.",
    "schema.services.retryLimit.unit": "deneme",
    "schema.services.retryBaseMilliseconds.label": "İlk işlem tekrar süresi",
    "schema.services.retryBaseMilliseconds.help": "Başarısız işlemlerin ilk tekrarını etkiler; çok kısa süre arızalı hizmet üzerindeki yükü artırabilir.",
    "schema.services.retryBaseMilliseconds.unit": "ms",
    "schema.services.retryMaximumMilliseconds.label": "En uzun işlem tekrar süresi",
    "schema.services.retryMaximumMilliseconds.help": "Başarısız işlemlerin tekrarları arasındaki en uzun beklemedir; yüksek değer kurtarmayı geciktirebilir.",
    "schema.services.retryMaximumMilliseconds.unit": "ms",
    "schema.services.retryExponentLimit.label": "Üstel tekrar büyüme sınırı",
    "schema.services.retryExponentLimit.help": "Ardışık hatalarda tekrar beklemesinin büyümesini etkiler; diğer tekrar süreleriyle birlikte test edilmelidir.",
    "schema.services.retryExponentLimit.unit": "üs",
    "schema.services.playerBusyRetryMilliseconds.label": "Oyuncu işlem kilidi bekleme",
    "schema.services.playerBusyRetryMilliseconds.help": "Aynı oyuncunun işlem kilidi meşgulken yeniden deneme süresidir; satın alma gecikmesini ve tekrar yükünü etkiler.",
    "schema.services.playerBusyRetryMilliseconds.unit": "ms",
    "schema.services.earlierPurchaseRetryMilliseconds.label": "Önceki satın alma işlemini bekleme",
    "schema.services.earlierPurchaseRetryMilliseconds.help": "Oyuncunun önceki satın alımı sürerken sonraki işin tekrar beklemesini etkiler; işlem sırasını kaldırmaz.",
    "schema.services.earlierPurchaseRetryMilliseconds.unit": "ms",
    "schema.services.loginLimit.label": "Giriş penceresindeki istek sınırı",
    "schema.services.loginLimit.help": "Giriş denemesi korumasıdır; bağlı toplam oyuncu sınırı değildir. Düşük değer normal girişlerin reddedilmesine yol açabilir.",
    "schema.services.loginLimit.unit": "istek",
    "schema.services.loginWindowSeconds.label": "Giriş sınırı penceresi",
    "schema.services.loginWindowSeconds.help": "Giriş denemesi sayım süresidir. İstek sınırıyla birlikte değerlendirilmezse normal girişleri engelleyebilir.",
    "schema.services.loginWindowSeconds.unit": "sn",
    "schema.services.sessionHours.label": "Yeni oturum süresi",
    "schema.services.sessionHours.help": "Yeni oyuncu oturumlarının geçerliliğini belirler; kısa süre yeniden giriş ihtiyacını artırır, uzun süre oturumu daha uzun açık tutar.",
    "schema.services.sessionHours.unit": "saat",
    "noticeMeta.auto.available.title": "Seçilebilecek kart sınırı",
    "noticeMeta.auto.available.where": "Hızlı Kart Seç",
    "noticeMeta.auto.available.condition": "Geçerli bir kart adedi seçildiğinde",
    "noticeMeta.auto.range.title": "Geçersiz kart adedi",
    "noticeMeta.auto.range.where": "Hızlı Kart Seç",
    "noticeMeta.auto.range.condition": "Girilen adet izin verilen aralığın dışındaysa",
    "noticeMeta.auto.empty.title": "Seçilebilecek kart yok",
    "noticeMeta.auto.empty.where": "Hızlı Kart Seç",
    "noticeMeta.auto.empty.condition": "Seçim yöntemine uygun kart kalmadığında",
    "noticeMeta.auto.unavailable.title": "Seçim kullanılamıyor",
    "noticeMeta.auto.unavailable.where": "Hızlı Kart Seç",
    "noticeMeta.auto.unavailable.condition": "Bağlantı veya satış durumu seçime izin vermiyorsa",
    "noticeMeta.auto.preferencesPending.title": "Favoriler bekleniyor",
    "noticeMeta.auto.preferencesPending.where": "Hızlı Kart Seç",
    "noticeMeta.auto.preferencesPending.condition": "Favori listesi henüz yüklenmediyse",
    "noticeMeta.selection.amountStep.title": "Tutar adımı",
    "noticeMeta.selection.amountStep.where": "Satın alma sepeti",
    "noticeMeta.selection.amountStep.condition": "Tutar, geçerli artış adımına uymuyorsa",
    "noticeMeta.room.amountRange.title": "Kart başına tutar aralığı",
    "noticeMeta.room.amountRange.where": "Satın alma sepeti",
    "noticeMeta.room.amountRange.condition": "Tutar, çekilişin alt veya üst sınırına uymuyorsa",
    "noticeMeta.cards.noMatches.title": "Filtrede kart yok",
    "noticeMeta.cards.noMatches.where": "Kart kataloğu",
    "noticeMeta.cards.noMatches.condition": "Arama veya filtre sonucunda kart bulunmadığında",
    "noticeMeta.cards.noFavorites.title": "Favori kart yok",
    "noticeMeta.cards.noFavorites.where": "Kart kataloğu",
    "noticeMeta.cards.noFavorites.condition": "Favori listesi boşken",
    "noticeMeta.play.noOwned.title": "Alınmış kart yok",
    "noticeMeta.play.noOwned.where": "Kart kataloğu",
    "noticeMeta.play.noOwned.condition": "Seçilen çekilişte oyuncunun kartı yokken",
    "noticeMeta.favorite.error.title": "Favoriler yüklenemedi",
    "noticeMeta.favorite.error.where": "Kart kataloğu / canlı oyun",
    "noticeMeta.favorite.error.condition": "Favori isteği başarısız olduğunda",
    "noticeMeta.connection.waiting.title": "Bağlantı bekleniyor",
    "noticeMeta.connection.waiting.where": "Oyun ekranı",
    "noticeMeta.connection.waiting.condition": "Oyun bağlantısı hazır değilken; işlem yapma kuralı değişmez",
    "noticeMeta.purchase.processing.title": "Satın alma sürüyor",
    "noticeMeta.purchase.processing.where": "İşlem makbuzu",
    "noticeMeta.purchase.processing.condition": "Gönderilen satın alma halen işleniyorsa",
    "noticeMeta.purchase.pending.title": "İşlem kontrol ediliyor",
    "noticeMeta.purchase.pending.where": "İşlem makbuzu",
    "noticeMeta.purchase.pending.condition": "Aynı işlemin kesin sonucu bekleniyorsa",
    "noticeMeta.purchase.receiptDetailsUnavailable.title": "Makbuz ayrıntısı okunamadı",
    "noticeMeta.purchase.receiptDetailsUnavailable.where": "İşlem makbuzu",
    "noticeMeta.purchase.receiptDetailsUnavailable.condition": "İşlemin özgün çekiliş ayrıntısı yüklenemediğinde",
    "noticeMeta.purchase.accepted.title": "Satın alma onaylandı",
    "noticeMeta.purchase.accepted.where": "Satın alma sonucu",
    "noticeMeta.purchase.accepted.condition": "Sunucudan kesin kabul sonucu geldiğinde",
    "noticeMeta.purchase.partial.title": "Kısmi kart alımı",
    "noticeMeta.purchase.partial.where": "Satın alma sonucu",
    "noticeMeta.purchase.partial.condition": "Komuttaki kartların bir bölümü kabul edilmiş, diğerleri reddedilmiş olduğunda.",
    "noticeMeta.purchase.notAccepted.title": "Satın alma kabul edilmedi",
    "noticeMeta.purchase.notAccepted.where": "Satın alma sonucu",
    "noticeMeta.purchase.notAccepted.condition": "Sunucudan kesin ret sonucu geldiğinde",
    "noticeMeta.purchase.notStarted.title": "İşlem başlatılamadı",
    "noticeMeta.purchase.notStarted.where": "Satın alma sonucu",
    "noticeMeta.purchase.notStarted.condition": "Tarayıcı işlem kimliği oluşturamadığında; komut gönderilmez",
    "noticeMeta.purchase.uncertain.title": "İşlem sonucu belirsiz",
    "noticeMeta.purchase.uncertain.where": "İşlem makbuzu",
    "noticeMeta.purchase.uncertain.condition": "Yanıt alınamadığında; aynı işlem kontrol edilir",
    "noticeMeta.purchase.sales_closed.title": "Satış kapandı",
    "noticeMeta.purchase.sales_closed.where": "Satın alma sonucu",
    "noticeMeta.purchase.sales_closed.condition": "Sunucu satışın kapandığını bildirdiğinde",
    "noticeMeta.purchase.amount_limit.title": "Kart tutar sınırı",
    "noticeMeta.purchase.amount_limit.where": "Sepet / satın alma sonucu",
    "noticeMeta.purchase.amount_limit.condition": "Kart başına tutar sınırı aşıldığında",
    "noticeMeta.purchase.insufficient_balance.title": "Bakiye yetersiz",
    "noticeMeta.purchase.insufficient_balance.where": "Sepet / satın alma sonucu",
    "noticeMeta.purchase.insufficient_balance.condition": "Seçim tutarı kullanılabilir bakiyeyi aştığında",
    "noticeMeta.purchase.wrong_draw.title": "Çekiliş değişti",
    "noticeMeta.purchase.wrong_draw.where": "Satın alma sonucu",
    "noticeMeta.purchase.wrong_draw.condition": "Sunucu hedef çekilişi uygun bulmadığında",
    "noticeMeta.purchase.invalid_selection.title": "Kart seçimi uygun değil",
    "noticeMeta.purchase.invalid_selection.where": "Satın alma sonucu",
    "noticeMeta.purchase.invalid_selection.condition": "Sunucu seçilen kart listesini reddettiğinde",
    "noticeMeta.purchase.unknown_card.title": "Kart bulunamadı",
    "noticeMeta.purchase.unknown_card.where": "Satın alma sonucu",
    "noticeMeta.purchase.unknown_card.condition": "Kart hedef çekilişte bulunmadığında",
    "noticeMeta.purchase.request_conflict.title": "İşlem kaydı uyuşmuyor",
    "noticeMeta.purchase.request_conflict.where": "Satın alma sonucu",
    "noticeMeta.purchase.request_conflict.condition": "İşlem kimliği ve içerik eşleşmediğinde",
    "noticeMeta.purchase.card_limit.title": "Kart sayısı sınırı",
    "noticeMeta.purchase.card_limit.where": "Sepet / satın alma sonucu",
    "noticeMeta.purchase.card_limit.condition": "Çekilişin kart sayısı sınırına ulaşıldığında",
    "noticeMeta.purchase.unknown_market.title": "Seçenek bulunamadı",
    "noticeMeta.purchase.unknown_market.where": "Satın alma sonucu",
    "noticeMeta.purchase.unknown_market.condition": "Sunucu satın alma seçeneğini tanımadığında",
    "noticeMeta.purchase.amount_step.title": "Tutar adımı reddi",
    "noticeMeta.purchase.amount_step.where": "Satın alma sonucu",
    "noticeMeta.purchase.amount_step.condition": "Sunucu tutar artış adımını uygun bulmadığında",
    "noticeMeta.room.closed.title": "Kart seçimi kapandı",
    "noticeMeta.room.closed.where": "Kart kataloğu",
    "noticeMeta.room.closed.condition": "Hedef çekiliş satışa kapandığında",
    "noticeMeta.room.completed.title": "Çekiliş tamamlandı",
    "noticeMeta.room.completed.where": "Kart kataloğu",
    "noticeMeta.room.completed.condition": "Satın alma hedefindeki çekiliş tamamlandığında",
    "noticeMeta.room.resultPending.title": "Kesin sonuç yükleniyor",
    "noticeMeta.room.resultPending.where": "Oyun ekranı",
    "noticeMeta.room.resultPending.condition": "Tamamlanan çekilişin kesin sonucu henüz gelmediyse",
    "noticeMeta.flow.startingHelp.title": "İlk top bekleniyor",
    "noticeMeta.flow.startingHelp.where": "Çekiliş başlangıcı",
    "noticeMeta.flow.startingHelp.condition": "Satış kapalı ve ilk top henüz çekilmediyse",
    "noticeMeta.flow.watchingHelp.title": "Kartsız izleyici",
    "noticeMeta.flow.watchingHelp.where": "Canlı oyun",
    "noticeMeta.flow.watchingHelp.condition": "Oyuncu kartı olmadan çekilişi izliyorsa",
    "noticeMeta.flow.waitingNext.title": "Sıradaki çekiliş hazırlanıyor",
    "noticeMeta.flow.waitingNext.where": "Çekiliş sonu",
    "noticeMeta.flow.waitingNext.condition": "Tamamlanan çekilişten sonra sıradaki el beklenirken",
    "noticeMeta.flow.cancelledObserver.title": "İzlenen çekiliş iptal edildi",
    "noticeMeta.flow.cancelledObserver.where": "Canlı oyun",
    "noticeMeta.flow.cancelledObserver.condition": "Katılım olmayan çekiliş iptal edildiğinde",
    "noticeMeta.flow.previousCancelled.title": "Önceki çekiliş iptali",
    "noticeMeta.flow.previousCancelled.where": "Çekiliş geçişi / satın alma",
    "noticeMeta.flow.previousCancelled.condition": "Önceki çekilişin iptali bildirildiğinde",
    "noticeMeta.flow.quickClosed.title": "Hızlı seçim satışla kapandı",
    "noticeMeta.flow.quickClosed.where": "Hızlı seçim sonrası",
    "noticeMeta.flow.quickClosed.condition": "Hedef elin satış süresi bitip hızlı seçim kapandığında",
    "noticeMeta.flow.selectionClosed.title": "Seçim korunuyor",
    "noticeMeta.flow.selectionClosed.where": "Satış kapanışı",
    "noticeMeta.flow.selectionClosed.condition": "Gönderilmemiş seçim, uygun sonraki ele devam için korunuyorsa",
    "noticeMeta.flow.selectionRestored.title": "Seçim aktarıldı",
    "noticeMeta.flow.selectionRestored.where": "Satın alma ekranı",
    "noticeMeta.flow.selectionRestored.condition": "Oyuncu korunmuş seçime devam ettiğinde; satın alma gerçekleşmez",
    "noticeMeta.flow.selectionPartlyRestored.title": "Seçim kısmen aktarıldı",
    "noticeMeta.flow.selectionPartlyRestored.where": "Satın alma ekranı",
    "noticeMeta.flow.selectionPartlyRestored.condition": "Korunan kartların yalnız bir kısmı yeni elde uygun olduğunda",
    "noticeMeta.flow.purchaseDrawWon.title": "Satın alma sırasında kazanç",
    "noticeMeta.flow.purchaseDrawWon.where": "Satın alma penceresi",
    "noticeMeta.flow.purchaseDrawWon.condition": "Diğer çekilişte kesinleşmiş kişisel kazanç varken",
    "noticeMeta.flow.refundPending.title": "İade bekleniyor",
    "noticeMeta.flow.refundPending.where": "İptal sonucu",
    "noticeMeta.flow.refundPending.condition": "İade henüz kesinleşmediyse",
    "noticeMeta.flow.refundConfirmed.title": "İade tamamlandı",
    "noticeMeta.flow.refundConfirmed.where": "İptal sonucu",
    "noticeMeta.flow.refundConfirmed.condition": "Sunucu iadeyi kesinleştirdiğinde",
    "noticeMeta.results.empty.title": "Geçmiş çekiliş yok",
    "noticeMeta.results.empty.where": "Sonuçlar",
    "noticeMeta.results.empty.condition": "Filtrelere uyan tamamlanmış çekiliş yokken",
    "noticeMeta.results.error.title": "Sonuçlar yüklenemedi",
    "noticeMeta.results.error.where": "Sonuçlar",
    "noticeMeta.results.error.condition": "Sonuç isteği başarısız olduğunda",
    "noticeMeta.x.paymentPending.title": "Bayi ödeme teyidi bekleniyor",
    "noticeMeta.x.paymentPending.where": "Sonuçlar",
    "noticeMeta.x.paymentPending.condition": "Pozitif kazancın bayi teyidi henüz tamamlanmadıysa",
    "noticeMeta.x.paymentConfirmed.title": "Bayi ödeme teyidi alındı",
    "noticeMeta.x.paymentConfirmed.where": "Sonuçlar",
    "noticeMeta.x.paymentConfirmed.condition": "Pozitif kazancın bayi teyidi tamamlandıysa",
    "noticeMeta.receipt.unit.title": "Birim",
    "noticeMeta.receipt.unit.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.unit.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.accepted.title": "Kabul edilen adet",
    "noticeMeta.receipt.accepted.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.accepted.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.rejected.title": "Kabul edilmeyen adet",
    "noticeMeta.receipt.rejected.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.rejected.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.pending.title": "Bekleyen adet",
    "noticeMeta.receipt.pending.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.pending.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.balance.title": "Kalan seçimlerde bakiye",
    "noticeMeta.receipt.balance.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.balance.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.closed.title": "Makbuzda satış kapanışı",
    "noticeMeta.receipt.closed.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.closed.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.amountLimit.title": "Makbuzda tutar sınırı",
    "noticeMeta.receipt.amountLimit.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.amountLimit.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.amountStep.title": "Makbuzda tutar adımı",
    "noticeMeta.receipt.amountStep.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.amountStep.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.session.title": "Bayi oturumu sona erdi",
    "noticeMeta.receipt.session.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.session.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.notDebited.title": "Tahsilat yapılmadı",
    "noticeMeta.receipt.notDebited.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.notDebited.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.refundPending.title": "Makbuzda iade bekleniyor",
    "noticeMeta.receipt.refundPending.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.refundPending.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.refunded.title": "Makbuzda iade tamamlandı",
    "noticeMeta.receipt.refunded.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.refunded.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.notIncluded.title": "Onaysız kart oyuna katılmadı",
    "noticeMeta.receipt.notIncluded.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.notIncluded.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.review.title": "İşlem incelemede",
    "noticeMeta.receipt.review.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.review.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.debited.title": "Kart kabulü doğrulanıyor",
    "noticeMeta.receipt.debited.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.debited.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.waiting.title": "İşlem onayı bekleniyor",
    "noticeMeta.receipt.waiting.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.waiting.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.receipt.notApproved.title": "Ödeme onaylanmadı",
    "noticeMeta.receipt.notApproved.where": "İşlem özeti (metin parçası)",
    "noticeMeta.receipt.notApproved.condition": "Sunucunun kesin makbuz durumuna göre birleştirilen işlem özeti",
    "noticeMeta.flow.selectionCatalogChanged.title": "Kart serisi yenilendi",
    "noticeMeta.flow.selectionCatalogChanged.where": "Satış kapanışı",
    "noticeMeta.flow.selectionCatalogChanged.condition": "Korunan se?imin katalog s?r?m? hedef ?ekili?ten farkl?ysa",
    "noticeMeta.category.general": "Bağlantı",
    "noticeMeta.category.selection": "Kart seçimi",
    "noticeMeta.category.purchase": "Satın alma",
    "noticeMeta.category.transition": "Çekiliş geçişi",
    "noticeMeta.category.results": "Sonuç ve iade",
    "noticeMeta.tones.info": "Bilgi",
    "noticeMeta.tones.success": "Başarı",
    "noticeMeta.tones.warning": "Uyarı",
    "noticeMeta.tones.error": "Hata",
    "color.card.orange": "Turuncu",
    "color.card.blue": "Mavi",
    "color.card.green": "Yeşil",
    "color.card.purple": "Mor",
    "color.card.red": "Kırmızı",
    "color.card.silver": "Gümüş",
    "color.ball.yellow": "Sarı",
    "color.ball.pink": "Pembe",
    "color.ball.green": "Yeşil",
    "color.ball.blue": "Mavi",
    "color.ball.red": "Kırmızı",
    "color.ball.black": "Siyah",
    "design.cardColor": "Kart · {color}",
    "copy.theme.surface": "Zemin",
    "copy.theme.text": "Yazı",
    "copy.theme.accent": "İkon",
    "lab.cardName": "No. {number}",
    "status.SalesOpen": "Satış açık",
    "status.Preparing": "Hazırlanıyor",
    "status.Live": "Canlı",
    "status.Completed": "Tamamlandı",
    "status.Cancelled": "İptal edildi",
    "api.failed": "İşlem tamamlanamadı. Bağlantınızı kontrol edip yeniden deneyin.",
    "api.http": "İşlem tamamlanamadı ({status}).",
    "api.copy_variant": "Geçersiz ekran metni varyantı.",
    "api.copy_variables": "Metindeki gerekli değişkenleri koruyun.",
    "copy.savedRevision": "Sürüm {revision} olarak kaydedildi.",
    "api.missing_payment_credential": "Missing financial recovery credential",
    "api.invalid_filter": "Arama, tarih aralığı veya sayfa bilgisi geçersiz.",
    "api.invalid_identity": "Bayi oyuncusu veya para birimi geçersiz.",
    "api.identity_mapping_changed": "Bayi havuz eşlemesi değişmiş; yönetim kontrolü gerekiyor.",
    "api.invalid_selection": "Kart/tutar/işlem bilgisi geçersiz.",
    "api.request_conflict": "Aynı işlem kimliği farklı içerikle kullanıldı.",
    "api.invalid_session": "Alım için geçerli bayi oyuncu oturumu gerekli.",
    "api.invalid_actor": "Yönetim oturumu gerekli.",
    "api.not_found": "İşlem bulunamadı.",
    "api.busy": "İşlem devam ediyor.",
    "api.invalid_replay": "Yalnız mutabakat bekleyen işlem tekrar işlenebilir.",
    "api.invalid_launch": "Oyun açılış bilgileri geçersiz.",
    "api.invalid_token": "Bayi oturumu doğrulanamadı.",
    "api.invalid_player": "Bayi oyuncusu doğrulanamadı.",
    "api.player_busy": "Oyuncu işlemi devam ediyor. Tekrar deneyebilirsin.",
    "api.wallet_unavailable": "Bayi bakiyesi alınamadı.",
    "api.unknown_merchant": "Bayi veya çekiliş havuzu tanımlı değil.",
    "api.unknown_game": "Bayi için bu oyun tanımlı değil.",
    "api.invalid_service_parameter": "En uzun tekrar süresi başlangıçtan kısa olamaz.",
    "api.admin_reason": "Değişiklik gerekçesi gerekli.",
    "api.admin_revision": "Servis ayarları değişti; güncel sürümü yükleyin.",
    "api.password_length": "Şifre 10–128 karakter olmalı.",
    "api.invalid_user": "Kullanıcı veya bakiye bilgisi geçersiz.",
    "api.unknown_player": "Kullanıcı bulunamadı.",
    "api.invalid_credit": "Tutar veya işlem kimliği geçersiz.",
    "api.invalid_login": "Kullanıcı adı veya şifre hatalı ya da hesap pasif.",
    "api.invalid_fault": "Geçersiz hata senaryosu.",
    "api.invalid_profile": "Profil ve kural sürümü aynı olmalı.",
    "api.invalid_presentation": "Sunucu adı, görsel ve geçmiş sınırı geçersiz.",
    "api.invalid_simulation": "Sanal bayi otomasyonu yalnız test profiliyle ve geçerli sınırlarla açılabilir.",
    "api.invalid_analysis": "Analiz örnek sayısı sınırları geçersiz (en çok 5 milyon).",
    "api.invalid_calibration": "RTP hedefi, aşama ağırlıkları ve çarpan adımı geçersiz.",
    "api.wrong_draw": "Alım hedefi başka çekilişe taşınamaz.",
    "api.sales_closed": "Bu çekiliş için satış süresi doldu.",
    "api.carry_conflict": "Çekilişe farklı devir tekrar bağlanamaz.",
    "api.invalid_activation": "Sıradaki çekiliş devir almaya uygun değil.",
    "api.sales_open": "Teklif edilen satış süresi henüz tamamlanmadı.",
    "api.invalid_event": "Geçerli olay kimliği gerekli.",
    "api.event_conflict": "Olay kimliği farklı veriyle tekrar kullanılamaz.",
    "api.draw_not_live": "Çekiliş top kabulüne açık değil.",
    "api.draw_preparing": "Çekiliş hazırlık süresi devam ediyor.",
    "api.carry_pending": "Önceki çekilişin jackpot devri bekleniyor.",
    "api.ball_not_due": "Sunucu top ve sonuç zamanlaması devam ediyor.",
    "api.invalid_source": "Geçersiz stüdyo kaynağı.",
    "api.invalid_number": "Top 1–90 aralığında olmalı.",
    "api.duplicate_number": "Bu top daha önce işlendi.",
    "api.sequence_gap": "Top sırası atlanamaz.",
    "api.invalid_time": "Topun zamanı satış kapanışı ile sunucu kabulü arasında olmalı.",
    "api.reason_required": "Elle giriş gerekçesi gerekli.",
    "api.cancel_conflict": "İptal gerekçesi değiştirilemez.",
    "api.cannot_cancel": "Bu işlem yalnız top çekilmemiş çekilişi gerekçeli iptal edebilir.",
    "api.batch_limit": "Bu çekilişin tek işlemde alınabilecek kart sınırı aşıldı.",
    "api.admin_draft": "Taslak değişti veya bulunamadı.",
    "api.ledger_filter": "Çekiliş, hareket türü veya sayfa aralığı geçersiz.",
    "api.draw_missing": "Çekiliş bulunamadı.",
    "api.catalog_recipe": "Set sayısı, simülasyon adedi veya üretim ayarı geçersiz.",
    "api.catalog_pattern": "Her desen 3 satır ve satır başına 5 farklı hücre içermeli.",
    "api.catalog_duplicate": "Aynı sayı kümesi tekrarlandı; farklı tohumla yeniden üretin.",
    "api.catalog_rows": "Sütun ve satır dengesi birlikte kurulamadı; başka tohumla yeniden üretin.",
    "api.simulation_options": "Simülasyon ayarları eksik.",
    "api.simulation_sales": "Satış senaryosu geçersiz.",
    "api.simulation_capacity": "Bu analiz en fazla 20 milyon bahis-çekiliş hesabı yapabilir; adetleri azaltın.",
    "api.simulation_empty": "RTP hesaplamak için pozitif satış gerekli.",
    "api.invalid_card": "Kart üç satır ve dokuz sütun; her satır beş sayı içermeli.",
    "api.invalid_card_column": "Sütunlar sırasıyla 1–9, 10–19, 20–29, 30–39, 40–49, 50–59, 60–69, 70–79 ve 80–90 aralıklarını kullanmalı.",
    "api.invalid_x_catalog": "X kataloğu aynı sürümde 120 farklı kimlikli kart içermeli.",
    "api.invalid_balls": "Toplar 1–90 aralığında, sıralı ve tekrarsız olmalı.",
    "api.catalog_mismatch": "Teklif edilen çekilişin kart kataloğu bulunamadı; kartlar değiştirilemez.",
    "api.invalid_limits": "Kart tutarı, adımı ve adet sınırları birlikte geçerli olmalı.",
    "api.invalid_jackpot": "Jackpot tabanı, katkısı, dağıtım yüzdesi veya top sınırı geçersiz.",
    "api.invalid_rules": "Sürümlü X kuralları ve desteklenen para birimi gerekli.",
    "api.invalid_multiplier": "Normal aşama çarpanı pozitif olmalı.",
    "api.invalid_timing": "Çekiliş ve sonuç gösterim süreleri geçersiz.",
    "api.fractional_payout": "Bahis adımı ve çarpan tam kuruş ödeme üretmeli.",
    "api.draw_completed": "İlk Tombala sonrasında top eklenemez.",
    "api.invalid_bets": "Kabul edilmiş bahis kimliği, kartı veya tutarı geçersiz.",
    "api.amount_limit": "Oyuncunun çekiliş kartı için kabul edilmiş toplam sınırı aşılıyor.",
    "api.preferences_conflict": "Tercih başka bir ekranda değişti. Tekrar deneyebilirsin.",
    "api.sandbox_unavailable": "Test bayisine ulaşılamadı.",
    "api.notice_color": "Bildirim renkleri opak, altı haneli renk kodları olmalı.",
    "api.notice_duration": "Geçici başarı bildirimi süresi 1000–10000 ms olmalı.",
    "api.notice_policy": "Bildirim sunum tanımı geçersiz.",
    "api.notice_reason": "Değişiklik gerekçesini yazın (en fazla 1000 karakter).",
    "api.ui_revision": "Ayarlar değişti. Güncel sürümü yükleyin.",
    "api.notice_revision": "Seçilen sürüm bulunamadı.",
    "api.notice_scope": "Bu ekran yalnız bildirim alanlarını değiştirebilir.",
    "api.rng_active": "Otomatik RNG açıkken manuel top kabul edilmez.",
    "api.experience_revision": "Ayarlar değişti. Güncel değerleri yükleyin.",
    "api.experience_value": "Sayaç süresi, liste adedi veya ödeme yenileme aralığı geçersiz.",
    "api.invalid_ui": "Tasarım profilinin alanları veya değerleri geçersiz.",
    "api.analysis_pending": "Tamamlanmış çarpan önerisi bulunamadı.",
    "api.analysis_trials": "Örnek sayısı yönetim sınırları dışında.",
    "api.analysis_empty": "Etkin çekilişte kabul edilmiş satış yok; eşit dağılımı kullanın.",
    "api.analysis_busy": "Bir analiz zaten çalışıyor.",
    "api.catalog_revision": "Üretim ayarları değişti; güncel değerleri yükleyin.",
    "api.catalog_missing": "Kart serisi bulunamadı.",
    "api.catalog_active": "Etkin oyun kataloğu silinemez.",
    "api.catalog_busy": "Bir üretim veya simülasyon zaten çalışıyor.",
    "api.simulation_trials": "Çekiliş adedi yönetim sınırları dışında.",
    "api.simulation_expired": "Geçici sonuç artık bellekte değil. Yeniden simüle edebilirsiniz.",
    "api.simulation_filter": "Simülasyon filtreleri geçersiz.",
    "api.draw_paused": "Çekiliş duraklatıldı.",
    "api.unknown_card_version": "Kart sürümü bulunamadı.",
    "api.test_environment": "Bu ortam yalnız test profillerini etkinleştirebilir.",
    "api.analysis_stale": "Analizden sonra etkin profil değişti; yeniden hesaplayın.",
    "api.draft_exists": "Mevcut taslağı önce inceleyin; analiz önerisi taslağın üzerine yazılmaz.",
    "api.result_filter": "Sonuç filtresi geçersiz.",
    "common.details": "Detay",
    "common.none": "Yok",
    "common.active": "Aktif",
    "common.inactive": "Pasif",
    "common.activeSuffix": " · Etkin",
    "lab.maximumWinners": "{stage} {count} kart",
    "lab.betOutcome": "{count} bahis · {stake} → {payout}",
    "lab.deleteSet": "{name} serisi ve {count} kartı silinsin mi?",
    "lab.patternLabel": "{color} desen adı",
    "audio.back": "← Ana ekrana dön",
    "audio.eyebrow": "90° · SES DENEMESİ",
    "audio.title": "Çekiliş ve ikramiye girişlerini dinleyelim.",
    "audio.intro": "Çekiliş başlangıcında açılış efekti; Çinko için belirgin vuruş ve parlak tını, Tombala için dolgun bir akor, Jackpot için güçlü açılış ve yükselen arpej. Mevcut Türkçe anonslar korunur. Her örnekte efekt ve anons tek ses dosyasıdır.",
    "audio.mix": "İki miks, aynı sesler",
    "audio.overlap": "B · Hafif örtüşen — önerilen",
    "audio.overlapHelp": "Efekt sürerken anons girer; efektin seviyesi konuşmanın altında azalır.",
    "audio.serial": "A · Ardışık",
    "audio.serialHelp": "Önce efekt tamamlanır, ardından ikramiye anonsu gelir.",
    "audio.durationTest": "Süre denemesi",
    "audio.duration": "{seconds} saniyelik ekran süresi",
    "audio.choose": "Bir ikramiye seç",
    "audio.stop": "Durdur",
    "audio.elapsed": "Geçen ekran süresi",
    "audio.time": "{elapsed} / {duration} sn",
    "audio.reading": "Ses bitince kalan süre, ödülü ve kartları okumaya ayrılıyor.",
    "audio.samples": "İkramiye sesleri",
    "audio.timing": "{sound} sn ses + {hold} sn sessiz okuma",
    "audio.listen": "Dinle ve süreyi dene",
    "audio.listenStage": "{stage} dinle",
    "audio.file": "Ses dosyası",
    "audio.starting": "ÇEKİLİŞ BAŞLANGICI",
    "audio.jackpotNote": "Jackpot örneğinde yalnız Jackpot anonsu var. Oyundaki Jackpot sahnesi Tombala + Jackpot toplam kişisel ödülünü gösterir.",
    "audio.previewNote": "Bu sayfa yalnız ses ve süre denemesidir; çekilişe bağlanmaz. Mevcut kayıtlarda iki Çinko anonsu aynıdır.",
    "audio.loading": "Ses hazırlanıyor…",
    "audio.stopped": "Durduruldu.",
    "audio.completed": "Deneme tamamlandı.",
    "audio.hold": "Ödülü ve kartları okuma süresi.",
    "audio.voice": "İkramiye anonsu.",
    "audio.effect": "Splash giriş sesi.",
    "audio.ready": "Seçilen miks hazır.",
    "audio.loadFailed": "Ses dosyaları yüklenemedi. Sayfayı yenileyebilirsin.",
    "audio.playFailed": "Ses açılamadı. Dinle düğmesine tekrar dokunabilirsin.",
    "automation.off": "Otomatik test alımı kapalı.",
    "automation.deferred": "Test alımı bekliyor: {code}",
    "automation.waitingDraw": "Alıma açık çekiliş bekleniyor.",
    "automation.waitingReceipt": "Önceki otomatik alımın bayi sonucu bekleniyor.",
    "automation.close": "Satış kapanışına yaklaşıldı; yeni test alımı yapılmıyor.",
    "automation.presalePace": "{accepted}/{target} alım; ön satış temposu bekleniyor.",
    "automation.salePace": "{accepted}/{target} alım; satış temposu bekleniyor.",
    "automation.amount": "Test tutarı satışa açılmış elin bahis aralığına uygun değil.",
    "automation.balanceUnknown": "{user}: bayi bakiyesi doğrulanamadı; alım bekliyor.",
    "automation.balanceLow": "{user}: yetersiz test bakiyesi; yeni alım üretilmedi.",
    "automation.cardLimit": "{user}: kart limitine ulaşıldı.",
    "automation.queued": "{user}: {count} kart sırada · {accepted}/{target} kabul edildi.",
    "automation.unconfigured": "Bu ortamda otomatik test hesabı tanımlı değil.",
    "lab.generateFailed": "Set üretimi tamamlanamadı.",
    "lab.simulateFailed": "Simülasyon tamamlanamadı.",
    "copy.invalidJson": "Gelişmiş profil geçerli JSON olmalı.",
    "lab.candidateUnavailable": "Bu örneklemde hedef çarpan hesabı için yeterli ödemeli kazanım yok veya yuvarlama adımı fazla büyük.",
    "viewport.mobile.guide.begin": "",
    "design.number.title": "Tutar ve adet seçimi",
    "design.number.help": "Web ve mobil aynı ayarları kullanır. İstediğin kadar ara seçenek ekleyebilir, silebilir ve sırasını değiştirebilirsin. Alt ve üst sınırlar aktif çekilişten gelir; hem slider hem düğmelerde otomatik bulunur. Sınır dışındaki seçenekler gösterilmez, tekrar eden değerler bir kez gösterilir. Varsayılan bu listeden seçilir; elle giriş açıktır.",
    "design.number.amount": "Kart başına tutar (TL)",
    "design.number.count": "Hızlı seçimde kart adedi",
    "design.number.presentation": "Seçim biçimi",
    "design.number.slider": "Slider",
    "design.number.badges": "Seçenek düğmeleri",
    "design.number.value": "{index}. seçenek",
    "design.number.up": "Yukarı taşı",
    "design.number.down": "Aşağı taşı",
    "design.number.remove": "Seçeneği sil",
    "design.number.add": "Seçenek ekle",
    "design.number.invalid": "Seçenekleri sıfırdan büyük ve tekrarsız gir. Tutar en fazla iki ondalık, kart adedi tam sayı olmalı. Varsayılanı listeden seç.",
    "design.number.default": "Varsayılan",
    "design.number.chooseDefault": "Listeden seç",
    "notice.durationLabel": "Görünme süresi (saniye)",
    "notice.durationHelp": "Otomatik kapanmayı kapatırsan bildirim, sen kapatana kadar görünür. Süre yalnız bildirimi gizler; sepet ve işlem sonucu korunur.",
    "notice.defaultDurationLabel": "Varsayılan bildirim süresi (saniye)",
    "notice.defaultDurationHelp": "Ayrı süre verilmemiş bildirimlerde geçerlidir. İkramiye kutlamalarının süresi kendi ayarından yönetilir.",
    "viewport.web.flow.quickClosed": "#{draw} satışı kapandı. Sonraki çekilişe geçebilirsin.",
    "notice.autoClose": "Otomatik kapansın",
    "notice.closeAlways": "Kapatma düğmesi her zaman görünür.",
    "demoSales.title": "Demo sayaçları",
    "demoSales.enabled": "Demo modu açık",
    "demoSales.target": "Çekiliş başına demo alım adedi",
    "demoSales.interval": "Artış aralığı (saniye)",
    "demoSales.help": "Yalnız demo sunumunda satış sayaçlarını ve JP göstergesini artırır. Her demo alım için 100 TL × %5 = 5 TL görsel JP katkısı eklenir. Gerçek kart, bakiye, kazanç veya Jackpot hareketi oluşturmaz.",
    "demoSales.targetHelp": "1.000–10.000 alım, mevcut 120 karta her çekilişte farklı dağıtılır.",
    "demoSales.nextDraw": "Adet ve aralık yeni satışa açılan çekilişlerde geçerlidir. Kapatınca gerçek sayaçlar gösterilir. Yalnız son 20 demo çekilişinin özeti tutulur.",
    "favorite.added": "Favorilere Eklendi!",
    "favorite.removed": "Favorilerden Çıkarıldı!",
    "selection.cardRemaining": "No. {card} kartına {invested} yatırdın. Kart başına sınır {max}; en fazla {remaining} daha ekleyebilirsin.",
    "selection.cardFull": "No. {card} kartına {invested} yatırdın. Kart başına sınır {max}; bu karta ek alım yapılamaz. Devam etmek için kartı seçimden çıkar.",
    "flow.returnToResults": "Sonuçlara Dön",
    "auto.manualHelp": "Manuel Giriş",
    "notice.persistentHelp": "Bu bilgi alanı kapatılamaz; seçim değiştikçe güncellenir.",
    "selection.amountHelp": "Her kart için tutarı seç veya elle yaz."
  },
  "links": {
    "tombala": "http://127.0.0.1:5540",
    "studio": "http://127.0.0.1:5542"
  },
  "assets": {
    "awardSounds": {
      "cinko": "/audio/tombala/awards/cinko.wav",
      "jackpot": "/audio/tombala/awards/jackpot.wav",
      "tombala": "/audio/tombala/awards/tombala.wav"
    },
    "studioImage": "/virtual-studio-v1.png",
    "drawEndSound": "/audio/tombala/tr/finished.mp3",
    "waitingMusic": "/audio/tombala/music/waiting-lounge.6bd08072a139.mp3",
    "waitingMusic2": "/audio/tombala/music/waiting-chill.52db34ba36b3.mp3",
    "waitingMusic3": "/audio/tombala/music/waiting-sherwood.1feb502810e4.mp3",
    "drawStartSound": "/audio/tombala/awards/starting.wav",
    "drawCountdownSound": "/audio/tombala/effects/countdown.2067760f603e.mp3"
  },
  "motion": {
    "confettiCount": 65,
    "confettiColors": [
      "#D6B37E",
      "#348D6B",
      "#D878A4",
      "#E9B83D"
    ],
    "confettiLifetimeFrames": 160
  },
  "themes": {
    "studio": {},
    "tombala": {},
    "gameadmin": {
      "--color-ink": "#1b2440",
      "--color-line": "#dce2ed",
      "--color-muted": "#59667e",
      "--color-white": "#ffffff",
      "--color-primary": "#6145dd",
      "--color-surface": "#f4f6fb"
    }
  },
  "tokens": {
    "--room-transition-sales-enabled": "1",
    "--room-transition-preparing-enabled": "1",
    "--room-transition-one-line-enabled": "1",
    "--room-transition-two-lines-enabled": "1",
    "--room-transition-full-house-enabled": "1",
    "--room-transition-award-enabled": "1",
    "--room-transition-completed-enabled": "1",
    "--room-transition-cancelled-enabled": "1",
    "--room-cta-next-action": "#A53B80",
    "--room-cta-secondary-bg": "#17182F",
    "--room-transition-sales-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-sales": "900ms",
    "--room-transition-preparing-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-preparing": "900ms",
    "--room-transition-one-line-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-one-line": "900ms",
    "--room-transition-two-lines-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-two-lines": "900ms",
    "--room-transition-full-house-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-full-house": "900ms",
    "--room-transition-award-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-award": "900ms",
    "--room-transition-completed-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-completed": "900ms",
    "--room-transition-cancelled-bg": "var(--room-bottom-cta-tint)",
    "--motion-room-cancelled": "900ms",
    "--room-bg": "#0D1025",
    "--admin-bg": "#f4f6fb",
    "--jp-limit": "#246ba5",
    "--admin-ink": "#1b2440",
    "--color-000": "#000",
    "--color-ink": "#153c30",
    "--font-body": "'DM Sans',Arial,sans-serif",
    "--jp-accent": "#6547eb",
    "--jp-target": "#a36800",
    "--room-line": "#373D64",
    "--room-live": "#35E5B1",
    "--room-text": "#F5F6FF",
    "--admin-line": "#dce2ed",
    "--admin-tint": "#efebff",
    "--color-fff4": "#fff4",
    "--color-gold": "#d6b37e",
    "--color-line": "#dee3d9",
    "--motion-win": "5s",
    "--room-muted": "#A5ADD3",
    "--room-panel": "#191D3B",
    "--space-page": "4.4%",
    "--admin-muted": "#59667e",
    "--color-muted": "#819089",
    "--color-white": "#fff",
    "--jp-selected": "#f0edff",
    "--motion-ball": "550ms",
    "--motion-card": "200ms",
    "--motion-pool": "350ms",
    "--radius-card": "11px",
    "--room-accent": "#FFD34E",
    "--room-action": "#6851F5",
    "--admin-accent": "#6145dd",
    "--admin-radius": "16px",
    "--color-10251c": "#10251c",
    "--color-121b22": "#121b22",
    "--color-15231a": "#15231a",
    "--color-15231d": "#15231d",
    "--color-152620": "#152620",
    "--color-152b25": "#152b25",
    "--color-163e31": "#163e31",
    "--color-17232a": "#17232a",
    "--color-1c292e": "#1c292e",
    "--color-1c2a30": "#1c2a30",
    "--color-1c2c30": "#1c2c30",
    "--color-202e35": "#202e35",
    "--color-203c37": "#203c37",
    "--color-224a3c": "#224a3c",
    "--color-233e34": "#233e34",
    "--color-234a35": "#234a35",
    "--color-243330": "#243330",
    "--color-244f3b": "#244f3b",
    "--color-254d3d": "#254d3d",
    "--color-285239": "#285239",
    "--color-294f36": "#294f36",
    "--color-296049": "#296049",
    "--color-2b3438": "#2b3438",
    "--color-2e4830": "#2e4830",
    "--color-2e503a": "#2e503a",
    "--color-30382f": "#30382f",
    "--color-304441": "#304441",
    "--color-305a41": "#305a41",
    "--color-344347": "#344347",
    "--color-354249": "#354249",
    "--color-394d65": "#394d65",
    "--color-3c4e49": "#3c4e49",
    "--color-43504b": "#43504b",
    "--color-44623d": "#44623d",
    "--color-465149": "#465149",
    "--color-487160": "#487160",
    "--color-49564f": "#49564f",
    "--color-4f9271": "#4f9271",
    "--color-507143": "#507143",
    "--color-514962": "#514962",
    "--color-547347": "#547347",
    "--color-547544": "#547544",
    "--color-567249": "#567249",
    "--color-617a68": "#617a68",
    "--color-6d9973": "#6d9973",
    "--color-6e4846": "#6e4846",
    "--color-6e5646": "#6e5646",
    "--color-70966e": "#70966e",
    "--color-728079": "#728079",
    "--color-728765": "#728765",
    "--color-738769": "#738769",
    "--color-744f64": "#744f64",
    "--color-74866f": "#74866f",
    "--color-758e7a": "#758e7a",
    "--color-75966b": "#75966b",
    "--color-79867e": "#79867e",
    "--color-799fbe": "#799fbe",
    "--color-7baf8c": "#7baf8c",
    "--color-7e795a": "#7e795a",
    "--color-7e8c7f": "#7e8c7f",
    "--color-7f9076": "#7f9076",
    "--color-80917b": "#80917b",
    "--color-81917c": "#81917c",
    "--color-819275": "#819275",
    "--color-819c65": "#819c65",
    "--color-836747": "#836747",
    "--color-84968c": "#84968c",
    "--color-86927e": "#86927e",
    "--color-879489": "#879489",
    "--color-899a7a": "#899a7a",
    "--color-8b989e": "#8b989e",
    "--color-8b9a8c": "#8b9a8c",
    "--color-8b9b7c": "#8b9b7c",
    "--color-8c9da0": "#8c9da0",
    "--color-8ca28f": "#8ca28f",
    "--color-8d9b80": "#8d9b80",
    "--color-8e9c95": "#8e9c95",
    "--color-8f9d81": "#8f9d81",
    "--color-909e96": "#909e96",
    "--color-91a08f": "#91a08f",
    "--color-91a9ad": "#91a9ad",
    "--color-96a19b": "#96a19b",
    "--color-98a897": "#98a897",
    "--color-9dad8d": "#9dad8d",
    "--color-9eae99": "#9eae99",
    "--color-a0aa91": "#a0aa91",
    "--color-a18145": "#a18145",
    "--color-a1ad96": "#a1ad96",
    "--color-aa8cbe": "#aa8cbe",
    "--color-ab9f78": "#ab9f78",
    "--color-aca88c": "#aca88c",
    "--color-acb8aa": "#acb8aa",
    "--color-ad9762": "#ad9762",
    "--color-b8965e": "#b8965e",
    "--color-b89b68": "#b89b68",
    "--color-b9b3a7": "#b9b3a7",
    "--color-b9cda1": "#b9cda1",
    "--color-bacbab": "#bacbab",
    "--color-bb9a59": "#bb9a59",
    "--color-bcb18f": "#bcb18f",
    "--color-bda271": "#bda271",
    "--color-bdab84": "#bdab84",
    "--color-bdd0c0": "#bdd0c0",
    "--color-c1d0ba": "#c1d0ba",
    "--color-c2b88f": "#c2b88f",
    "--color-c5a679": "#c5a679",
    "--color-c6bf91": "#c6bf91",
    "--color-c6d0ba": "#c6d0ba",
    "--color-c785a9": "#c785a9",
    "--color-c8d6bc": "#c8d6bc",
    "--color-c8d9a7": "#c8d9a7",
    "--color-c8dc9b": "#c8dc9b",
    "--color-ccd6c6": "#ccd6c6",
    "--color-cd7c66": "#cd7c66",
    "--color-ceb783": "#ceb783",
    "--color-d1b581": "#d1b581",
    "--color-d2dfc6": "#d2dfc6",
    "--color-d39476": "#d39476",
    "--color-d4ac57": "#d4ac57",
    "--color-d4bc8a": "#d4bc8a",
    "--color-d4c4a1": "#d4c4a1",
    "--color-d4dfc8": "#d4dfc8",
    "--color-d5dfcc": "#d5dfcc",
    "--color-d6dccf": "#d6dccf",
    "--color-d8c390": "#d8c390",
    "--color-d9e2d0": "#d9e2d0",
    "--color-dae3d2": "#dae3d2",
    "--color-dbc58d": "#dbc58d",
    "--color-dbe3d2": "#dbe3d2",
    "--color-dce7cc": "#dce7cc",
    "--color-ddcca6": "#ddcca6",
    "--color-dde9cf": "#dde9cf",
    "--color-deca9c": "#deca9c",
    "--color-dfd1a8": "#dfd1a8",
    "--color-dfd6c1": "#dfd6c1",
    "--color-dfe3d7": "#dfe3d7",
    "--color-dfe8d8": "#dfe8d8",
    "--color-e1e1d8": "#e1e1d8",
    "--color-e1e7dc": "#e1e7dc",
    "--color-e2e9dc": "#e2e9dc",
    "--color-e3ebd7": "#e3ebd7",
    "--color-e4e3e1": "#e4e3e1",
    "--color-e5e9d8": "#e5e9d8",
    "--color-e5ebdd": "#e5ebdd",
    "--color-e6dac6": "#e6dac6",
    "--color-e6e8e7": "#e6e8e7",
    "--color-e6eadd": "#e6eadd",
    "--color-e6eddd": "#e6eddd",
    "--color-e7d5ad": "#e7d5ad",
    "--color-e7ecdf": "#e7ecdf",
    "--color-e8cf9e": "#e8cf9e",
    "--color-e9d6b0": "#e9d6b0",
    "--color-e9ede5": "#e9ede5",
    "--color-eaf0e0": "#eaf0e0",
    "--color-ecdfb8": "#ecdfb8",
    "--color-ece9d6": "#ece9d6",
    "--color-efdeb9": "#efdeb9",
    "--color-f0f3e9": "#f0f3e9",
    "--color-f1ead6": "#f1ead6",
    "--color-f3e2bb": "#f3e2bb",
    "--color-f6f7ed": "#f6f7ed",
    "--color-f8faf1": "#f8faf1",
    "--color-f9faf5": "#f9faf5",
    "--color-f9faf6": "#f9faf6",
    "--color-fbfcf5": "#fbfcf5",
    "--color-fbfcf6": "#fbfcf6",
    "--color-fcf5df": "#fcf5df",
    "--color-fff4d5": "#fff4d5",
    "--color-fff4d7": "#fff4d7",
    "--color-fff6dc": "#fff6dc",
    "--color-fff9e5": "#fff9e5",
    "--color-fffdf5": "#fffdf5",
    "--color-fffef4": "#fffef4",
    "--color-fffef7": "#fffef7",
    "--color-fffef8": "#fffef8",
    "--font-display": "'Manrope',Arial,sans-serif",
    "--motion-track": "400ms",
    "--radius-stage": "14px",
    "--admin-success": "#187855",
    "--admin-surface": "#ffffff",
    "--card-cell-gap": "2px",
    "--card-hit-lift": "-9px",
    "--color-primary": "#1c4738",
    "--color-surface": "#f3f4ed",
    "--room-card-gap": "4px",
    "--room-flow-gap": "10px",
    "--room-flow-win": "#42E1B0",
    "--room-menu-gap": "4px",
    "--card-hit-scale": "1.6",
    "--card-rank-lift": "24px",
    "--color-061b17e8": "#061b17e8",
    "--color-061e2030": "#061e2030",
    "--color-071b19a3": "#071b19a3",
    "--color-071c1635": "#071c1635",
    "--color-091a2055": "#091a2055",
    "--color-0c211d1a": "#0c211d1a",
    "--color-0e302bea": "#0e302bea",
    "--color-123529bb": "#123529bb",
    "--color-152b3044": "#152b3044",
    "--color-153c3016": "#153c3016",
    "--color-18372709": "#18372709",
    "--color-2a48230c": "#2a48230c",
    "--color-4f927114": "#4f927114",
    "--color-7f9b8a50": "#7f9b8a50",
    "--color-819c6533": "#819c6533",
    "--color-9d8d6419": "#9d8d6419",
    "--color-9d8d642b": "#9d8d642b",
    "--color-9d8d644f": "#9d8d644f",
    "--color-b4d2b435": "#b4d2b435",
    "--color-bcc5b812": "#bcc5b812",
    "--color-cfba7b04": "#cfba7b04",
    "--color-cfba7b06": "#cfba7b06",
    "--color-cfba7b16": "#cfba7b16",
    "--color-dcd9b322": "#dcd9b322",
    "--color-dee3c317": "#dee3c317",
    "--color-ede7d4b5": "#ede7d4b5",
    "--color-efede2bb": "#efede2bb",
    "--color-f5edcd44": "#f5edcd44",
    "--color-f7f4eeb8": "#f7f4eeb8",
    "--color-f8efd8b5": "#f8efd8b5",
    "--color-faf6e1bb": "#faf6e1bb",
    "--color-fcf8e5d9": "#fcf8e5d9",
    "--color-ffffff0d": "#ffffff0d",
    "--color-ffffff17": "#ffffff17",
    "--room-award-top": "max(76px, env(safe-area-inset-top))",
    "--room-font-main": "1rem",
    "--room-logo-size": "30px",
    "--room-prize-gap": "6px",
    "--admin-nav-width": "240px",
    "--card-cell-inset": "1px",
    "--card-rank-scale": "1.015",
    "--motion-card-hit": "500ms",
    "--room-card-inset": "8px",
    "--room-cta-height": "48px",
    "--room-bottom-cta-tint": "#193257",
    "--room-glass-blur": "10px",
    "--room-glass-edge": "color-mix(in srgb, var(--room-text) 25%, transparent)",
    "--room-menu-inset": "6px",
    "--room-menu-width": "208px",
    "--room-title-size": "18px",
    "--room-topbar-gap": "4px",
    "--card-cell-radius": "2px",
    "--card-marker-size": "1.85em",
    "--card-rank-shadow": "0 8px 24px #0005",
    "--motion-card-rank": "500ms",
    "--notice-info-text": "#FFFFFF",
    "--room-award-inset": "16px",
    "--room-award-width": "360px",
    "--room-card-number": "1.125rem",
    "--room-desktop-gap": "24px",
    "--room-flow-radius": "12px",
    "--room-jackpot-ink": "#39FF88",
    "--room-menu-radius": "10px",
    "--room-menu-shadow": "0 8px 24px #0005",
    "--room-notice-info": "var(--room-muted)",
    "--room-page-gutter": "24px",
    "--room-toolbar-gap": "2px",
    "--card-identity-gap": "4px",
    "--card-label-radius": "7px",
    "--card-label-weight": "800",
    "--card-marker-width": "66",
    "--card-prize-won-bg": "#E2F3E9",
    "--notice-error-text": "#FFFFFF",
    "--room-award-radius": "16px",
    "--room-flow-padding": "14px",
    "--room-font-caption": "0.75rem",
    "--room-glass-shadow": "0 16px 36px #00000045, 0 4px 0 color-mix(in srgb, var(--room-bg) 60%, transparent), inset 0 1px 0 #FFFFFF24, inset 0 -1px 0 #00000038",
    "--room-idle-art-ink": "#A497D8",
    "--room-live-cta-ink": "#16243C",
    "--room-moving-width": "224px",
    "--room-notice-error": "#FF9DAD",
    "--room-overlay-ball": "56px",
    "--room-panel-raised": "#252A4C",
    "--room-prize-margin": "8px",
    "--room-scene-height": "clamp(184px, 52vw, 300px)",
    "--room-sticky-inset": "4px",
    "--room-toolbar-face": "34px",
    "--room-toolbar-icon": "18px",
    "--room-touch-target": "44px",
    "--room-video-height": "176px",
    "--card-label-padding": "4px 8px",
    "--card-prize-won-ink": "#185F45",
    "--notice-info-accent": "#B8C7FF",
    "--room-ball-origin-x": "14%",
    "--room-ball-origin-y": "58%",
    "--room-card-list-gap": "14px",
    "--room-clock-surface": "var(--room-jackpot-surface)",
    "--room-desktop-inset": "12px",
    "--room-glass-surface": "linear-gradient(145deg, color-mix(in srgb, var(--room-text) 14%, transparent), color-mix(in srgb, var(--room-text) 3%, transparent)), color-mix(in srgb, var(--room-panel) 70%, transparent)",
    "--room-idle-art-ball": "#D6B37E",
    "--room-idle-art-glow": "#7965CD22",
    "--room-logo-dot-size": "19px",
    "--room-prize-done-bg": "#11182B",
    "--room-prize-inset-x": "4px",
    "--room-prize-inset-y": "8px",
    "--room-selection-gap": "6px",
    "--room-space-compact": "8px",
    "--room-toolbar-inset": "4px",
    "--room-topbar-height": "48px",
    "--room-video-overlay": "#0D1025E8",
    "--broadcast-lab-error": "#ffacae",
    "--broadcast-lab-muted": "#b9c3e1",
    "--broadcast-lab-width": "1160px",
    "--card-header-on-dark": "#FFFFFF",
    "--card-prize-cell-gap": "4px",
    "--card-prize-done-ink": "#68707C",
    "--notice-error-accent": "#FF9DAD",
    "--notice-info-surface": "#1B1F3D",
    "--notice-success-text": "#FFFFFF",
    "--notice-warning-text": "#FFFFFF",
    "--room-award-side-gap": "32px",
    "--room-ball-face-size": "78%",
    "--room-board-ball-ink": "#243247",
    "--room-card-min-width": "292px",
    "--room-font-secondary": "0.875rem",
    "--room-idle-art-width": "190px",
    "--room-menu-icon-size": "26px",
    "--room-notice-success": "var(--room-live)",
    "--room-notice-warning": "var(--room-accent)",
    "--room-small-ball-gap": "4px",
    "--room-toolbar-radius": "8px",
    "--broadcast-player-ink": "#f3f5ff",
    "--card-label-min-width": "36px",
    "--card-play-footer-gap": "1px",
    "--card-prize-badge-gap": "3px",
    "--notice-error-surface": "#1B1F3D",
    "--room-board-ball-base": "#8290A5",
    "--room-board-ball-face": "#E8EDF4",
    "--room-guide-art-width": "240px",
    "--room-jackpot-surface": "#0D1025B3",
    "--room-menu-background": "#171d35",
    "--room-prize-active-bg": "#303654",
    "--room-prize-done-line": "#2C4049",
    "--room-prize-done-text": "#B0BBCE",
    "--room-tools-panel-gap": "8px",
    "--broadcast-lab-surface": "#171d35",
    "--broadcast-player-line": "#3c4469",
    "--card-header-icon-size": "20px",
    "--card-play-heading-gap": "6px",
    "--card-prize-badge-size": "14px",
    "--motion-confirmed-ball": "850ms",
    "--notice-success-accent": "#48DEB0",
    "--notice-warning-accent": "#FFD36B",
    "--room-ball-history-gap": "8px",
    "--room-board-arrow-size": "14px",
    "--room-card-section-gap": "6px",
    "--room-filter-reset-ink": "#FFFFFF",
    "--room-flow-amount-size": "26px",
    "--room-flow-symbol-size": "34px",
    "--room-hero-number-size": "24px",
    "--room-idle-art-opacity": "0.55",
    "--room-live-cta-surface": "linear-gradient(145deg, #F8F7FFF5, #EEEAF9EB)",
    "--room-moving-chip-lift": "6px",
    "--room-prize-amount-max": "18px",
    "--room-prize-amount-min": "14px",
    "--room-prize-done-label": "#97A4BA",
    "--room-prize-label-size": "12px",
    "--broadcast-player-ratio": "16/9",
    "--broadcast-player-shade": "#080c1be0",
    "--card-label-line-height": "20px",
    "--card-play-progress-gap": "4px",
    "--card-prize-active-tint": "9%",
    "--notice-success-surface": "#1B1F3D",
    "--notice-warning-surface": "#1B1F3D",
    "--room-action-surface-bg": "color-mix(in srgb, var(--room-panel-raised) 65%, var(--room-panel))",
    "--room-award-amount-size": "28px",
    "--room-ball-sequence-gap": "6px",
    "--room-clock-number-size": "clamp(24px, 6.5vw, 28px)",
    "--room-guide-art-opacity": "0.3",
    "--room-guide-blink-count": "2",
    "--room-jackpot-count-ink": "#F6FF00",
    "--room-jackpot-label-ink": "#FFFFFF",
    "--room-jackpot-shine-ink": "#E3FFF3",
    "--room-jp-counter-height": "16px",
    "--room-moving-chip-inset": "3px",
    "--room-moving-count-size": "18px",
    "--room-next-action-width": "340px",
    "--room-prize-active-line": "#FFFFFF80",
    "--room-prize-active-text": "#FFFFFF",
    "--room-prize-content-gap": "4px",
    "--room-prize-detail-size": "24px",
    "--room-small-number-size": "14px",
    "--room-title-mobile-size": "14px",
    "--room-tools-panel-inset": "6px",
    "--broadcast-player-button": "#6550ed",
    "--broadcast-player-radius": "14px",
    "--card-header-action-size": "30px",
    "--card-header-icon-stroke": "2.2",
    "--card-play-value-padding": "4px",
    "--card-prize-divider-tint": "12%",
    "--card-prize-upcoming-ink": "#56616E",
    "--room-award-observer-ink": "var(--notice-info-text)",
    "--room-ball-number-weight": "700",
    "--room-card-status-height": "28px",
    "--room-desktop-play-width": "640px",
    "--room-filter-color-width": "32px",
    "--room-filter-input-width": "64px",
    "--room-jackpot-amount-max": "26px",
    "--room-jackpot-amount-min": "20px",
    "--room-jackpot-count-size": "18px",
    "--room-moving-chip-height": "24px",
    "--room-moving-chip-radius": "5px",
    "--room-overlay-small-ball": "28px",
    "--room-page-mobile-gutter": "12px",
    "--room-prize-active-inset": "0px",
    "--room-sound-hint-opacity": "0.65",
    "--room-sound-switch-width": "30px",
    "--room-tools-panel-border": "var(--room-line)",
    "--room-tools-panel-radius": "12px",
    "--card-play-footer-padding": "2px 4px",
    "--card-play-identity-width": "110px",
    "--card-purchase-action-gap": "6px",
    "--card-purchase-label-size": "0.875rem",
    "--room-action-surface-edge": "color-mix(in srgb, var(--room-text) 14%, transparent)",
    "--room-ball-number-padding": "2px",
    "--room-card-heading-height": "32px",
    "--room-desktop-stage-width": "720px",
    "--room-filter-reset-border": "#8F83D8",
    "--room-guide-emphasis-size": "16px",
    "--room-jackpot-count-right": "4px",
    "--room-jackpot-count-width": "30px",
    "--room-prize-done-badge-bg": "#193E3C",
    "--room-section-heading-gap": "4px",
    "--room-sound-switch-height": "18px",
    "--room-toolbar-label-width": "35px",
    "--room-tools-panel-row-gap": "6px",
    "--card-play-progress-height": "3px",
    "--room-guide-blink-duration": "650ms",
    "--room-jackpot-count-border": "1px solid color-mix(in srgb, var(--room-jackpot-ink) 20%, var(--room-line))",
    "--room-menu-surface-opacity": "100%",
    "--room-prize-done-badge-ink": "#8CE0C1",
    "--room-purchase-heading-gap": "8px",
    "--room-section-heading-size": "0.8125rem",
    "--room-selection-total-size": "24px",
    "--room-action-surface-shadow": "#00000024",
    "--room-award-own-amount-size": "36px",
    "--room-guide-multiplier-size": "36px",
    "--room-prize-done-badge-size": "16px",
    "--broadcast-player-background": "#080c1b",
    "--card-purchase-label-padding": "4px 8px",
    "--room-award-observer-padding": "42px 28px 28px",
    "--room-award-observer-surface": "linear-gradient(145deg,color-mix(in srgb,var(--room-action) 78%,var(--room-panel)),color-mix(in srgb,var(--room-action) 28%,var(--room-bg)))",
    "--room-broadcast-aspect-ratio": "16 / 9",
    "--room-desktop-play-min-width": "320px",
    "--room-draw-reference-opacity": "0.72",
    "--room-jackpot-shine-duration": "900ms",
    "--room-purchase-count-opacity": "0.9",
    "--room-selection-heading-size": "17px",
    "--room-tool-active-background": "color-mix(in srgb, var(--room-action) 38%, var(--room-panel))",
    "--room-tools-panel-background": "var(--room-panel-raised)",
    "--card-play-progress-font-size": "0.75rem",
    "--card-prize-active-mark-width": "18px",
    "--room-filter-reset-background": "#443A70",
    "--room-guide-secondary-opacity": "0.72",
    "--room-jackpot-count-font-size": "12px",
    "--room-live-cta-button-surface": "var(--room-action)",
    "--room-sticky-scene-max-height": "36svh",
    "--card-prize-active-mark-height": "2px",
    "--room-jackpot-count-background": "var(--room-jackpot-surface)",
    "--room-jackpot-disabled-opacity": "0.6",
    "--room-toolbar-bottom-clearance": "34px",
    "--room-award-observer-stage-size": "clamp(30px, 8.4vw, 40px)",
    "--room-flow-other-winner-opacity": "0.6",
    "--room-desktop-short-scene-height": "48svh",
    "--room-selection-quote-label-size": "10px",
    "--room-section-heading-line-height": "1.125rem",
    "--room-selection-quote-amount-size": "12px",
    "--room-filter-reset-disabled-opacity": "0.45",
    "--room-award-winner-surface": "linear-gradient(145deg,color-mix(in srgb,var(--room-action) 86%,var(--room-panel)),color-mix(in srgb,var(--room-action) 30%,var(--room-bg)))",
    "--room-broadcast-draw-number-size": "10px"
  },
  "controls": {
    "cardsPerPage": 6,
    "amountOptions": [
      10,
      25,
      50,
      100,
      250
    ],
    "defaultAmount": 50,
    "movingCardGap": 4,
    "movingCardWidth": 44,
    "recentBallCount": 10,
    "cardMarkerEffect": "ink",
    "movingCardsLimit": 10,
    "roomCardsPerPage": 12,
    "adminTablePageSize": 24,
    "movingCardsPerPage": 8,
    "prizeDisplayLocale": "tr-TR",
    "broadcastDefaultOpen": true,
    "tombalaAmountOptions": [
      5,
      10,
      20,
      50,
      100,
      200,
      500
    ],
    "awardWinnerDurationMs": 6000,
    "movingCardsIntervalMs": 5000,
    "personalCardNameLimit": 12,
    "spectatorCardsVisible": 10,
    "broadcastPreviousBalls": 3,
    "liveMusicVolumePercent": 4,
    "awardObserverDurationMs": 4500,
    "resultRefreshMilliseconds": 3000,
    "waitingMusicVolumePercent": 12,
    "quickSelectionDefaultCount": 10,
    "prizeGuideIntervalMilliseconds": 5000,
    "noticeSuccessDurationMilliseconds": 5000,
    "purchaseReceiptRefreshMilliseconds": 5000,
    "guideBallIntervalMilliseconds": 900,
    "tombalaAmountPresentation": "badges",
    "quickSelectionCountPresentation": "badges",
    "quickSelectionCountOptions": [
      1,
      3,
      5,
      10,
      20,
      50,
      100
    ],
    "tombalaDefaultAmount": 20,
    "demoSalesEnabled": false,
    "demoSalesTarget": 5000,
    "demoSalesIntervalMilliseconds": 5000
  },
  "ballPalette": {
    "red": {
      "on": "#FFFFFF",
      "ink": "#923837",
      "base": "#C95151",
      "soft": "#F9E7E5"
    },
    "blue": {
      "on": "#FFFFFF",
      "ink": "#295782",
      "base": "#427EBB",
      "soft": "#E6EFFA"
    },
    "pink": {
      "on": "#341625",
      "ink": "#923965",
      "base": "#D878A4",
      "soft": "#FAE9F1"
    },
    "black": {
      "on": "#FFFFFF",
      "ink": "#353D47",
      "base": "#353D47",
      "soft": "#E9ECF0"
    },
    "green": {
      "on": "#FFFFFF",
      "ink": "#236447",
      "base": "#348D6B",
      "soft": "#E3F2EA"
    },
    "yellow": {
      "on": "#342605",
      "ink": "#634A0B",
      "base": "#E9B83D",
      "soft": "#FBF1CF"
    }
  },
  "schemaVersion": 4,
  "cardAppearance": {
    "groups": {
      "orange": {
        "ink": "#532600",
        "soft": "#FFF0DC",
        "label": "Turuncu",
        "accent": "#FF982E",
        "emphasis": "#B75B08"
      },
      "blue": {
        "ink": "#003853",
        "soft": "#DDF5FF",
        "label": "Mavi",
        "accent": "#36BFFF",
        "emphasis": "#087EAF"
      },
      "green": {
        "ink": "#003E2D",
        "soft": "#DEFFF2",
        "label": "Yeşil",
        "accent": "#18D598",
        "emphasis": "#05845D"
      },
      "purple": {
        "ink": "#36165D",
        "soft": "#EEE3FF",
        "label": "Mor",
        "accent": "#AF75FF",
        "emphasis": "#9154D2"
      },
      "red": {
        "ink": "#571421",
        "soft": "#FFE4E9",
        "label": "Kırmızı",
        "accent": "#FF536A",
        "emphasis": "#D03950"
      },
      "silver": {
        "ink": "#202D43",
        "soft": "#EDF2F8",
        "label": "Gümüş",
        "accent": "#B9C6D8",
        "emphasis": "#526680"
      }
    },
    "numbers": {
      "ink": "#17213B",
      "grid": "#D3DBE9",
      "markedInk": "#FFFFFF",
      "background": "#FFFFFF",
      "emptyBackground": "#EAEFF6",
      "markedBackground": "#41454B"
    },
    "assignments": {
      "card-001": "orange",
      "card-002": "orange",
      "card-003": "orange",
      "card-004": "orange",
      "card-005": "orange",
      "card-006": "orange",
      "card-007": "orange",
      "card-008": "orange",
      "card-009": "orange",
      "card-010": "orange",
      "card-011": "orange",
      "card-012": "orange",
      "card-013": "orange",
      "card-014": "orange",
      "card-015": "orange",
      "card-016": "orange",
      "card-017": "orange",
      "card-018": "orange",
      "card-019": "orange",
      "card-020": "orange",
      "card-021": "blue",
      "card-022": "blue",
      "card-023": "blue",
      "card-024": "blue",
      "card-025": "blue",
      "card-026": "blue",
      "card-027": "blue",
      "card-028": "blue",
      "card-029": "blue",
      "card-030": "blue",
      "card-031": "blue",
      "card-032": "blue",
      "card-033": "blue",
      "card-034": "blue",
      "card-035": "blue",
      "card-036": "blue",
      "card-037": "blue",
      "card-038": "blue",
      "card-039": "blue",
      "card-040": "blue",
      "card-041": "green",
      "card-042": "green",
      "card-043": "green",
      "card-044": "green",
      "card-045": "green",
      "card-046": "green",
      "card-047": "green",
      "card-048": "green",
      "card-049": "green",
      "card-050": "green",
      "card-051": "green",
      "card-052": "green",
      "card-053": "green",
      "card-054": "green",
      "card-055": "green",
      "card-056": "green",
      "card-057": "green",
      "card-058": "green",
      "card-059": "green",
      "card-060": "green",
      "card-061": "purple",
      "card-062": "purple",
      "card-063": "purple",
      "card-064": "purple",
      "card-065": "purple",
      "card-066": "purple",
      "card-067": "purple",
      "card-068": "purple",
      "card-069": "purple",
      "card-070": "purple",
      "card-071": "purple",
      "card-072": "purple",
      "card-073": "purple",
      "card-074": "purple",
      "card-075": "purple",
      "card-076": "purple",
      "card-077": "purple",
      "card-078": "purple",
      "card-079": "purple",
      "card-080": "purple",
      "card-081": "red",
      "card-082": "red",
      "card-083": "red",
      "card-084": "red",
      "card-085": "red",
      "card-086": "red",
      "card-087": "red",
      "card-088": "red",
      "card-089": "red",
      "card-090": "red",
      "card-091": "red",
      "card-092": "red",
      "card-093": "red",
      "card-094": "red",
      "card-095": "red",
      "card-096": "red",
      "card-097": "red",
      "card-098": "red",
      "card-099": "red",
      "card-100": "red",
      "card-101": "silver",
      "card-102": "silver",
      "card-103": "silver",
      "card-104": "silver",
      "card-105": "silver",
      "card-106": "silver",
      "card-107": "silver",
      "card-108": "silver",
      "card-109": "silver",
      "card-110": "silver",
      "card-111": "silver",
      "card-112": "silver",
      "card-113": "silver",
      "card-114": "silver",
      "card-115": "silver",
      "card-116": "silver",
      "card-117": "silver",
      "card-118": "silver",
      "card-119": "silver",
      "card-120": "silver"
    }
  },
  "noticePresentation": {
    "auto.empty": {
      "layout": "context",
      "enabled": true,
      "dismissible": false,
      "durationMilliseconds": 0
    },
    "auto.range": {
      "layout": "context",
      "enabled": true,
      "dismissible": false,
      "durationMilliseconds": 0
    },
    "room.closed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "play.noOwned": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "results.empty": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "results.error": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "auto.available": {
      "layout": "context",
      "enabled": true,
      "dismissible": false,
      "durationMilliseconds": 0
    },
    "favorite.error": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "room.completed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "cards.noMatches": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "auto.unavailable": {
      "layout": "context",
      "enabled": true,
      "dismissible": false,
      "durationMilliseconds": 0
    },
    "flow.quickClosed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.waitingNext": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.partial": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.pending": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "room.amountRange": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "x.paymentPending": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "cards.noFavorites": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.startingHelp": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.watchingHelp": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.accepted": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "connection.waiting": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.uncertain": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "room.resultPending": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "x.paymentConfirmed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.card_limit": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.notStarted": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.processing": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.wrong_draw": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.purchaseDrawWon": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.selectionClosed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.amount_step": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.notAccepted": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "selection.amountStep": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.amount_limit": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.sales_closed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.unknown_card": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.cancelledObserver": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.previousCancelled": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.selectionRestored": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "auto.preferencesPending": {
      "layout": "context",
      "enabled": true,
      "dismissible": false,
      "durationMilliseconds": 0
    },
    "purchase.unknown_market": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.request_conflict": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.invalid_selection": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.selectionCatalogChanged": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "flow.selectionPartlyRestored": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.insufficient_balance": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "purchase.receiptDetailsUnavailable": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "favorite.added": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    },
    "favorite.removed": {
      "layout": "context",
      "enabled": true,
      "dismissible": true,
      "durationMilliseconds": 5000
    }
  }
}
